/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.9.0 (NJsonSchema v10.6.8.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AuthorizationGroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMapsToken(timeZone: string): Observable<string> {
        let url_ = this.baseUrl + "/api/AuthorizationGroups/MapsAuth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMapsToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMapsToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetMapsToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class AzureB2CTemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAzureB2CTemplate(id: number, timeZone: string): Observable<string> {
        let url_ = this.baseUrl + "/api/AzureB2CTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAzureB2CTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAzureB2CTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAzureB2CTemplate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class BatchesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getBatchDetail(uniqueId: string, timeZone: string): Observable<BatchViewModel> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchViewModel>;
        }));
    }

    protected processGetBatchDetail(response: HttpResponseBase): Observable<BatchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchViewModel>(null as any);
    }

    /**
     * @return Success
     */
    deleteBatch(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getBatchStatusOverview(timeZone: string): Observable<BatchStatusOverviewViewModel> {
        let url_ = this.baseUrl + "/api/Batches/StatusOverview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchStatusOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchStatusOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchStatusOverviewViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchStatusOverviewViewModel>;
        }));
    }

    protected processGetBatchStatusOverview(response: HttpResponseBase): Observable<BatchStatusOverviewViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchStatusOverviewViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchStatusOverviewViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getBatchHistoryStatus(uniqueId: string, timeZone: string): Observable<BatchHistoryViewModel[]> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/History";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchHistoryStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchHistoryStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchHistoryViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchHistoryViewModel[]>;
        }));
    }

    protected processGetBatchHistoryStatus(response: HttpResponseBase): Observable<BatchHistoryViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchHistoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchHistoryViewModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBatch(timeZone: string, body: CreateBatchCommand | undefined): Observable<BatchViewModel> {
        let url_ = this.baseUrl + "/api/Batches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchViewModel>;
        }));
    }

    protected processCreateBatch(response: HttpResponseBase): Observable<BatchViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = BatchViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editBatch(timeZone: string, body: EditBatchCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    batchSearch(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<BatchSearchViewModelBatchTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Batches/Search?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchSearchViewModelBatchTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchSearchViewModelBatchTotalTypePagedResultResponse>;
        }));
    }

    protected processBatchSearch(response: HttpResponseBase): Observable<BatchSearchViewModelBatchTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchSearchViewModelBatchTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchSearchViewModelBatchTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignBatchReviewer(uniqueId: string, timeZone: string, body: BatchAssignReviewerCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/Reviewer";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignBatchReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignBatchReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignBatchReviewer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    unassignBatchReviewer(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/Reviewer";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignBatchReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignBatchReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignBatchReviewer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getBatchAttachmentDetail(uniqueId: string, timeZone: string): Observable<BatchAttachmentViewModel[]> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/Attachment";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchAttachmentDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchAttachmentDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchAttachmentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchAttachmentViewModel[]>;
        }));
    }

    protected processGetBatchAttachmentDetail(response: HttpResponseBase): Observable<BatchAttachmentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchAttachmentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchAttachmentViewModel[]>(null as any);
    }

    /**
     * @param batchUniqueId (optional) 
     * @param links (optional) 
     * @param files (optional) 
     * @return Success
     */
    uploadAttachment(timeZone: string, batchUniqueId: string | undefined, links: string[] | undefined, files: FileParameter[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Batches/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (batchUniqueId === null || batchUniqueId === undefined)
            throw new Error("The parameter 'batchUniqueId' cannot be null.");
        else
            content_.append("BatchUniqueId", batchUniqueId.toString());
        if (links === null || links === undefined)
            throw new Error("The parameter 'links' cannot be null.");
        else
            links.forEach(item_ => content_.append("Links", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadAttachment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param cleanFillUserUniqueId (optional) 
     * @param batchUniqueId (optional) 
     * @return Success
     */
    createFavoriteBatch(timeZone: string, cleanFillUserUniqueId: string | undefined, batchUniqueId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Batches/Favorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (cleanFillUserUniqueId === null || cleanFillUserUniqueId === undefined)
            throw new Error("The parameter 'cleanFillUserUniqueId' cannot be null.");
        else
            content_.append("CleanFillUserUniqueId", cleanFillUserUniqueId.toString());
        if (batchUniqueId === null || batchUniqueId === undefined)
            throw new Error("The parameter 'batchUniqueId' cannot be null.");
        else
            content_.append("BatchUniqueId", batchUniqueId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFavoriteBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFavoriteBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateFavoriteBatch(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    deleteAttachment(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/Attachment/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    downloadBatchAttachment(uniqueId: string, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Batches/Attachment/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBatchAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBatchAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBatchAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteFavoriteBatch(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/Favorite/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFavoriteBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFavoriteBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFavoriteBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchFSUApproval(uniqueId: string, timeZone: string, body: BatchFSUApprovalCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/FillSiteUserApproval";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchFSUApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchFSUApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchFSUApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchFSQPApproval(uniqueId: string, timeZone: string, body: BatchFSQPApprovalCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/FillSiteQPApproval";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchFSQPApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchFSQPApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchFSQPApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forwardToTPQP(uniqueId: string, timeZone: string, body: BatchFSQPForwardToTPQPCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/TPQP";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForwardToTPQP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForwardToTPQP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForwardToTPQP(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    batchFSTPQPApproval(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/FillSiteTPQPApproval";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchFSTPQPApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchFSTPQPApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchFSTPQPApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchFillSiteUserRejection(uniqueId: string, timeZone: string, body: BatchFSURejectionCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/FillSiteUserRejection";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchFillSiteUserRejection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchFillSiteUserRejection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchFillSiteUserRejection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchFSQPRejection(uniqueId: string, timeZone: string, body: BatchFSQPRejectionCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/FillSiteQPRejection";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchFSQPRejection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchFSQPRejection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchFSQPRejection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    batchFSTPQPRejection(uniqueId: string, timeZone: string, body: BatchFSTPQPRejectionCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/FillSiteTPQPRejection";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchFSTPQPRejection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchFSTPQPRejection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatchFSTPQPRejection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    releaseBatchESVR(uniqueId: string, timeZone: string, body: BatchReleaseESVRCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/IsESVRReleased";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseBatchESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseBatchESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseBatchESVR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyESVRsReleased(uniqueId: string, timeZone: string, body: NotifyESVRsReleasedCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/NotifyESVRsReleased";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyESVRsReleased(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyESVRsReleased(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyESVRsReleased(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAdditionalESVRs(uniqueId: string, timeZone: string, body: BatchAddAdditionalESVRsCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/AdditionalESVRs";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAdditionalESVRs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAdditionalESVRs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAdditionalESVRs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBatchStatus(uniqueId: string, timeZone: string, body: UpdateBatchStatusCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/Status";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBatchStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBatchStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBatchStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getBatchReconciliation(uniqueId: string, timeZone: string): Observable<BatchReconciliationViewModel> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/ESVR/Reconciliation";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchReconciliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchReconciliation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchReconciliationViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchReconciliationViewModel>;
        }));
    }

    protected processGetBatchReconciliation(response: HttpResponseBase): Observable<BatchReconciliationViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchReconciliationViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchReconciliationViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getBatchExtrasByBatchId(uniqueId: string, timeZone: string): Observable<BatchExtraViewModel[]> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/BatchExtras";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchExtrasByBatchId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchExtrasByBatchId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchExtraViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchExtraViewModel[]>;
        }));
    }

    protected processGetBatchExtrasByBatchId(response: HttpResponseBase): Observable<BatchExtraViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchExtraViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchExtraViewModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getBatchExtraDetail(uniqueId: string, timeZone: string): Observable<BatchExtraViewModel> {
        let url_ = this.baseUrl + "/api/Batches/Extra/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchExtraDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchExtraDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchExtraViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchExtraViewModel>;
        }));
    }

    protected processGetBatchExtraDetail(response: HttpResponseBase): Observable<BatchExtraViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BatchExtraViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchExtraViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editBatchExtra(uniqueId: string, timeZone: string, body: EditBatchExtraCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/Extra/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditBatchExtra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditBatchExtra(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditBatchExtra(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBatchExtra(uniqueId: string, timeZone: string, body: CreateBatchExtraCommand | undefined): Observable<BatchExtraViewModel> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/Extra";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatchExtra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatchExtra(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchExtraViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchExtraViewModel>;
        }));
    }

    protected processCreateBatchExtra(response: HttpResponseBase): Observable<BatchExtraViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = BatchExtraViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchExtraViewModel>(null as any);
    }

    generateTrucksBillingPDF(timeZone: string, body: ESVRsReqDownloadQuery | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Batches/GenerateTrucksBillingPDF";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateTrucksBillingPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTrucksBillingPDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateTrucksBillingPDF(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadESVRs(timeZone: string, body: ESVRsDownloadQuery | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Batches/DownloadESVRs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadESVRs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadESVRs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadESVRs(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    eSVRReport(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Batches/ESVRs/Report?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processESVRReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processESVRReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processESVRReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    batchLoadsReport(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Batches/ESVRs/BatchLoadsReport?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatchLoadsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatchLoadsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processBatchLoadsReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reassignSourceSiteUser(uniqueId: string, timeZone: string, body: BatchReassignSourceSiteUserCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/SourceSiteUser";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassignSourceSiteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassignSourceSiteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReassignSourceSiteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reassignFillSiteUser(uniqueId: string, timeZone: string, body: BatchReassignFillSiteUserCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/FillSiteUser";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassignFillSiteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassignFillSiteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReassignFillSiteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reassignSourceSiteQP(uniqueId: string, timeZone: string, body: BatchReassignSourceSiteQPCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/SourceSiteQP";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassignSourceSiteQP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassignSourceSiteQP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReassignSourceSiteQP(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reassignFillSiteQP(uniqueId: string, timeZone: string, body: BatchReassignFillSiteQPCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Batches/{uniqueId}/FillSiteQP";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassignFillSiteQP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassignFillSiteQP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReassignFillSiteQP(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CompaniesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deleteCompany(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Companies/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getCompanyDetail(uniqueId: string, timeZone: string): Observable<CompanyViewModel> {
        let url_ = this.baseUrl + "/api/Companies/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyViewModel>;
        }));
    }

    protected processGetCompanyDetail(response: HttpResponseBase): Observable<CompanyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCompany(uniqueId: string, timeZone: string, body: EditCompanyCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Companies/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchCompany(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<CompanySearchViewModel[]> {
        let url_ = this.baseUrl + "/api/Companies/Search?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanySearchViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanySearchViewModel[]>;
        }));
    }

    protected processSearchCompany(response: HttpResponseBase): Observable<CompanySearchViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanySearchViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanySearchViewModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchSourceSite(uniqueId: string, timeZone: string, body: SourceSiteSearchQuery | undefined): Observable<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Companies/{uniqueId}/SourceSites/Search";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchSourceSite(response: HttpResponseBase): Observable<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SourceSiteSearchViewModelSiteTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchFillSite(uniqueId: string, timeZone: string, body: FillSiteSearchQuery | undefined): Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Companies/{uniqueId}/FillSites/Search";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchFillSite(response: HttpResponseBase): Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FillSiteSearchViewModelSiteTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteSearchViewModelSiteTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCompany(timeZone: string, body: CreateCompanyCommand | undefined): Observable<CompanyViewModel> {
        let url_ = this.baseUrl + "/api/Companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyViewModel>;
        }));
    }

    protected processCreateCompany(response: HttpResponseBase): Observable<CompanyViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CompanyViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyViewModel>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchCompanyQPs(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Companies/{uniqueId}/QualifiedPersons/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCompanyQPs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCompanyQPs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchCompanyQPs(response: HttpResponseBase): Observable<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyQPViewModelCompanyQPTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param companyUniqueId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    haulerSearch(uniqueId: string, companyUniqueId: string | undefined, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<HaulerSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Companies/{uniqueId}/Haulers/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (companyUniqueId === null)
            throw new Error("The parameter 'companyUniqueId' cannot be null.");
        else if (companyUniqueId !== undefined)
            url_ += "CompanyUniqueId=" + encodeURIComponent("" + companyUniqueId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHaulerSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHaulerSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HaulerSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HaulerSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processHaulerSearch(response: HttpResponseBase): Observable<HaulerSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaulerSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HaulerSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param companyUniqueId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    truckSearch(uniqueId: string, companyUniqueId: string | undefined, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<TruckSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Companies/{uniqueId}/Trucks/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (companyUniqueId === null)
            throw new Error("The parameter 'companyUniqueId' cannot be null.");
        else if (companyUniqueId !== undefined)
            url_ += "CompanyUniqueId=" + encodeURIComponent("" + companyUniqueId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTruckSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTruckSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processTruckSearch(response: HttpResponseBase): Observable<TruckSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TruckSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TruckSearchViewModelTotalTypePagedResultResponse>(null as any);
    }
}

@Injectable()
export class CompanyQualifiedPersonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignQPToCompany(timeZone: string, body: AssignQPToCompanyCommand | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/CompanyQualifiedPersons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignQPToCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignQPToCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAssignQPToCompany(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    unassignQPFromCompany(uniqueid: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/CompanyQualifiedPersons/{uniqueid}";
        if (uniqueid === undefined || uniqueid === null)
            throw new Error("The parameter 'uniqueid' must be defined.");
        url_ = url_.replace("{uniqueid}", encodeURIComponent("" + uniqueid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignQPFromCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignQPFromCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignQPFromCompany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param sourceSiteUniqueIds (optional) 
     * @param receivingSiteUniqueIds (optional) 
     * @param statuses (optional) 
     * @return Success
     */
    getBatches(sourceSiteUniqueIds: string[] | undefined, receivingSiteUniqueIds: string[] | undefined, statuses: BatchTotalType[] | undefined, timeZone: string): Observable<BatchDashboardViewModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/Batches?";
        if (sourceSiteUniqueIds === null)
            throw new Error("The parameter 'sourceSiteUniqueIds' cannot be null.");
        else if (sourceSiteUniqueIds !== undefined)
            sourceSiteUniqueIds && sourceSiteUniqueIds.forEach(item => { url_ += "SourceSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        if (receivingSiteUniqueIds === null)
            throw new Error("The parameter 'receivingSiteUniqueIds' cannot be null.");
        else if (receivingSiteUniqueIds !== undefined)
            receivingSiteUniqueIds && receivingSiteUniqueIds.forEach(item => { url_ += "ReceivingSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchDashboardViewModel[]>;
        }));
    }

    protected processGetBatches(response: HttpResponseBase): Observable<BatchDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchDashboardViewModel[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sourceSiteUniqueIds (optional) 
     * @param receivingSiteUniqueIds (optional) 
     * @param batchUniqueIds (optional) 
     * @param statuses (optional) 
     * @return Success
     */
    getBatchStatusCount(startDate: Date | undefined, endDate: Date | undefined, sourceSiteUniqueIds: string[] | undefined, receivingSiteUniqueIds: string[] | undefined, batchUniqueIds: string[] | undefined, statuses: BatchTotalType[] | undefined, timeZone: string): Observable<BatchStatusCountViewModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/BatchStatusCount?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (sourceSiteUniqueIds === null)
            throw new Error("The parameter 'sourceSiteUniqueIds' cannot be null.");
        else if (sourceSiteUniqueIds !== undefined)
            sourceSiteUniqueIds && sourceSiteUniqueIds.forEach(item => { url_ += "SourceSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        if (receivingSiteUniqueIds === null)
            throw new Error("The parameter 'receivingSiteUniqueIds' cannot be null.");
        else if (receivingSiteUniqueIds !== undefined)
            receivingSiteUniqueIds && receivingSiteUniqueIds.forEach(item => { url_ += "ReceivingSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        if (batchUniqueIds === null)
            throw new Error("The parameter 'batchUniqueIds' cannot be null.");
        else if (batchUniqueIds !== undefined)
            batchUniqueIds && batchUniqueIds.forEach(item => { url_ += "BatchUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBatchStatusCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBatchStatusCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchStatusCountViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchStatusCountViewModel[]>;
        }));
    }

    protected processGetBatchStatusCount(response: HttpResponseBase): Observable<BatchStatusCountViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchStatusCountViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchStatusCountViewModel[]>(null as any);
    }

    /**
     * @param receivingSiteUniqueIds (optional) 
     * @return Success
     */
    getSourceSites(receivingSiteUniqueIds: string[] | undefined, timeZone: string): Observable<SourceSiteDashboardViewModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/SourceSites?";
        if (receivingSiteUniqueIds === null)
            throw new Error("The parameter 'receivingSiteUniqueIds' cannot be null.");
        else if (receivingSiteUniqueIds !== undefined)
            receivingSiteUniqueIds && receivingSiteUniqueIds.forEach(item => { url_ += "ReceivingSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteDashboardViewModel[]>;
        }));
    }

    protected processGetSourceSites(response: HttpResponseBase): Observable<SourceSiteDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceSiteDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteDashboardViewModel[]>(null as any);
    }

    /**
     * @param sourceSiteUniqueIds (optional) 
     * @return Success
     */
    getFillSites(sourceSiteUniqueIds: string[] | undefined, timeZone: string): Observable<FillSiteDashboardViewModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/FillSites?";
        if (sourceSiteUniqueIds === null)
            throw new Error("The parameter 'sourceSiteUniqueIds' cannot be null.");
        else if (sourceSiteUniqueIds !== undefined)
            sourceSiteUniqueIds && sourceSiteUniqueIds.forEach(item => { url_ += "SourceSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFillSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFillSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteDashboardViewModel[]>;
        }));
    }

    protected processGetFillSites(response: HttpResponseBase): Observable<FillSiteDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FillSiteDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteDashboardViewModel[]>(null as any);
    }

    /**
     * @param sourceSiteUniqueIds (optional) 
     * @param receivingSiteUniqueIds (optional) 
     * @return Success
     */
    getQualifiedPersons(sourceSiteUniqueIds: string[] | undefined, receivingSiteUniqueIds: string[] | undefined, timeZone: string): Observable<QualifiedPersonDashboardViewModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/QualifiedPersons?";
        if (sourceSiteUniqueIds === null)
            throw new Error("The parameter 'sourceSiteUniqueIds' cannot be null.");
        else if (sourceSiteUniqueIds !== undefined)
            sourceSiteUniqueIds && sourceSiteUniqueIds.forEach(item => { url_ += "SourceSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        if (receivingSiteUniqueIds === null)
            throw new Error("The parameter 'receivingSiteUniqueIds' cannot be null.");
        else if (receivingSiteUniqueIds !== undefined)
            receivingSiteUniqueIds && receivingSiteUniqueIds.forEach(item => { url_ += "ReceivingSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualifiedPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualifiedPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualifiedPersonDashboardViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualifiedPersonDashboardViewModel[]>;
        }));
    }

    protected processGetQualifiedPersons(response: HttpResponseBase): Observable<QualifiedPersonDashboardViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualifiedPersonDashboardViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualifiedPersonDashboardViewModel[]>(null as any);
    }

    getLoadCountsSummary(sourceSites: string[] | undefined, receivingSites: string[] | undefined, batches: string[] | undefined, startDate: Date | undefined, endDate: Date | undefined, dailyReport: boolean | undefined, sendEmail: boolean | undefined, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Dashboard/LoadCountsSummary?";
        if (sourceSites === null)
            throw new Error("The parameter 'sourceSites' cannot be null.");
        else if (sourceSites !== undefined)
            sourceSites && sourceSites.forEach(item => { url_ += "SourceSites=" + encodeURIComponent("" + item) + "&"; });
        if (receivingSites === null)
            throw new Error("The parameter 'receivingSites' cannot be null.");
        else if (receivingSites !== undefined)
            receivingSites && receivingSites.forEach(item => { url_ += "ReceivingSites=" + encodeURIComponent("" + item) + "&"; });
        if (batches === null)
            throw new Error("The parameter 'batches' cannot be null.");
        else if (batches !== undefined)
            batches && batches.forEach(item => { url_ += "Batches=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (dailyReport === null)
            throw new Error("The parameter 'dailyReport' cannot be null.");
        else if (dailyReport !== undefined)
            url_ += "DailyReport=" + encodeURIComponent("" + dailyReport) + "&";
        if (sendEmail === null)
            throw new Error("The parameter 'sendEmail' cannot be null.");
        else if (sendEmail !== undefined)
            url_ += "SendEmail=" + encodeURIComponent("" + sendEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoadCountsSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoadCountsSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLoadCountsSummary(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sourceSiteUniqueIds (optional) 
     * @param receivingSiteUniqueIds (optional) 
     * @param batchUniqueIds (optional) 
     * @param statuses (optional) 
     * @return Success
     */
    getESVRs(startDate: Date | undefined, endDate: Date | undefined, sourceSiteUniqueIds: string[] | undefined, receivingSiteUniqueIds: string[] | undefined, batchUniqueIds: string[] | undefined, statuses: BatchTotalType[] | undefined, timeZone: string): Observable<ESVRStatusCountViewModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/ESVRs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (sourceSiteUniqueIds === null)
            throw new Error("The parameter 'sourceSiteUniqueIds' cannot be null.");
        else if (sourceSiteUniqueIds !== undefined)
            sourceSiteUniqueIds && sourceSiteUniqueIds.forEach(item => { url_ += "SourceSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        if (receivingSiteUniqueIds === null)
            throw new Error("The parameter 'receivingSiteUniqueIds' cannot be null.");
        else if (receivingSiteUniqueIds !== undefined)
            receivingSiteUniqueIds && receivingSiteUniqueIds.forEach(item => { url_ += "ReceivingSiteUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        if (batchUniqueIds === null)
            throw new Error("The parameter 'batchUniqueIds' cannot be null.");
        else if (batchUniqueIds !== undefined)
            batchUniqueIds && batchUniqueIds.forEach(item => { url_ += "BatchUniqueIds=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESVRs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESVRs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ESVRStatusCountViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ESVRStatusCountViewModel[]>;
        }));
    }

    protected processGetESVRs(response: HttpResponseBase): Observable<ESVRStatusCountViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ESVRStatusCountViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ESVRStatusCountViewModel[]>(null as any);
    }
}

@Injectable()
export class ESVRsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getESVRDetail(uniqueid: string, timeZone: string): Observable<ESVRViewModel> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueid}";
        if (uniqueid === undefined || uniqueid === null)
            throw new Error("The parameter 'uniqueid' must be defined.");
        url_ = url_.replace("{uniqueid}", encodeURIComponent("" + uniqueid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESVRDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESVRDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ESVRViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ESVRViewModel>;
        }));
    }

    protected processGetESVRDetail(response: HttpResponseBase): Observable<ESVRViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ESVRViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ESVRViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editESVR(uniqueid: string, timeZone: string, body: EditESVRCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueid}";
        if (uniqueid === undefined || uniqueid === null)
            throw new Error("The parameter 'uniqueid' must be defined.");
        url_ = url_.replace("{uniqueid}", encodeURIComponent("" + uniqueid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditESVR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dispatchESVR(uniqueid: string, timeZone: string, body: DispatchESVRInfoUpdate | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueid}";
        if (uniqueid === undefined || uniqueid === null)
            throw new Error("The parameter 'uniqueid' must be defined.");
        url_ = url_.replace("{uniqueid}", encodeURIComponent("" + uniqueid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDispatchESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDispatchESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDispatchESVR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteESVR(uniqueid: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueid}";
        if (uniqueid === undefined || uniqueid === null)
            throw new Error("The parameter 'uniqueid' must be defined.");
        url_ = url_.replace("{uniqueid}", encodeURIComponent("" + uniqueid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteESVR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getESVRDetailBySearch(esvrInfo: string, fillSiteUniqueId: string, timeZone: string): Observable<ESVRViewModel> {
        let url_ = this.baseUrl + "/api/ESVRs/{esvrInfo},{fillSiteUniqueId}/GetESVRDetailBySearch";
        if (esvrInfo === undefined || esvrInfo === null)
            throw new Error("The parameter 'esvrInfo' must be defined.");
        url_ = url_.replace("{esvrInfo}", encodeURIComponent("" + esvrInfo));
        if (fillSiteUniqueId === undefined || fillSiteUniqueId === null)
            throw new Error("The parameter 'fillSiteUniqueId' must be defined.");
        url_ = url_.replace("{fillSiteUniqueId}", encodeURIComponent("" + fillSiteUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESVRDetailBySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESVRDetailBySearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ESVRViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ESVRViewModel>;
        }));
    }

    protected processGetESVRDetailBySearch(response: HttpResponseBase): Observable<ESVRViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ESVRViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ESVRViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    prepareESVRs(timeZone: string, body: PrepareESVRCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/IsPrepared";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareESVRs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareESVRs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrepareESVRs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    eSVRSourceSiteSave(uniqueId: string, timeZone: string, body: ESVRSourceSiteSaveCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueId}/SourceSite/IsPrepared";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processESVRSourceSiteSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processESVRSourceSiteSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processESVRSourceSiteSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    eSVRFillSiteSave(uniqueId: string, timeZone: string, body: ESVRFillSiteSaveCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueId}/FillSite/IsPrepared";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processESVRFillSiteSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processESVRFillSiteSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processESVRFillSiteSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forwardESVRs(timeZone: string, body: ForwardESVRsCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/IsForwarded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForwardESVRs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForwardESVRs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForwardESVRs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    forwardESVR(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueId}/IsForwarded";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForwardESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForwardESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForwardESVR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveESVR(uniqueid: string, timeZone: string, body: ApproveESVRInfoUpdate | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueid}/Approval";
        if (uniqueid === undefined || uniqueid === null)
            throw new Error("The parameter 'uniqueid' must be defined.");
        url_ = url_.replace("{uniqueid}", encodeURIComponent("" + uniqueid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveESVR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectESVR(uniqueid: string, timeZone: string, body: RejectESVRCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueid}/Rejection";
        if (uniqueid === undefined || uniqueid === null)
            throw new Error("The parameter 'uniqueid' must be defined.");
        url_ = url_.replace("{uniqueid}", encodeURIComponent("" + uniqueid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectESVR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disputeESVR(uniqueid: string, timeZone: string, body: DisputeESVRCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueid}/Dispute";
        if (uniqueid === undefined || uniqueid === null)
            throw new Error("The parameter 'uniqueid' must be defined.");
        url_ = url_.replace("{uniqueid}", encodeURIComponent("" + uniqueid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisputeESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisputeESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisputeESVR(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchESVR(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/ESVRs/Search?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchESVR(response: HttpResponseBase): Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ESVRSearchViewModelESVRTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ESVRSearchViewModelESVRTotalTypePagedResultResponse>(null as any);
    }

    downloadESVR(uniqueId: string, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueId}/Download";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadESVR(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadESVRByText(id: number, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ESVRs/{id}/Dwnld";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "application/pdf"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadESVRByText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadESVRByText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadESVRByText(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @param sourceSites (optional) 
     * @param receivingSites (optional) 
     * @param batches (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param dailyReport (optional) 
     * @return Success
     */
    getESVRsForReport(sourceSites: string[] | undefined, receivingSites: string[] | undefined, batches: string[] | undefined, startDate: Date | undefined, endDate: Date | undefined, dailyReport: boolean | undefined, timeZone: string): Observable<ESVRViewModel[]> {
        let url_ = this.baseUrl + "/api/ESVRs/GetESVRsForReport?";
        if (sourceSites === null)
            throw new Error("The parameter 'sourceSites' cannot be null.");
        else if (sourceSites !== undefined)
            sourceSites && sourceSites.forEach(item => { url_ += "SourceSites=" + encodeURIComponent("" + item) + "&"; });
        if (receivingSites === null)
            throw new Error("The parameter 'receivingSites' cannot be null.");
        else if (receivingSites !== undefined)
            receivingSites && receivingSites.forEach(item => { url_ += "ReceivingSites=" + encodeURIComponent("" + item) + "&"; });
        if (batches === null)
            throw new Error("The parameter 'batches' cannot be null.");
        else if (batches !== undefined)
            batches && batches.forEach(item => { url_ += "Batches=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (dailyReport === null)
            throw new Error("The parameter 'dailyReport' cannot be null.");
        else if (dailyReport !== undefined)
            url_ += "DailyReport=" + encodeURIComponent("" + dailyReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESVRsForReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESVRsForReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ESVRViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ESVRViewModel[]>;
        }));
    }

    protected processGetESVRsForReport(response: HttpResponseBase): Observable<ESVRViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ESVRViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ESVRViewModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getESVRByBarcode(uniqueId: string, userUniqueId: string, timeZone: string): Observable<ESVRViewModel> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueId},{userUniqueId}/GetESVRByBarcode";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (userUniqueId === undefined || userUniqueId === null)
            throw new Error("The parameter 'userUniqueId' must be defined.");
        url_ = url_.replace("{userUniqueId}", encodeURIComponent("" + userUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetESVRByBarcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetESVRByBarcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ESVRViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ESVRViewModel>;
        }));
    }

    protected processGetESVRByBarcode(response: HttpResponseBase): Observable<ESVRViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ESVRViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ESVRViewModel>(null as any);
    }

    /**
     * @return Success
     */
    sendESVRLinkByTextOrEmail(uniqueId: string, phoneNumber: string, email: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ESVRs/{uniqueId},{phoneNumber},{email}/SendESVRLinkByTextOrEmail";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendESVRLinkByTextOrEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendESVRLinkByTextOrEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendESVRLinkByTextOrEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FillSiteCleanFillUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignUserToFillSite(timeZone: string, body: AssignUserToFillSiteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSiteCleanFillUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserToFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserToFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignUserToFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    unassignUserFromFillSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSiteCleanFillUsers/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignUserFromFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignUserFromFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignUserFromFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FillSiteQualifiedPersonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignQPToFillSite(timeZone: string, body: AssignQPToFillSiteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSiteQualifiedPersons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignQPToFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignQPToFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignQPToFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    unassignQPFromFillSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSiteQualifiedPersons/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignQPFromFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignQPFromFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignQPFromFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FillSitesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchFillSites(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/FillSites/Search?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFillSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFillSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchFillSites(response: HttpResponseBase): Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FillSiteSearchViewModelSiteTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteSearchViewModelSiteTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFillSiteQualifiedPersons(uniqueId: string, timeZone: string): Observable<QualifiedPersonViewModel[]> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/QualifiedPersons";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFillSiteQualifiedPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFillSiteQualifiedPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualifiedPersonViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualifiedPersonViewModel[]>;
        }));
    }

    protected processGetFillSiteQualifiedPersons(response: HttpResponseBase): Observable<QualifiedPersonViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualifiedPersonViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualifiedPersonViewModel[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    getFillSiteSourceSites(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<FillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/SourceSites/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFillSiteSourceSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFillSiteSourceSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse>;
        }));
    }

    protected processGetFillSiteSourceSites(response: HttpResponseBase): Observable<FillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFillSiteDetails(uniqueId: string, timeZone: string): Observable<FillSiteViewModel> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFillSiteDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFillSiteDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteViewModel>;
        }));
    }

    protected processGetFillSiteDetails(response: HttpResponseBase): Observable<FillSiteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FillSiteViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editFillSite(uniqueId: string, timeZone: string, body: EditFillSiteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteFillSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFillSite(timeZone: string, body: CreateFillSiteCommand | undefined): Observable<FillSiteViewModel> {
        let url_ = this.baseUrl + "/api/FillSites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteViewModel>;
        }));
    }

    protected processCreateFillSite(response: HttpResponseBase): Observable<FillSiteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FillSiteViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteViewModel>(null as any);
    }

    /**
     * @return Success
     */
    archiveFillSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/IsArchived";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    reactivateFillSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/Reactivate";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReactivateFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getFillSiteAttachmentDetail(uniqueId: string, timeZone: string): Observable<FillSiteAttachmentViewModel[]> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/Attachment";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFillSiteAttachmentDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFillSiteAttachmentDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteAttachmentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteAttachmentViewModel[]>;
        }));
    }

    protected processGetFillSiteAttachmentDetail(response: HttpResponseBase): Observable<FillSiteAttachmentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FillSiteAttachmentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteAttachmentViewModel[]>(null as any);
    }

    /**
     * @param fillSiteUniqueId (optional) 
     * @param links (optional) 
     * @param files (optional) 
     * @return Success
     */
    uploadFillSiteAttachment(timeZone: string, fillSiteUniqueId: string | undefined, links: string[] | undefined, files: FileParameter[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/FillSites/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fillSiteUniqueId === null || fillSiteUniqueId === undefined)
            throw new Error("The parameter 'fillSiteUniqueId' cannot be null.");
        else
            content_.append("FillSiteUniqueId", fillSiteUniqueId.toString());
        if (links === null || links === undefined)
            throw new Error("The parameter 'links' cannot be null.");
        else
            links.forEach(item_ => content_.append("Links", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFillSiteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFillSiteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadFillSiteAttachment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    downloadFillSiteAttachment(uniqueId: string, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/FillSites/Attachment/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFillSiteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFillSiteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFillSiteAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteFillSiteAttachment(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSites/Attachment/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFillSiteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFillSiteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFillSiteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fillSiteUniqueId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    getFillSiteAssignedUsers(uniqueId: string, fillSiteUniqueId: string | undefined, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<FillSiteUserSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/AssignedUsers?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (fillSiteUniqueId === null)
            throw new Error("The parameter 'fillSiteUniqueId' cannot be null.");
        else if (fillSiteUniqueId !== undefined)
            url_ += "FillSiteUniqueId=" + encodeURIComponent("" + fillSiteUniqueId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFillSiteAssignedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFillSiteAssignedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteUserSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteUserSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processGetFillSiteAssignedUsers(response: HttpResponseBase): Observable<FillSiteUserSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FillSiteUserSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteUserSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param fillSiteUniqueId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    getFillSiteAssignedQPs(uniqueId: string, fillSiteUniqueId: string | undefined, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<FillSiteQPSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/AssignedQPs?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (fillSiteUniqueId === null)
            throw new Error("The parameter 'fillSiteUniqueId' cannot be null.");
        else if (fillSiteUniqueId !== undefined)
            url_ += "FillSiteUniqueId=" + encodeURIComponent("" + fillSiteUniqueId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFillSiteAssignedQPs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFillSiteAssignedQPs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteQPSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteQPSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processGetFillSiteAssignedQPs(response: HttpResponseBase): Observable<FillSiteQPSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FillSiteQPSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteQPSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchFillSiteESVR(uniqueId: string, timeZone: string, body: FillSiteESVRSearchQuery | undefined): Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/ESVRs/Search";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFillSiteESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFillSiteESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchFillSiteESVR(response: HttpResponseBase): Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ESVRSearchViewModelESVRTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ESVRSearchViewModelESVRTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchFillSitesUsers(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/Users/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFillSitesUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFillSitesUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchFillSitesUsers(response: HttpResponseBase): Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSearchViewModelCleanFillUserTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @return Success
     */
    getFillSiteBatches(uniqueId: string, timeZone: string): Observable<BatchQueryResultViewModel[]> {
        let url_ = this.baseUrl + "/api/FillSites/{uniqueId}/Batches";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFillSiteBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFillSiteBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchQueryResultViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchQueryResultViewModel[]>;
        }));
    }

    protected processGetFillSiteBatches(response: HttpResponseBase): Observable<BatchQueryResultViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchQueryResultViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchQueryResultViewModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBatchExtraFS(fillSiteUniqueId: string, batchUniqueId: string, timeZone: string, body: CreateBatchExtraFSCommand | undefined): Observable<BatchExtraViewModel> {
        let url_ = this.baseUrl + "/api/FillSites/{fillSiteUniqueId}/Batches/{batchUniqueId}/Extra";
        if (fillSiteUniqueId === undefined || fillSiteUniqueId === null)
            throw new Error("The parameter 'fillSiteUniqueId' must be defined.");
        url_ = url_.replace("{fillSiteUniqueId}", encodeURIComponent("" + fillSiteUniqueId));
        if (batchUniqueId === undefined || batchUniqueId === null)
            throw new Error("The parameter 'batchUniqueId' must be defined.");
        url_ = url_.replace("{batchUniqueId}", encodeURIComponent("" + batchUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBatchExtraFS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBatchExtraFS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchExtraViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchExtraViewModel>;
        }));
    }

    protected processCreateBatchExtraFS(response: HttpResponseBase): Observable<BatchExtraViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = BatchExtraViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchExtraViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editBatchExtraFS(fillSiteUniqueId: string, uniqueId: string, timeZone: string, body: EditBatchExtraFSCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSites/{fillSiteUniqueId}/Batches/{uniqueId}";
        if (fillSiteUniqueId === undefined || fillSiteUniqueId === null)
            throw new Error("The parameter 'fillSiteUniqueId' must be defined.");
        url_ = url_.replace("{fillSiteUniqueId}", encodeURIComponent("" + fillSiteUniqueId));
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditBatchExtraFS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditBatchExtraFS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditBatchExtraFS(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    eSVRFillSiteInfoEdit(fillSiteUniqueId: string, uniqueId: string, timeZone: string, body: ESVRFillSiteInfoEditCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSites/{fillSiteUniqueId}/ESVR/{uniqueId}";
        if (fillSiteUniqueId === undefined || fillSiteUniqueId === null)
            throw new Error("The parameter 'fillSiteUniqueId' must be defined.");
        url_ = url_.replace("{fillSiteUniqueId}", encodeURIComponent("" + fillSiteUniqueId));
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processESVRFillSiteInfoEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processESVRFillSiteInfoEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processESVRFillSiteInfoEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FillSiteSourceSitesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignSourceSitesToFillSite(timeZone: string, body: AssignSourceSitesToFillSiteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSiteSourceSites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignSourceSitesToFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignSourceSitesToFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignSourceSitesToFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    unassignSourceSiteFromFillSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/FillSiteSourceSites/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignSourceSiteFromFillSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignSourceSiteFromFillSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignSourceSiteFromFillSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllGroups(timeZone: string): Observable<CleanFillGroupViewModel[]> {
        let url_ = this.baseUrl + "/api/Group";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CleanFillGroupViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CleanFillGroupViewModel[]>;
        }));
    }

    protected processGetAllGroups(response: HttpResponseBase): Observable<CleanFillGroupViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CleanFillGroupViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CleanFillGroupViewModel[]>(null as any);
    }
}

@Injectable()
export class HaulersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getHaulerDetail(uniqueId: string, timeZone: string): Observable<HaulerViewModel> {
        let url_ = this.baseUrl + "/api/Haulers/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHaulerDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHaulerDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HaulerViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HaulerViewModel>;
        }));
    }

    protected processGetHaulerDetail(response: HttpResponseBase): Observable<HaulerViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HaulerViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HaulerViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editHauler(uniqueId: string, timeZone: string, body: EditHaulerCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Haulers/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditHauler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditHauler(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditHauler(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteHauler(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Haulers/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteHauler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHauler(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteHauler(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createHauler(timeZone: string, body: CreateHaulerCommand | undefined): Observable<HaulerViewModel> {
        let url_ = this.baseUrl + "/api/Haulers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateHauler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHauler(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HaulerViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HaulerViewModel>;
        }));
    }

    protected processCreateHauler(response: HttpResponseBase): Observable<HaulerViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = HaulerViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HaulerViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTruck(uniqueId: string, timeZone: string, body: CreateTruckCommand | undefined): Observable<TruckViewModel> {
        let url_ = this.baseUrl + "/api/Haulers/{uniqueId}/Truck";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTruck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTruck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckViewModel>;
        }));
    }

    protected processCreateTruck(response: HttpResponseBase): Observable<TruckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TruckViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TruckViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTrucks(uniqueId: string, timeZone: string, body: CreateTruckListCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Haulers/{uniqueId}/Trucks";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTrucks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTrucks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTrucks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getTruckList(uniqueId: string, timeZone: string): Observable<TruckViewModel[]> {
        let url_ = this.baseUrl + "/api/Haulers/{uniqueId}/Trucks";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTruckList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTruckList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckViewModel[]>;
        }));
    }

    protected processGetTruckList(response: HttpResponseBase): Observable<TruckViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TruckViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TruckViewModel[]>(null as any);
    }
}

@Injectable()
export class InspectionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInspectionQuestions(timeZone: string): Observable<InspectionQuestionViewModel[]> {
        let url_ = this.baseUrl + "/api/Inspections/questions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectionQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectionQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InspectionQuestionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InspectionQuestionViewModel[]>;
        }));
    }

    protected processGetInspectionQuestions(response: HttpResponseBase): Observable<InspectionQuestionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InspectionQuestionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InspectionQuestionViewModel[]>(null as any);
    }
}

@Injectable()
export class InvoicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInvoiceDetail(uniqueId: string, timeZone: string): Observable<InvoiceViewModel> {
        let url_ = this.baseUrl + "/api/Invoices/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceViewModel>;
        }));
    }

    protected processGetInvoiceDetail(response: HttpResponseBase): Observable<InvoiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editInvoice(uniqueId: string, timeZone: string, body: EditInvoiceCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Invoices/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoice(timeZone: string, body: CreateInvoiceCommand | undefined): Observable<InvoiceViewModel> {
        let url_ = this.baseUrl + "/api/Invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceViewModel>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<InvoiceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = InvoiceViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInvoiceStatus(uniqueId: string, timeZone: string, body: UpdateInvoiceStatusCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Invoices/{uniqueId}/Status";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInvoiceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvoiceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInvoiceStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    invoiceSearch(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<InvoiceSearchViewModelInvoiceTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Invoices/Search?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoiceSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoiceSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceSearchViewModelInvoiceTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceSearchViewModelInvoiceTotalTypePagedResultResponse>;
        }));
    }

    protected processInvoiceSearch(response: HttpResponseBase): Observable<InvoiceSearchViewModelInvoiceTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceSearchViewModelInvoiceTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceSearchViewModelInvoiceTotalTypePagedResultResponse>(null as any);
    }
}

@Injectable()
export class LegalEntitiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    inviteNewUser(uniqueId: string, timeZone: string, body: InviteUserCommand | undefined): Observable<UserInviteViewModel> {
        let url_ = this.baseUrl + "/api/LegalEntities/{uniqueId}/Users/Invite";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteNewUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteNewUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInviteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInviteViewModel>;
        }));
    }

    protected processInviteNewUser(response: HttpResponseBase): Observable<UserInviteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UserInviteViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInviteViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getUserInviteDetail(uniqueId: string, inviteUniqueId: string, timeZone: string): Observable<UserInviteViewModel> {
        let url_ = this.baseUrl + "/api/LegalEntities/{uniqueId}/UserInvites/{InviteUniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (inviteUniqueId === undefined || inviteUniqueId === null)
            throw new Error("The parameter 'inviteUniqueId' must be defined.");
        url_ = url_.replace("{inviteUniqueId}", encodeURIComponent("" + inviteUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInviteDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInviteDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInviteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInviteViewModel>;
        }));
    }

    protected processGetUserInviteDetail(response: HttpResponseBase): Observable<UserInviteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInviteViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInviteViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    inviteNewQualifiedPerson(uniqueId: string, timeZone: string, body: InviteQualifiedPersonCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/LegalEntities/{uniqueId}/QualifiedPersons/Invite";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteNewQualifiedPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteNewQualifiedPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInviteNewQualifiedPerson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    inviteNewQualifiedPersonList(uniqueId: string, timeZone: string, body: InviteQualifiedPersonListCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/LegalEntities/{uniqueId}/QualifiedPersons/Invites";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteNewQualifiedPersonList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteNewQualifiedPersonList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInviteNewQualifiedPersonList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    removeQPAdmin(uniqueId: string, qpUniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/LegalEntities/{uniqueId}/QualifiedPersons/{qpUniqueId}/IsAdmin";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (qpUniqueId === undefined || qpUniqueId === null)
            throw new Error("The parameter 'qpUniqueId' must be defined.");
        url_ = url_.replace("{qpUniqueId}", encodeURIComponent("" + qpUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveQPAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveQPAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveQPAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getQualifiedPersonInviteDetail(uniqueId: string, inviteUniqueId: string, timeZone: string): Observable<UserInviteViewModel> {
        let url_ = this.baseUrl + "/api/LegalEntities/{uniqueId}/QualifiedPersonsInvites/{InviteUniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (inviteUniqueId === undefined || inviteUniqueId === null)
            throw new Error("The parameter 'inviteUniqueId' must be defined.");
        url_ = url_.replace("{inviteUniqueId}", encodeURIComponent("" + inviteUniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualifiedPersonInviteDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualifiedPersonInviteDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInviteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInviteViewModel>;
        }));
    }

    protected processGetQualifiedPersonInviteDetail(response: HttpResponseBase): Observable<UserInviteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInviteViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInviteViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    inviteNewCompanyQP(timeZone: string, body: InviteLegalEntityCommand | undefined): Observable<QualifiedPersonInviteViewModel> {
        let url_ = this.baseUrl + "/api/LegalEntities/Invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteNewCompanyQP(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteNewCompanyQP(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualifiedPersonInviteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualifiedPersonInviteViewModel>;
        }));
    }

    protected processInviteNewCompanyQP(response: HttpResponseBase): Observable<QualifiedPersonInviteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = QualifiedPersonInviteViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualifiedPersonInviteViewModel>(null as any);
    }
}

@Injectable()
export class LogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    listLogs(timeZone: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Log";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processListLogs(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    getLogFile(file: string, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Log/{file}";
        if (file === undefined || file === null)
            throw new Error("The parameter 'file' must be defined.");
        url_ = url_.replace("{file}", encodeURIComponent("" + file));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetLogFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class NotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deleteNotification(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Notifications/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editNotificationStatus(uniqueId: string, timeZone: string, body: NotificationStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Notifications/{uniqueId}/Status";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditNotificationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditNotificationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditNotificationStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PolicyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPolicies(timeZone: string): Observable<CleanFillPolicyViewModel[]> {
        let url_ = this.baseUrl + "/api/Policy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPolicies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CleanFillPolicyViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CleanFillPolicyViewModel[]>;
        }));
    }

    protected processGetAllPolicies(response: HttpResponseBase): Observable<CleanFillPolicyViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CleanFillPolicyViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CleanFillPolicyViewModel[]>(null as any);
    }
}

@Injectable()
export class QualifiedPersonInviteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editQualifiedPersonInvite(timeZone: string, body: EditQualifiedPersonInviteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/QualifiedPersonInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditQualifiedPersonInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditQualifiedPersonInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditQualifiedPersonInvite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class QualifiedPersonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    deleteQualifiedPerson(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/QualifiedPersons/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteQualifiedPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteQualifiedPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteQualifiedPerson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getQualifiedPersonDetail(uniqueId: string, timeZone: string): Observable<QualifiedPersonViewModel> {
        let url_ = this.baseUrl + "/api/QualifiedPersons/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQualifiedPersonDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQualifiedPersonDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualifiedPersonViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualifiedPersonViewModel>;
        }));
    }

    protected processGetQualifiedPersonDetail(response: HttpResponseBase): Observable<QualifiedPersonViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualifiedPersonViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualifiedPersonViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editQualifiedPerson(uniqueId: string, timeZone: string, body: EditQualifiedPersonCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/QualifiedPersons/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditQualifiedPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditQualifiedPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditQualifiedPerson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchQualifiedPerson(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<QualifiedPersonSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/QualifiedPersons/Search?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchQualifiedPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchQualifiedPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualifiedPersonSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualifiedPersonSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchQualifiedPerson(response: HttpResponseBase): Observable<QualifiedPersonSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualifiedPersonSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualifiedPersonSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param qualifiedPersonId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    getCompanyInvites(uniqueId: string, qualifiedPersonId: string | undefined, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/QualifiedPersons/{uniqueId}/CompanyInvites/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (qualifiedPersonId === null)
            throw new Error("The parameter 'qualifiedPersonId' cannot be null.");
        else if (qualifiedPersonId !== undefined)
            url_ += "QualifiedPersonId=" + encodeURIComponent("" + qualifiedPersonId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyInvites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyInvites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse>;
        }));
    }

    protected processGetCompanyInvites(response: HttpResponseBase): Observable<QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createQualifiedPerson(timeZone: string, body: CreateQualifiedPersonCommand | undefined): Observable<QualifiedPersonViewModel> {
        let url_ = this.baseUrl + "/api/QualifiedPersons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateQualifiedPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQualifiedPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualifiedPersonViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualifiedPersonViewModel>;
        }));
    }

    protected processCreateQualifiedPerson(response: HttpResponseBase): Observable<QualifiedPersonViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = QualifiedPersonViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualifiedPersonViewModel>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    qPSourceSitesSearch(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<SourceSiteQPSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/QualifiedPersons/{uniqueId}/SourceSites/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQPSourceSitesSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQPSourceSitesSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteQPSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteQPSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processQPSourceSitesSearch(response: HttpResponseBase): Observable<SourceSiteQPSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SourceSiteQPSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteQPSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    qPFillSitesSearch(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<FillSiteQPSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/QualifiedPersons/{uniqueId}/FillSites/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQPFillSitesSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQPFillSitesSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteQPSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteQPSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processQPFillSitesSearch(response: HttpResponseBase): Observable<FillSiteQPSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FillSiteQPSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteQPSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchQPClients(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/QualifiedPersons/{uniqueId}/Clients/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchQPClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchQPClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchQPClients(response: HttpResponseBase): Observable<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyQPViewModelCompanyQPTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyQPViewModelCompanyQPTotalTypePagedResultResponse>(null as any);
    }
}

@Injectable()
export class SourceSiteCleanFillUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignUserToSourceSite(timeZone: string, body: AssignUserToSourceSiteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSiteCleanFillUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUserToSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUserToSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignUserToSourceSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    unassignUserFromSourceSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSiteCleanFillUsers/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignUserFromSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignUserFromSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignUserFromSourceSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SourceSiteQualifiedPersonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignQPToSourceSite(timeZone: string, body: AssignQPToSourceSiteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSiteQualifiedPersons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignQPToSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignQPToSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignQPToSourceSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    unassignQPFromSourceSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSiteQualifiedPersons/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignQPFromSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignQPFromSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignQPFromSourceSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SourceSitesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchSourceSites(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/SourceSites/Search?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSourceSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSourceSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchSourceSites(response: HttpResponseBase): Observable<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SourceSiteSearchViewModelSiteTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteSearchViewModelSiteTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @return Success
     */
    sourceSiteBatches(uniqueId: string, timeZone: string): Observable<BatchQueryResultViewModel[]> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/Batches";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSourceSiteBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSourceSiteBatches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BatchQueryResultViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BatchQueryResultViewModel[]>;
        }));
    }

    protected processSourceSiteBatches(response: HttpResponseBase): Observable<BatchQueryResultViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchQueryResultViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchQueryResultViewModel[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchSourceSiteFillSites(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/FillSites/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSourceSiteFillSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSourceSiteFillSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchSourceSiteFillSites(response: HttpResponseBase): Observable<FillSiteSearchViewModelSiteTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FillSiteSearchViewModelSiteTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteSearchViewModelSiteTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSourceSiteQualifiedPersons(uniqueId: string, timeZone: string): Observable<QualifiedPersonViewModel[]> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/QualifiedPersons";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceSiteQualifiedPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceSiteQualifiedPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualifiedPersonViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualifiedPersonViewModel[]>;
        }));
    }

    protected processGetSourceSiteQualifiedPersons(response: HttpResponseBase): Observable<QualifiedPersonViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualifiedPersonViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualifiedPersonViewModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getSourceSiteDetail(uniqueId: string, timeZone: string): Observable<SourceSiteViewModel> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceSiteDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceSiteDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteViewModel>;
        }));
    }

    protected processGetSourceSiteDetail(response: HttpResponseBase): Observable<SourceSiteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SourceSiteViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editSourceSite(uniqueId: string, timeZone: string, body: EditSourceSiteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditSourceSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteSourceSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSourceSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSourceSite(timeZone: string, body: CreateSourceSiteCommand | undefined): Observable<SourceSiteViewModel> {
        let url_ = this.baseUrl + "/api/SourceSites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteViewModel>;
        }));
    }

    protected processCreateSourceSite(response: HttpResponseBase): Observable<SourceSiteViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = SourceSiteViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getSourceSiteAttachmentDetail(uniqueId: string, timeZone: string): Observable<SourceSiteAttachmentViewModel[]> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/Attachment";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceSiteAttachmentDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceSiteAttachmentDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteAttachmentViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteAttachmentViewModel[]>;
        }));
    }

    protected processGetSourceSiteAttachmentDetail(response: HttpResponseBase): Observable<SourceSiteAttachmentViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SourceSiteAttachmentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteAttachmentViewModel[]>(null as any);
    }

    /**
     * @param sourceSiteUniqueId (optional) 
     * @param links (optional) 
     * @param files (optional) 
     * @return Success
     */
    uploadSourceSiteAttachment(timeZone: string, sourceSiteUniqueId: string | undefined, links: string[] | undefined, files: FileParameter[] | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/SourceSites/Attachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (sourceSiteUniqueId === null || sourceSiteUniqueId === undefined)
            throw new Error("The parameter 'sourceSiteUniqueId' cannot be null.");
        else
            content_.append("SourceSiteUniqueId", sourceSiteUniqueId.toString());
        if (links === null || links === undefined)
            throw new Error("The parameter 'links' cannot be null.");
        else
            links.forEach(item_ => content_.append("Links", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSourceSiteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSourceSiteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadSourceSiteAttachment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    downloadSourceSiteAttachment(uniqueId: string, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/SourceSites/Attachment/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/*"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSourceSiteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSourceSiteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadSourceSiteAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteSourceSiteAttachment(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSites/Attachment/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSourceSiteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSourceSiteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSourceSiteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    archiveSourceSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/IsArchived";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveSourceSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    reactivateSourceSite(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/Reactivate";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateSourceSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateSourceSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReactivateSourceSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sourceSiteUniqueId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    getSourceSiteAssignedUsers(uniqueId: string, sourceSiteUniqueId: string | undefined, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<SourceSiteUserSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/AssignedUsers?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (sourceSiteUniqueId === null)
            throw new Error("The parameter 'sourceSiteUniqueId' cannot be null.");
        else if (sourceSiteUniqueId !== undefined)
            url_ += "SourceSiteUniqueId=" + encodeURIComponent("" + sourceSiteUniqueId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceSiteAssignedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceSiteAssignedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteUserSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteUserSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processGetSourceSiteAssignedUsers(response: HttpResponseBase): Observable<SourceSiteUserSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SourceSiteUserSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteUserSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param sourceSiteUniqueId (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    getSourceSiteAssignedQPs(uniqueId: string, sourceSiteUniqueId: string | undefined, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<SourceSiteQPSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/AssignedQPs?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (sourceSiteUniqueId === null)
            throw new Error("The parameter 'sourceSiteUniqueId' cannot be null.");
        else if (sourceSiteUniqueId !== undefined)
            url_ += "SourceSiteUniqueId=" + encodeURIComponent("" + sourceSiteUniqueId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSourceSiteAssignedQPs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSourceSiteAssignedQPs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteQPSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteQPSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processGetSourceSiteAssignedQPs(response: HttpResponseBase): Observable<SourceSiteQPSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SourceSiteQPSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteQPSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchSourceSiteESVR(uniqueId: string, timeZone: string, body: SourceSiteESVRSearchQuery | undefined): Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/ESVRs/Search";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSourceSiteESVR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSourceSiteESVR(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchSourceSiteESVR(response: HttpResponseBase): Observable<ESVRSearchViewModelESVRTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ESVRSearchViewModelESVRTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ESVRSearchViewModelESVRTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchSourceSiteUsers(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/SourceSites/{uniqueId}/Users/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSourceSiteUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSourceSiteUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchSourceSiteUsers(response: HttpResponseBase): Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSearchViewModelCleanFillUserTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    eSVRSourceSiteInfoEdit(sourceSiteUniqueId: string, uniqueId: string, timeZone: string, body: ESVRSourceSiteInfoEditCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SourceSites/{sourceSiteUniqueId}/ESVR/{uniqueId}";
        if (sourceSiteUniqueId === undefined || sourceSiteUniqueId === null)
            throw new Error("The parameter 'sourceSiteUniqueId' must be defined.");
        url_ = url_.replace("{sourceSiteUniqueId}", encodeURIComponent("" + sourceSiteUniqueId));
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processESVRSourceSiteInfoEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processESVRSourceSiteInfoEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processESVRSourceSiteInfoEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TermsAndConditionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    termsAndConditions(timeZone: string): Observable<TermsAndConditionsViewModelResultResponse> {
        let url_ = this.baseUrl + "/api/TermsAndConditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTermsAndConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTermsAndConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TermsAndConditionsViewModelResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TermsAndConditionsViewModelResultResponse>;
        }));
    }

    protected processTermsAndConditions(response: HttpResponseBase): Observable<TermsAndConditionsViewModelResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermsAndConditionsViewModelResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TermsAndConditionsViewModelResultResponse>(null as any);
    }
}

@Injectable()
export class TrainingMaterialsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTrainingMaterialDetail(uniqueId: string, timeZone: string): Observable<TrainingMaterialViewModel> {
        let url_ = this.baseUrl + "/api/TrainingMaterials/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingMaterialDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingMaterialDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingMaterialViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingMaterialViewModel>;
        }));
    }

    protected processGetTrainingMaterialDetail(response: HttpResponseBase): Observable<TrainingMaterialViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingMaterialViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrainingMaterialViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editTrainingMaterial(uniqueId: string, timeZone: string, body: EditTrainingMaterialCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TrainingMaterials/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTrainingMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTrainingMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditTrainingMaterial(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTrainingMaterial(timeZone: string, body: CreateTrainingMaterialCommand | undefined): Observable<TrainingMaterialViewModel> {
        let url_ = this.baseUrl + "/api/TrainingMaterials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTrainingMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTrainingMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingMaterialViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingMaterialViewModel>;
        }));
    }

    protected processCreateTrainingMaterial(response: HttpResponseBase): Observable<TrainingMaterialViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TrainingMaterialViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrainingMaterialViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllTrainingMaterials(timeZone: string): Observable<TrainingMaterialViewModel[]> {
        let url_ = this.baseUrl + "/api/TrainingMaterials/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrainingMaterials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrainingMaterials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingMaterialViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingMaterialViewModel[]>;
        }));
    }

    protected processGetAllTrainingMaterials(response: HttpResponseBase): Observable<TrainingMaterialViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingMaterialViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TrainingMaterialViewModel[]>(null as any);
    }
}

@Injectable()
export class TrucksClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTruckDetail(uniqueId: string, timeZone: string): Observable<TruckViewModel> {
        let url_ = this.baseUrl + "/api/Trucks/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTruckDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTruckDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckViewModel>;
        }));
    }

    protected processGetTruckDetail(response: HttpResponseBase): Observable<TruckViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TruckViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TruckViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editTruck(uniqueId: string, timeZone: string, body: EditTruckCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Trucks/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTruck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTruck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditTruck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteTruck(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Trucks/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTruck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTruck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTruck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    downloadBarcodes(timeZone: string, body: TruckDownloadQuery | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Trucks/DownloadBarcodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/pdf"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBarcodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBarcodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBarcodes(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    truckEmailLogs(uniqueId: string, timeZone: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Trucks/{uniqueId}/TruckEmailLogs";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTruckEmailLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTruckEmailLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processTruckEmailLogs(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTrucks(timeZone: string, body: DeleteTruckListCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Trucks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrucks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrucks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTrucks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserInviteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUserInvite(timeZone: string, body: EditUserInviteCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/UserInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditUserInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditUserInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditUserInvite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserDetails(timeZone: string): Observable<CurrentUserViewModel> {
        let url_ = this.baseUrl + "/api/Users/CurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserViewModel>;
        }));
    }

    protected processGetCurrentUserDetails(response: HttpResponseBase): Observable<CurrentUserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentUserViewModel>(null as any);
    }

    /**
     * @return Success
     */
    createUser(timeZone: string): Observable<CurrentUserViewModel> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserViewModel>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<CurrentUserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CurrentUserViewModel.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentUserViewModel>(null as any);
    }

    /**
     * @return Success
     */
    getUserDetails(uniqueId: string, timeZone: string): Observable<UserViewModel> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel>;
        }));
    }

    protected processGetUserDetails(response: HttpResponseBase): Observable<UserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUserProfile(uniqueId: string, timeZone: string, body: EditUserProfileCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteUser(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchUsers(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Users/Search?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchUsers(response: HttpResponseBase): Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSearchViewModelCleanFillUserTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    searchApproveUsers(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Users/SearchApprove?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchApproveUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchApproveUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>;
        }));
    }

    protected processSearchApproveUsers(response: HttpResponseBase): Observable<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSearchViewModelCleanFillUserTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSearchViewModelCleanFillUserTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    userSourceSitesSearch(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<SourceSiteUserSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/SourceSites/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserSourceSitesSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserSourceSitesSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceSiteUserSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceSiteUserSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processUserSourceSitesSearch(response: HttpResponseBase): Observable<SourceSiteUserSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SourceSiteUserSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceSiteUserSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    userFillSitesSearch(uniqueId: string, page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, timeZone: string): Observable<FillSiteUserSearchViewModelTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/FillSites/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserFillSitesSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserFillSitesSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FillSiteUserSearchViewModelTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FillSiteUserSearchViewModelTotalTypePagedResultResponse>;
        }));
    }

    protected processUserFillSitesSearch(response: HttpResponseBase): Observable<FillSiteUserSearchViewModelTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FillSiteUserSearchViewModelTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FillSiteUserSearchViewModelTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUserPoliciesAndRoles(uniqueId: string, timeZone: string, body: EditUserPoliciesAndRolesCommand | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/Authorization";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditUserPoliciesAndRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditUserPoliciesAndRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditUserPoliciesAndRoles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deactivateUser(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/Deactivation";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    approveUser(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/Approval";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApproveUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteUserForever(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/DeleteForever";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserForever(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserForever(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUserForever(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortBy (optional) 
     * @param filterBy (optional) 
     * @return Success
     */
    getUserNotifications(page: number | undefined, pageSize: number | undefined, sortBy: SortBy[] | undefined, filterBy: FilterBy[] | undefined, uniqueId: string, timeZone: string): Observable<NotificationViewModelNotificationTotalTypePagedResultResponse> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/Notifications/Search?";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            sortBy && sortBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (filterBy === null)
            throw new Error("The parameter 'filterBy' cannot be null.");
        else if (filterBy !== undefined)
            filterBy && filterBy.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "FilterBy[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationViewModelNotificationTotalTypePagedResultResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationViewModelNotificationTotalTypePagedResultResponse>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<NotificationViewModelNotificationTotalTypePagedResultResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationViewModelNotificationTotalTypePagedResultResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationViewModelNotificationTotalTypePagedResultResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteAllUserNotifications(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/Notifications";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUserNotificationsStatus(uniqueId: string, timeZone: string, body: NotificationStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/Notifications/Status";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditUserNotificationsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditUserNotificationsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditUserNotificationsStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    userAcceptTerm(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/IsTermAccepted";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserAcceptTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserAcceptTerm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserAcceptTerm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    userApproved(uniqueId: string, timeZone: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Users/{uniqueId}/IsUserApproved";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "TimeZone": timeZone !== undefined && timeZone !== null ? "" + timeZone : "",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserApproved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserApproved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUserApproved(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class AddressViewModel implements IAddressViewModel {
    province?: ProvinceViewModel | undefined;
    uniqueId?: string;
    city?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    postalCode?: string | undefined;
    provinceUniqueId?: string | undefined;

    constructor(data?: IAddressViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.province = _data["province"] ? ProvinceViewModel.fromJS(_data["province"]) : <any>undefined;
            this.uniqueId = _data["uniqueId"];
            this.city = _data["city"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.postalCode = _data["postalCode"];
            this.provinceUniqueId = _data["provinceUniqueId"];
        }
    }

    static fromJS(data: any): AddressViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["province"] = this.province ? this.province.toJSON() : <any>undefined;
        data["uniqueId"] = this.uniqueId;
        data["city"] = this.city;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["postalCode"] = this.postalCode;
        data["provinceUniqueId"] = this.provinceUniqueId;
        return data;
    }
}

export interface IAddressViewModel {
    province?: ProvinceViewModel | undefined;
    uniqueId?: string;
    city?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    postalCode?: string | undefined;
    provinceUniqueId?: string | undefined;
}

export class AddressViewModelBase implements IAddressViewModelBase {
    city?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    postalCode?: string | undefined;
    provinceUniqueId?: string | undefined;

    constructor(data?: IAddressViewModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.postalCode = _data["postalCode"];
            this.provinceUniqueId = _data["provinceUniqueId"];
        }
    }

    static fromJS(data: any): AddressViewModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new AddressViewModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["postalCode"] = this.postalCode;
        data["provinceUniqueId"] = this.provinceUniqueId;
        return data;
    }
}

export interface IAddressViewModelBase {
    city?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    postalCode?: string | undefined;
    provinceUniqueId?: string | undefined;
}

export enum AnalysisParameter {
    F1F4 = "F1F4",
    VOC = "VOC",
    SVOC = "SVOC",
    Metals = "Metals",
    Inorg = "Inorg",
    PCB = "PCB",
    Pest = "Pest",
    Other = "Other",
}

export class ApproveESVRInfoUpdate implements IApproveESVRInfoUpdate {
    loadWeight?: number;
    placementLocation?: string | undefined;

    constructor(data?: IApproveESVRInfoUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loadWeight = _data["loadWeight"];
            this.placementLocation = _data["placementLocation"];
        }
    }

    static fromJS(data: any): ApproveESVRInfoUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveESVRInfoUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loadWeight"] = this.loadWeight;
        data["placementLocation"] = this.placementLocation;
        return data;
    }
}

export interface IApproveESVRInfoUpdate {
    loadWeight?: number;
    placementLocation?: string | undefined;
}

export class AssignQPToCompanyCommand implements IAssignQPToCompanyCommand {
    companyUniqueId?: string;
    qualifiedPersonUniqueId?: string;

    constructor(data?: IAssignQPToCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyUniqueId = _data["companyUniqueId"];
            this.qualifiedPersonUniqueId = _data["qualifiedPersonUniqueId"];
        }
    }

    static fromJS(data: any): AssignQPToCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignQPToCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyUniqueId"] = this.companyUniqueId;
        data["qualifiedPersonUniqueId"] = this.qualifiedPersonUniqueId;
        return data;
    }
}

export interface IAssignQPToCompanyCommand {
    companyUniqueId?: string;
    qualifiedPersonUniqueId?: string;
}

export class AssignQPToFillSiteCommand implements IAssignQPToFillSiteCommand {
    qualifiedPersonUniqueId?: string;
    fillSiteUniqueId?: string;

    constructor(data?: IAssignQPToFillSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifiedPersonUniqueId = _data["qualifiedPersonUniqueId"];
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
        }
    }

    static fromJS(data: any): AssignQPToFillSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignQPToFillSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifiedPersonUniqueId"] = this.qualifiedPersonUniqueId;
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        return data;
    }
}

export interface IAssignQPToFillSiteCommand {
    qualifiedPersonUniqueId?: string;
    fillSiteUniqueId?: string;
}

export class AssignQPToSourceSiteCommand implements IAssignQPToSourceSiteCommand {
    qualifiedPersonUniqueId?: string;
    sourceSiteUniqueId?: string;
    sourceSiteId?: number;
    qualifiedPersonId?: number;

    constructor(data?: IAssignQPToSourceSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifiedPersonUniqueId = _data["qualifiedPersonUniqueId"];
            this.sourceSiteUniqueId = _data["sourceSiteUniqueId"];
            this.sourceSiteId = _data["sourceSiteId"];
            this.qualifiedPersonId = _data["qualifiedPersonId"];
        }
    }

    static fromJS(data: any): AssignQPToSourceSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignQPToSourceSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifiedPersonUniqueId"] = this.qualifiedPersonUniqueId;
        data["sourceSiteUniqueId"] = this.sourceSiteUniqueId;
        data["sourceSiteId"] = this.sourceSiteId;
        data["qualifiedPersonId"] = this.qualifiedPersonId;
        return data;
    }
}

export interface IAssignQPToSourceSiteCommand {
    qualifiedPersonUniqueId?: string;
    sourceSiteUniqueId?: string;
    sourceSiteId?: number;
    qualifiedPersonId?: number;
}

export class AssignSourceSitesToFillSiteCommand implements IAssignSourceSitesToFillSiteCommand {
    fillSiteUniqueId?: string;
    sourceSiteUniqueIds?: string[] | undefined;

    constructor(data?: IAssignSourceSitesToFillSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
            if (Array.isArray(_data["sourceSiteUniqueIds"])) {
                this.sourceSiteUniqueIds = [] as any;
                for (let item of _data["sourceSiteUniqueIds"])
                    this.sourceSiteUniqueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AssignSourceSitesToFillSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignSourceSitesToFillSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        if (Array.isArray(this.sourceSiteUniqueIds)) {
            data["sourceSiteUniqueIds"] = [];
            for (let item of this.sourceSiteUniqueIds)
                data["sourceSiteUniqueIds"].push(item);
        }
        return data;
    }
}

export interface IAssignSourceSitesToFillSiteCommand {
    fillSiteUniqueId?: string;
    sourceSiteUniqueIds?: string[] | undefined;
}

export class AssignUserToFillSiteCommand implements IAssignUserToFillSiteCommand {
    cleanFillUserId?: number;
    cleanFillUserUniqueId?: string;
    fillSiteUniqueId?: string;

    constructor(data?: IAssignUserToFillSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cleanFillUserId = _data["cleanFillUserId"];
            this.cleanFillUserUniqueId = _data["cleanFillUserUniqueId"];
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
        }
    }

    static fromJS(data: any): AssignUserToFillSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserToFillSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cleanFillUserId"] = this.cleanFillUserId;
        data["cleanFillUserUniqueId"] = this.cleanFillUserUniqueId;
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        return data;
    }
}

export interface IAssignUserToFillSiteCommand {
    cleanFillUserId?: number;
    cleanFillUserUniqueId?: string;
    fillSiteUniqueId?: string;
}

export class AssignUserToSourceSiteCommand implements IAssignUserToSourceSiteCommand {
    cleanFillUserUniqueId?: string;
    sourceSiteUniqueId?: string;

    constructor(data?: IAssignUserToSourceSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cleanFillUserUniqueId = _data["cleanFillUserUniqueId"];
            this.sourceSiteUniqueId = _data["sourceSiteUniqueId"];
        }
    }

    static fromJS(data: any): AssignUserToSourceSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignUserToSourceSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cleanFillUserUniqueId"] = this.cleanFillUserUniqueId;
        data["sourceSiteUniqueId"] = this.sourceSiteUniqueId;
        return data;
    }
}

export interface IAssignUserToSourceSiteCommand {
    cleanFillUserUniqueId?: string;
    sourceSiteUniqueId?: string;
}

export class AuditTrailChangeViewModel implements IAuditTrailChangeViewModel {
    propertyName?: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;

    constructor(data?: IAuditTrailChangeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): AuditTrailChangeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTrailChangeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IAuditTrailChangeViewModel {
    propertyName?: string | undefined;
    oldValue?: any | undefined;
    newValue?: any | undefined;
}

export class AuditTrailViewModel implements IAuditTrailViewModel {
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    changes?: AuditTrailChangeViewModel[] | undefined;

    constructor(data?: IAuditTrailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes!.push(AuditTrailChangeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditTrailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuditTrailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuditTrailViewModel {
    modifiedBy?: string | undefined;
    modifiedDate?: Date | undefined;
    changes?: AuditTrailChangeViewModel[] | undefined;
}

export class BatchAddAdditionalESVRsCommand implements IBatchAddAdditionalESVRsCommand {
    batchId?: number;
    batchUniqueId?: string | undefined;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;

    constructor(data?: IBatchAddAdditionalESVRsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.batchUniqueId = _data["batchUniqueId"];
            this.estimatedLoads = _data["estimatedLoads"];
            this.estimatedWeight = _data["estimatedWeight"];
            this.estimatedVolume = _data["estimatedVolume"];
        }
    }

    static fromJS(data: any): BatchAddAdditionalESVRsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchAddAdditionalESVRsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["batchUniqueId"] = this.batchUniqueId;
        data["estimatedLoads"] = this.estimatedLoads;
        data["estimatedWeight"] = this.estimatedWeight;
        data["estimatedVolume"] = this.estimatedVolume;
        return data;
    }
}

export interface IBatchAddAdditionalESVRsCommand {
    batchId?: number;
    batchUniqueId?: string | undefined;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
}

export class BatchAnalysisParameterViewModel implements IBatchAnalysisParameterViewModel {
    uniqueId?: string;
    analysisParameter?: AnalysisParameter;
    count?: number | undefined;
    exceedance?: number | undefined;
    isTCPL?: boolean | undefined;

    constructor(data?: IBatchAnalysisParameterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.analysisParameter = _data["analysisParameter"];
            this.count = _data["count"];
            this.exceedance = _data["exceedance"];
            this.isTCPL = _data["isTCPL"];
        }
    }

    static fromJS(data: any): BatchAnalysisParameterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchAnalysisParameterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["analysisParameter"] = this.analysisParameter;
        data["count"] = this.count;
        data["exceedance"] = this.exceedance;
        data["isTCPL"] = this.isTCPL;
        return data;
    }
}

export interface IBatchAnalysisParameterViewModel {
    uniqueId?: string;
    analysisParameter?: AnalysisParameter;
    count?: number | undefined;
    exceedance?: number | undefined;
    isTCPL?: boolean | undefined;
}

export class BatchAnalysisParameterViewModelBase implements IBatchAnalysisParameterViewModelBase {
    analysisParameter?: AnalysisParameter;
    count?: number | undefined;
    exceedance?: number | undefined;
    isTCPL?: boolean | undefined;

    constructor(data?: IBatchAnalysisParameterViewModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.analysisParameter = _data["analysisParameter"];
            this.count = _data["count"];
            this.exceedance = _data["exceedance"];
            this.isTCPL = _data["isTCPL"];
        }
    }

    static fromJS(data: any): BatchAnalysisParameterViewModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new BatchAnalysisParameterViewModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["analysisParameter"] = this.analysisParameter;
        data["count"] = this.count;
        data["exceedance"] = this.exceedance;
        data["isTCPL"] = this.isTCPL;
        return data;
    }
}

export interface IBatchAnalysisParameterViewModelBase {
    analysisParameter?: AnalysisParameter;
    count?: number | undefined;
    exceedance?: number | undefined;
    isTCPL?: boolean | undefined;
}

export class BatchAssignReviewerCommand implements IBatchAssignReviewerCommand {
    uniqueId?: string;
    reviewerUserUniqueId?: string;

    constructor(data?: IBatchAssignReviewerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.reviewerUserUniqueId = _data["reviewerUserUniqueId"];
        }
    }

    static fromJS(data: any): BatchAssignReviewerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchAssignReviewerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["reviewerUserUniqueId"] = this.reviewerUserUniqueId;
        return data;
    }
}

export interface IBatchAssignReviewerCommand {
    uniqueId?: string;
    reviewerUserUniqueId?: string;
}

export class BatchAttachmentViewModel implements IBatchAttachmentViewModel {
    uniqueId?: string;
    isLink?: boolean;
    fileName?: string | undefined;
    fileSize?: number;
    link?: string | undefined;

    constructor(data?: IBatchAttachmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.isLink = _data["isLink"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): BatchAttachmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchAttachmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["isLink"] = this.isLink;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["link"] = this.link;
        return data;
    }
}

export interface IBatchAttachmentViewModel {
    uniqueId?: string;
    isLink?: boolean;
    fileName?: string | undefined;
    fileSize?: number;
    link?: string | undefined;
}

export class BatchDashboardViewModel implements IBatchDashboardViewModel {
    uniqueId?: string;
    name?: string | undefined;

    constructor(data?: IBatchDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BatchDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        return data;
    }
}

export interface IBatchDashboardViewModel {
    uniqueId?: string;
    name?: string | undefined;
}

export class BatchExtraViewModel implements IBatchExtraViewModel {
    name?: string | undefined;
    isESVRReleased?: boolean | undefined;
    approvedLoads?: number | undefined;
    approvedWeight?: number | undefined;
    unitPrice?: number | undefined;
    estimatedStartDate?: Date | undefined;
    invoiceType?: InvoiceType;
    sourceSiteUserUniqueId?: string | undefined;
    sourceSiteQPUniqueId?: string | undefined;
    fillSiteQPUserUniqueId?: string | undefined;
    fillSiteTPQPUserUniqueId?: string | undefined;
    createdDate?: Date | undefined;
    uniqueId?: string;
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;

    constructor(data?: IBatchExtraViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isESVRReleased = _data["isESVRReleased"];
            this.approvedLoads = _data["approvedLoads"];
            this.approvedWeight = _data["approvedWeight"];
            this.unitPrice = _data["unitPrice"];
            this.estimatedStartDate = _data["estimatedStartDate"] ? new Date(_data["estimatedStartDate"].toString()) : <any>undefined;
            this.invoiceType = _data["invoiceType"];
            this.sourceSiteUserUniqueId = _data["sourceSiteUserUniqueId"];
            this.sourceSiteQPUniqueId = _data["sourceSiteQPUniqueId"];
            this.fillSiteQPUserUniqueId = _data["fillSiteQPUserUniqueId"];
            this.fillSiteTPQPUserUniqueId = _data["fillSiteTPQPUserUniqueId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.uniqueId = _data["uniqueId"];
            this.parentBatchUniqueId = _data["parentBatchUniqueId"];
            this.status = _data["status"];
            this.estimatedLoads = _data["estimatedLoads"];
            this.estimatedWeight = _data["estimatedWeight"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): BatchExtraViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchExtraViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isESVRReleased"] = this.isESVRReleased;
        data["approvedLoads"] = this.approvedLoads;
        data["approvedWeight"] = this.approvedWeight;
        data["unitPrice"] = this.unitPrice;
        data["estimatedStartDate"] = this.estimatedStartDate ? this.estimatedStartDate.toISOString() : <any>undefined;
        data["invoiceType"] = this.invoiceType;
        data["sourceSiteUserUniqueId"] = this.sourceSiteUserUniqueId;
        data["sourceSiteQPUniqueId"] = this.sourceSiteQPUniqueId;
        data["fillSiteQPUserUniqueId"] = this.fillSiteQPUserUniqueId;
        data["fillSiteTPQPUserUniqueId"] = this.fillSiteTPQPUserUniqueId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["uniqueId"] = this.uniqueId;
        data["parentBatchUniqueId"] = this.parentBatchUniqueId;
        data["status"] = this.status;
        data["estimatedLoads"] = this.estimatedLoads;
        data["estimatedWeight"] = this.estimatedWeight;
        data["estimatedVolume"] = this.estimatedVolume;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IBatchExtraViewModel {
    name?: string | undefined;
    isESVRReleased?: boolean | undefined;
    approvedLoads?: number | undefined;
    approvedWeight?: number | undefined;
    unitPrice?: number | undefined;
    estimatedStartDate?: Date | undefined;
    invoiceType?: InvoiceType;
    sourceSiteUserUniqueId?: string | undefined;
    sourceSiteQPUniqueId?: string | undefined;
    fillSiteQPUserUniqueId?: string | undefined;
    fillSiteTPQPUserUniqueId?: string | undefined;
    createdDate?: Date | undefined;
    uniqueId?: string;
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;
}

export class BatchFSQPApprovalCommand implements IBatchFSQPApprovalCommand {
    uniqueId?: string;
    approvedLoads?: number;
    approvedWeight?: number | undefined;

    constructor(data?: IBatchFSQPApprovalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.approvedLoads = _data["approvedLoads"];
            this.approvedWeight = _data["approvedWeight"];
        }
    }

    static fromJS(data: any): BatchFSQPApprovalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchFSQPApprovalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["approvedLoads"] = this.approvedLoads;
        data["approvedWeight"] = this.approvedWeight;
        return data;
    }
}

export interface IBatchFSQPApprovalCommand {
    uniqueId?: string;
    approvedLoads?: number;
    approvedWeight?: number | undefined;
}

export class BatchFSQPForwardToTPQPCommand implements IBatchFSQPForwardToTPQPCommand {
    uniqueId?: string;
    fillSiteTPQPUniqueId?: string;

    constructor(data?: IBatchFSQPForwardToTPQPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.fillSiteTPQPUniqueId = _data["fillSiteTPQPUniqueId"];
        }
    }

    static fromJS(data: any): BatchFSQPForwardToTPQPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchFSQPForwardToTPQPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["fillSiteTPQPUniqueId"] = this.fillSiteTPQPUniqueId;
        return data;
    }
}

export interface IBatchFSQPForwardToTPQPCommand {
    uniqueId?: string;
    fillSiteTPQPUniqueId?: string;
}

export class BatchFSQPRejectionCommand implements IBatchFSQPRejectionCommand {
    uniqueId?: string;
    comments?: string | undefined;

    constructor(data?: IBatchFSQPRejectionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): BatchFSQPRejectionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchFSQPRejectionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IBatchFSQPRejectionCommand {
    uniqueId?: string;
    comments?: string | undefined;
}

export class BatchFSTPQPRejectionCommand implements IBatchFSTPQPRejectionCommand {
    uniqueId?: string;
    comments?: string | undefined;

    constructor(data?: IBatchFSTPQPRejectionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): BatchFSTPQPRejectionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchFSTPQPRejectionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IBatchFSTPQPRejectionCommand {
    uniqueId?: string;
    comments?: string | undefined;
}

export class BatchFSUApprovalCommand implements IBatchFSUApprovalCommand {
    uniqueId?: string;
    approvedLoads?: number;
    approvedWeight?: number | undefined;
    skipQPApproval?: boolean;
    fillSiteQPUniqueId?: string | undefined;

    constructor(data?: IBatchFSUApprovalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.approvedLoads = _data["approvedLoads"];
            this.approvedWeight = _data["approvedWeight"];
            this.skipQPApproval = _data["skipQPApproval"];
            this.fillSiteQPUniqueId = _data["fillSiteQPUniqueId"];
        }
    }

    static fromJS(data: any): BatchFSUApprovalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchFSUApprovalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["approvedLoads"] = this.approvedLoads;
        data["approvedWeight"] = this.approvedWeight;
        data["skipQPApproval"] = this.skipQPApproval;
        data["fillSiteQPUniqueId"] = this.fillSiteQPUniqueId;
        return data;
    }
}

export interface IBatchFSUApprovalCommand {
    uniqueId?: string;
    approvedLoads?: number;
    approvedWeight?: number | undefined;
    skipQPApproval?: boolean;
    fillSiteQPUniqueId?: string | undefined;
}

export class BatchFSURejectionCommand implements IBatchFSURejectionCommand {
    uniqueId?: string;
    comments?: string | undefined;

    constructor(data?: IBatchFSURejectionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): BatchFSURejectionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchFSURejectionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IBatchFSURejectionCommand {
    uniqueId?: string;
    comments?: string | undefined;
}

export enum BatchHistoryStatus {
    Submission = "Submission",
    FSApproval = "FSApproval",
    QPApproval = "QPApproval",
    TransferStart = "TransferStart",
    Complete = "Complete",
}

export class BatchHistoryViewModel implements IBatchHistoryViewModel {
    status?: BatchHistoryStatus;
    createdDate?: Date | undefined;

    constructor(data?: IBatchHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BatchHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBatchHistoryViewModel {
    status?: BatchHistoryStatus;
    createdDate?: Date | undefined;
}

export class BatchLoadReconciliationViewModel implements IBatchLoadReconciliationViewModel {
    totalLoad?: number;
    extra?: number;
    transferred?: number;
    remaining?: number;

    constructor(data?: IBatchLoadReconciliationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalLoad = _data["totalLoad"];
            this.extra = _data["extra"];
            this.transferred = _data["transferred"];
            this.remaining = _data["remaining"];
        }
    }

    static fromJS(data: any): BatchLoadReconciliationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchLoadReconciliationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalLoad"] = this.totalLoad;
        data["extra"] = this.extra;
        data["transferred"] = this.transferred;
        data["remaining"] = this.remaining;
        return data;
    }
}

export interface IBatchLoadReconciliationViewModel {
    totalLoad?: number;
    extra?: number;
    transferred?: number;
    remaining?: number;
}

export class BatchQueryResultViewModel implements IBatchQueryResultViewModel {
    uniqueId?: string;
    identification?: string | undefined;
    name?: string | undefined;
    status?: BatchStatus;
    sourceSite?: string | undefined;
    fillSite?: string | undefined;
    submittedBy?: string | undefined;
    startedDate?: Date | undefined;
    loads?: number;
    receivedLoads?: number;

    constructor(data?: IBatchQueryResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.identification = _data["identification"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.sourceSite = _data["sourceSite"];
            this.fillSite = _data["fillSite"];
            this.submittedBy = _data["submittedBy"];
            this.startedDate = _data["startedDate"] ? new Date(_data["startedDate"].toString()) : <any>undefined;
            this.loads = _data["loads"];
            this.receivedLoads = _data["receivedLoads"];
        }
    }

    static fromJS(data: any): BatchQueryResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchQueryResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["identification"] = this.identification;
        data["name"] = this.name;
        data["status"] = this.status;
        data["sourceSite"] = this.sourceSite;
        data["fillSite"] = this.fillSite;
        data["submittedBy"] = this.submittedBy;
        data["startedDate"] = this.startedDate ? this.startedDate.toISOString() : <any>undefined;
        data["loads"] = this.loads;
        data["receivedLoads"] = this.receivedLoads;
        return data;
    }
}

export interface IBatchQueryResultViewModel {
    uniqueId?: string;
    identification?: string | undefined;
    name?: string | undefined;
    status?: BatchStatus;
    sourceSite?: string | undefined;
    fillSite?: string | undefined;
    submittedBy?: string | undefined;
    startedDate?: Date | undefined;
    loads?: number;
    receivedLoads?: number;
}

export class BatchReassignFillSiteQPCommand implements IBatchReassignFillSiteQPCommand {
    uniqueId?: string;
    fillSiteQPUniqueId?: string;

    constructor(data?: IBatchReassignFillSiteQPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.fillSiteQPUniqueId = _data["fillSiteQPUniqueId"];
        }
    }

    static fromJS(data: any): BatchReassignFillSiteQPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReassignFillSiteQPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["fillSiteQPUniqueId"] = this.fillSiteQPUniqueId;
        return data;
    }
}

export interface IBatchReassignFillSiteQPCommand {
    uniqueId?: string;
    fillSiteQPUniqueId?: string;
}

export class BatchReassignFillSiteUserCommand implements IBatchReassignFillSiteUserCommand {
    uniqueId?: string;
    fillSiteUserUniqueId?: string;

    constructor(data?: IBatchReassignFillSiteUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.fillSiteUserUniqueId = _data["fillSiteUserUniqueId"];
        }
    }

    static fromJS(data: any): BatchReassignFillSiteUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReassignFillSiteUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["fillSiteUserUniqueId"] = this.fillSiteUserUniqueId;
        return data;
    }
}

export interface IBatchReassignFillSiteUserCommand {
    uniqueId?: string;
    fillSiteUserUniqueId?: string;
}

export class BatchReassignSourceSiteQPCommand implements IBatchReassignSourceSiteQPCommand {
    uniqueId?: string;
    sourceSiteQPUniqueId?: string;

    constructor(data?: IBatchReassignSourceSiteQPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.sourceSiteQPUniqueId = _data["sourceSiteQPUniqueId"];
        }
    }

    static fromJS(data: any): BatchReassignSourceSiteQPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReassignSourceSiteQPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["sourceSiteQPUniqueId"] = this.sourceSiteQPUniqueId;
        return data;
    }
}

export interface IBatchReassignSourceSiteQPCommand {
    uniqueId?: string;
    sourceSiteQPUniqueId?: string;
}

export class BatchReassignSourceSiteUserCommand implements IBatchReassignSourceSiteUserCommand {
    uniqueId?: string;
    sourceSiteUserUniqueId?: string;

    constructor(data?: IBatchReassignSourceSiteUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.sourceSiteUserUniqueId = _data["sourceSiteUserUniqueId"];
        }
    }

    static fromJS(data: any): BatchReassignSourceSiteUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReassignSourceSiteUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["sourceSiteUserUniqueId"] = this.sourceSiteUserUniqueId;
        return data;
    }
}

export interface IBatchReassignSourceSiteUserCommand {
    uniqueId?: string;
    sourceSiteUserUniqueId?: string;
}

export class BatchReconciliationViewModel implements IBatchReconciliationViewModel {
    load?: BatchLoadReconciliationViewModel | undefined;
    weight?: BatchWeightReconciliationViewModel | undefined;

    constructor(data?: IBatchReconciliationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.load = _data["load"] ? BatchLoadReconciliationViewModel.fromJS(_data["load"]) : <any>undefined;
            this.weight = _data["weight"] ? BatchWeightReconciliationViewModel.fromJS(_data["weight"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BatchReconciliationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReconciliationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["load"] = this.load ? this.load.toJSON() : <any>undefined;
        data["weight"] = this.weight ? this.weight.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBatchReconciliationViewModel {
    load?: BatchLoadReconciliationViewModel | undefined;
    weight?: BatchWeightReconciliationViewModel | undefined;
}

export class BatchReleaseESVRCommand implements IBatchReleaseESVRCommand {
    uniqueId?: string;

    constructor(data?: IBatchReleaseESVRCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): BatchReleaseESVRCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BatchReleaseESVRCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        return data;
    }
}

export interface IBatchReleaseESVRCommand {
    uniqueId?: string;
}

export class BatchSearchViewModel implements IBatchSearchViewModel {
    uniqueId?: string;
    name?: string | undefined;
    status?: BatchStatus;
    loads?: number;
    weight?: number;
    invoicedLoads?: number;
    invoicedWeight?: number;
    lastInvoiceDate?: Date | undefined;
    transferred?: number;
    rejected?: number;
    remaining?: number;
    submittedDate?: Date | undefined;
    submittedBy?: string | undefined;
    startedDate?: Date | undefined;
    sourceSite?: string | undefined;
    fillSiteUniqueId?: string;
    fillSite?: string | undefined;
    fillSiteQPUniqueId?: string | undefined;
    fillSiteTPQPUniqueId?: string | undefined;
    sourceSiteUser?: string | undefined;
    sourceSiteQP?: string | undefined;
    fillSiteUser?: string | undefined;
    fillSiteQP?: string | undefined;
    fillSiteQPUser?: string | undefined;
    fillSiteTPQP?: string | undefined;
    fillSiteTPQPUser?: string | undefined;
    isFavorite?: boolean;

    constructor(data?: IBatchSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.loads = _data["loads"];
            this.weight = _data["weight"];
            this.invoicedLoads = _data["invoicedLoads"];
            this.invoicedWeight = _data["invoicedWeight"];
            this.lastInvoiceDate = _data["lastInvoiceDate"] ? new Date(_data["lastInvoiceDate"].toString()) : <any>undefined;
            this.transferred = _data["transferred"];
            this.rejected = _data["rejected"];
            this.remaining = _data["remaining"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.submittedBy = _data["submittedBy"];
            this.startedDate = _data["startedDate"] ? new Date(_data["startedDate"].toString()) : <any>undefined;
            this.sourceSite = _data["sourceSite"];
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
            this.fillSite = _data["fillSite"];
            this.fillSiteQPUniqueId = _data["fillSiteQPUniqueId"];
            this.fillSiteTPQPUniqueId = _data["fillSiteTPQPUniqueId"];
            this.sourceSiteUser = _data["sourceSiteUser"];
            this.sourceSiteQP = _data["sourceSiteQP"];
            this.fillSiteUser = _data["fillSiteUser"];
            this.fillSiteQP = _data["fillSiteQP"];
            this.fillSiteQPUser = _data["fillSiteQPUser"];
            this.fillSiteTPQP = _data["fillSiteTPQP"];
            this.fillSiteTPQPUser = _data["fillSiteTPQPUser"];
            this.isFavorite = _data["isFavorite"];
        }
    }

    static fromJS(data: any): BatchSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["loads"] = this.loads;
        data["weight"] = this.weight;
        data["invoicedLoads"] = this.invoicedLoads;
        data["invoicedWeight"] = this.invoicedWeight;
        data["lastInvoiceDate"] = this.lastInvoiceDate ? this.lastInvoiceDate.toISOString() : <any>undefined;
        data["transferred"] = this.transferred;
        data["rejected"] = this.rejected;
        data["remaining"] = this.remaining;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["submittedBy"] = this.submittedBy;
        data["startedDate"] = this.startedDate ? this.startedDate.toISOString() : <any>undefined;
        data["sourceSite"] = this.sourceSite;
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        data["fillSite"] = this.fillSite;
        data["fillSiteQPUniqueId"] = this.fillSiteQPUniqueId;
        data["fillSiteTPQPUniqueId"] = this.fillSiteTPQPUniqueId;
        data["sourceSiteUser"] = this.sourceSiteUser;
        data["sourceSiteQP"] = this.sourceSiteQP;
        data["fillSiteUser"] = this.fillSiteUser;
        data["fillSiteQP"] = this.fillSiteQP;
        data["fillSiteQPUser"] = this.fillSiteQPUser;
        data["fillSiteTPQP"] = this.fillSiteTPQP;
        data["fillSiteTPQPUser"] = this.fillSiteTPQPUser;
        data["isFavorite"] = this.isFavorite;
        return data;
    }
}

export interface IBatchSearchViewModel {
    uniqueId?: string;
    name?: string | undefined;
    status?: BatchStatus;
    loads?: number;
    weight?: number;
    invoicedLoads?: number;
    invoicedWeight?: number;
    lastInvoiceDate?: Date | undefined;
    transferred?: number;
    rejected?: number;
    remaining?: number;
    submittedDate?: Date | undefined;
    submittedBy?: string | undefined;
    startedDate?: Date | undefined;
    sourceSite?: string | undefined;
    fillSiteUniqueId?: string;
    fillSite?: string | undefined;
    fillSiteQPUniqueId?: string | undefined;
    fillSiteTPQPUniqueId?: string | undefined;
    sourceSiteUser?: string | undefined;
    sourceSiteQP?: string | undefined;
    fillSiteUser?: string | undefined;
    fillSiteQP?: string | undefined;
    fillSiteQPUser?: string | undefined;
    fillSiteTPQP?: string | undefined;
    fillSiteTPQPUser?: string | undefined;
    isFavorite?: boolean;
}

export class BatchSearchViewModelBatchTotalTypePagedResultResponse implements IBatchSearchViewModelBatchTotalTypePagedResultResponse {
    totals?: BatchTotalTypeITotal[] | undefined;
    records?: BatchSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IBatchSearchViewModelBatchTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(BatchTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(BatchSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): BatchSearchViewModelBatchTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSearchViewModelBatchTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IBatchSearchViewModelBatchTotalTypePagedResultResponse {
    totals?: BatchTotalTypeITotal[] | undefined;
    records?: BatchSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class BatchSoilQualityTypeViewModel implements IBatchSoilQualityTypeViewModel {
    uniqueId?: string;
    soilQualityType?: SoilQualityType;

    constructor(data?: IBatchSoilQualityTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.soilQualityType = _data["soilQualityType"];
        }
    }

    static fromJS(data: any): BatchSoilQualityTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchSoilQualityTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["soilQualityType"] = this.soilQualityType;
        return data;
    }
}

export interface IBatchSoilQualityTypeViewModel {
    uniqueId?: string;
    soilQualityType?: SoilQualityType;
}

export enum BatchStatus {
    New = "New",
    Draft = "Draft",
    FillSitePending = "FillSitePending",
    FillSiteInReview = "FillSiteInReview",
    FillSiteRejected = "FillSiteRejected",
    QPPending = "QPPending",
    QPInReview = "QPInReview",
    QPRejected = "QPRejected",
    Approved = "Approved",
    Inprogress = "Inprogress",
    BatchExtraPending = "BatchExtraPending",
    Complete = "Complete",
    Archive = "Archive",
    TPQPPending = "TPQPPending",
    TPQPInReview = "TPQPInReview",
    TPQPRejected = "TPQPRejected",
    TPQPApproved = "TPQPApproved",
}

export class BatchStatusCountViewModel implements IBatchStatusCountViewModel {
    status?: BatchTotalType;
    count?: number | undefined;

    constructor(data?: IBatchStatusCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): BatchStatusCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchStatusCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IBatchStatusCountViewModel {
    status?: BatchTotalType;
    count?: number | undefined;
}

export class BatchStatusOverviewViewModel implements IBatchStatusOverviewViewModel {
    all?: BatchStatusCountViewModel[] | undefined;
    myBatches?: BatchStatusCountViewModel[] | undefined;
    archive?: BatchStatusCountViewModel[] | undefined;

    constructor(data?: IBatchStatusOverviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["all"])) {
                this.all = [] as any;
                for (let item of _data["all"])
                    this.all!.push(BatchStatusCountViewModel.fromJS(item));
            }
            if (Array.isArray(_data["myBatches"])) {
                this.myBatches = [] as any;
                for (let item of _data["myBatches"])
                    this.myBatches!.push(BatchStatusCountViewModel.fromJS(item));
            }
            if (Array.isArray(_data["archive"])) {
                this.archive = [] as any;
                for (let item of _data["archive"])
                    this.archive!.push(BatchStatusCountViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BatchStatusOverviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchStatusOverviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.all)) {
            data["all"] = [];
            for (let item of this.all)
                data["all"].push(item.toJSON());
        }
        if (Array.isArray(this.myBatches)) {
            data["myBatches"] = [];
            for (let item of this.myBatches)
                data["myBatches"].push(item.toJSON());
        }
        if (Array.isArray(this.archive)) {
            data["archive"] = [];
            for (let item of this.archive)
                data["archive"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBatchStatusOverviewViewModel {
    all?: BatchStatusCountViewModel[] | undefined;
    myBatches?: BatchStatusCountViewModel[] | undefined;
    archive?: BatchStatusCountViewModel[] | undefined;
}

export enum BatchTotalType {
    Draft = "Draft",
    PendingRequest = "PendingRequest",
    Approved = "Approved",
    Inprogress = "Inprogress",
    Rejected = "Rejected",
    Completed = "Completed",
    Archive = "Archive",
    AllStatus = "AllStatus",
}

export class BatchTotalTypeITotal implements IBatchTotalTypeITotal {
    type?: BatchTotalType;
    value?: number | undefined;

    constructor(data?: IBatchTotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BatchTotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new BatchTotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IBatchTotalTypeITotal {
    type?: BatchTotalType;
    value?: number | undefined;
}

export class BatchViewModel implements IBatchViewModel {
    identification?: string | undefined;
    sourceSiteUser?: UserViewModel | undefined;
    sourceSiteQP?: QualifiedPersonViewModel | undefined;
    sourceSite?: SourceSiteViewModel | undefined;
    fillSiteUser?: UserViewModel | undefined;
    submittedByUser?: UserViewModel | undefined;
    fillSite?: FillSiteViewModel | undefined;
    fillSiteQP?: QualifiedPersonViewModel | undefined;
    fillSiteTPQP?: QualifiedPersonViewModel | undefined;
    fillSiteQPUserUniqueId?: string | undefined;
    sourceSiteQPUserUniqueId?: string | undefined;
    fillSiteTPQPUserUniqueId?: string | undefined;
    fillSiteQPUser?: UserViewModel | undefined;
    fillSiteTPQPUser?: UserViewModel | undefined;
    isESVRReleased?: boolean | undefined;
    unitPrice?: number;
    invoiceType?: InvoiceType;
    approvedLoads?: number;
    approvedWeight?: number;
    rejectionComments?: string | undefined;
    maxEsvrIndex?: number | undefined;
    companyUniqueId?: string;
    companyName?: string | undefined;
    pendingApprovalBatchExtraUniqueId?: string | undefined;
    pendingESVRReleaseBatchExtraUniqueId?: string | undefined;
    soilQualityTypes?: BatchSoilQualityTypeViewModel[] | undefined;
    analysisParameters?: BatchAnalysisParameterViewModel[] | undefined;
    isqpAdminForSourceSite?: boolean;
    isqpAdminForFillSite?: boolean;
    uniqueId?: string;
    name?: string | undefined;
    status?: BatchStatus;
    estimatedStartDate?: Date | undefined;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    sourceSiteUniqueId?: string | undefined;
    sourceType?: SourceType | undefined;
    sourceTypeOther?: string | undefined;
    sourceSiteHistory?: SourceSiteType | undefined;
    sourceSiteHistoryOther?: string | undefined;
    sourceSitePresentUse?: string | undefined;
    sourceSiteAddress?: string | undefined;
    sourceSiteUserUniqueId?: string | undefined;
    sourceSiteQPUniqueId?: string | undefined;
    soilDescriptionType?: SoilDescriptionType | undefined;
    soilAnalysisNotDone?: boolean | undefined;
    analysisParameterOther?: string | undefined;
    fillSiteUniqueId?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IBatchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identification = _data["identification"];
            this.sourceSiteUser = _data["sourceSiteUser"] ? UserViewModel.fromJS(_data["sourceSiteUser"]) : <any>undefined;
            this.sourceSiteQP = _data["sourceSiteQP"] ? QualifiedPersonViewModel.fromJS(_data["sourceSiteQP"]) : <any>undefined;
            this.sourceSite = _data["sourceSite"] ? SourceSiteViewModel.fromJS(_data["sourceSite"]) : <any>undefined;
            this.fillSiteUser = _data["fillSiteUser"] ? UserViewModel.fromJS(_data["fillSiteUser"]) : <any>undefined;
            this.submittedByUser = _data["submittedByUser"] ? UserViewModel.fromJS(_data["submittedByUser"]) : <any>undefined;
            this.fillSite = _data["fillSite"] ? FillSiteViewModel.fromJS(_data["fillSite"]) : <any>undefined;
            this.fillSiteQP = _data["fillSiteQP"] ? QualifiedPersonViewModel.fromJS(_data["fillSiteQP"]) : <any>undefined;
            this.fillSiteTPQP = _data["fillSiteTPQP"] ? QualifiedPersonViewModel.fromJS(_data["fillSiteTPQP"]) : <any>undefined;
            this.fillSiteQPUserUniqueId = _data["fillSiteQPUserUniqueId"];
            this.sourceSiteQPUserUniqueId = _data["sourceSiteQPUserUniqueId"];
            this.fillSiteTPQPUserUniqueId = _data["fillSiteTPQPUserUniqueId"];
            this.fillSiteQPUser = _data["fillSiteQPUser"] ? UserViewModel.fromJS(_data["fillSiteQPUser"]) : <any>undefined;
            this.fillSiteTPQPUser = _data["fillSiteTPQPUser"] ? UserViewModel.fromJS(_data["fillSiteTPQPUser"]) : <any>undefined;
            this.isESVRReleased = _data["isESVRReleased"];
            this.unitPrice = _data["unitPrice"];
            this.invoiceType = _data["invoiceType"];
            this.approvedLoads = _data["approvedLoads"];
            this.approvedWeight = _data["approvedWeight"];
            this.rejectionComments = _data["rejectionComments"];
            this.maxEsvrIndex = _data["maxEsvrIndex"];
            this.companyUniqueId = _data["companyUniqueId"];
            this.companyName = _data["companyName"];
            this.pendingApprovalBatchExtraUniqueId = _data["pendingApprovalBatchExtraUniqueId"];
            this.pendingESVRReleaseBatchExtraUniqueId = _data["pendingESVRReleaseBatchExtraUniqueId"];
            if (Array.isArray(_data["soilQualityTypes"])) {
                this.soilQualityTypes = [] as any;
                for (let item of _data["soilQualityTypes"])
                    this.soilQualityTypes!.push(BatchSoilQualityTypeViewModel.fromJS(item));
            }
            if (Array.isArray(_data["analysisParameters"])) {
                this.analysisParameters = [] as any;
                for (let item of _data["analysisParameters"])
                    this.analysisParameters!.push(BatchAnalysisParameterViewModel.fromJS(item));
            }
            this.isqpAdminForSourceSite = _data["isqpAdminForSourceSite"];
            this.isqpAdminForFillSite = _data["isqpAdminForFillSite"];
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.estimatedStartDate = _data["estimatedStartDate"] ? new Date(_data["estimatedStartDate"].toString()) : <any>undefined;
            this.estimatedLoads = _data["estimatedLoads"];
            this.estimatedWeight = _data["estimatedWeight"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.sourceSiteUniqueId = _data["sourceSiteUniqueId"];
            this.sourceType = _data["sourceType"];
            this.sourceTypeOther = _data["sourceTypeOther"];
            this.sourceSiteHistory = _data["sourceSiteHistory"];
            this.sourceSiteHistoryOther = _data["sourceSiteHistoryOther"];
            this.sourceSitePresentUse = _data["sourceSitePresentUse"];
            this.sourceSiteAddress = _data["sourceSiteAddress"];
            this.sourceSiteUserUniqueId = _data["sourceSiteUserUniqueId"];
            this.sourceSiteQPUniqueId = _data["sourceSiteQPUniqueId"];
            this.soilDescriptionType = _data["soilDescriptionType"];
            this.soilAnalysisNotDone = _data["soilAnalysisNotDone"];
            this.analysisParameterOther = _data["analysisParameterOther"];
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): BatchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identification"] = this.identification;
        data["sourceSiteUser"] = this.sourceSiteUser ? this.sourceSiteUser.toJSON() : <any>undefined;
        data["sourceSiteQP"] = this.sourceSiteQP ? this.sourceSiteQP.toJSON() : <any>undefined;
        data["sourceSite"] = this.sourceSite ? this.sourceSite.toJSON() : <any>undefined;
        data["fillSiteUser"] = this.fillSiteUser ? this.fillSiteUser.toJSON() : <any>undefined;
        data["submittedByUser"] = this.submittedByUser ? this.submittedByUser.toJSON() : <any>undefined;
        data["fillSite"] = this.fillSite ? this.fillSite.toJSON() : <any>undefined;
        data["fillSiteQP"] = this.fillSiteQP ? this.fillSiteQP.toJSON() : <any>undefined;
        data["fillSiteTPQP"] = this.fillSiteTPQP ? this.fillSiteTPQP.toJSON() : <any>undefined;
        data["fillSiteQPUserUniqueId"] = this.fillSiteQPUserUniqueId;
        data["sourceSiteQPUserUniqueId"] = this.sourceSiteQPUserUniqueId;
        data["fillSiteTPQPUserUniqueId"] = this.fillSiteTPQPUserUniqueId;
        data["fillSiteQPUser"] = this.fillSiteQPUser ? this.fillSiteQPUser.toJSON() : <any>undefined;
        data["fillSiteTPQPUser"] = this.fillSiteTPQPUser ? this.fillSiteTPQPUser.toJSON() : <any>undefined;
        data["isESVRReleased"] = this.isESVRReleased;
        data["unitPrice"] = this.unitPrice;
        data["invoiceType"] = this.invoiceType;
        data["approvedLoads"] = this.approvedLoads;
        data["approvedWeight"] = this.approvedWeight;
        data["rejectionComments"] = this.rejectionComments;
        data["maxEsvrIndex"] = this.maxEsvrIndex;
        data["companyUniqueId"] = this.companyUniqueId;
        data["companyName"] = this.companyName;
        data["pendingApprovalBatchExtraUniqueId"] = this.pendingApprovalBatchExtraUniqueId;
        data["pendingESVRReleaseBatchExtraUniqueId"] = this.pendingESVRReleaseBatchExtraUniqueId;
        if (Array.isArray(this.soilQualityTypes)) {
            data["soilQualityTypes"] = [];
            for (let item of this.soilQualityTypes)
                data["soilQualityTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.analysisParameters)) {
            data["analysisParameters"] = [];
            for (let item of this.analysisParameters)
                data["analysisParameters"].push(item.toJSON());
        }
        data["isqpAdminForSourceSite"] = this.isqpAdminForSourceSite;
        data["isqpAdminForFillSite"] = this.isqpAdminForFillSite;
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["estimatedStartDate"] = this.estimatedStartDate ? this.estimatedStartDate.toISOString() : <any>undefined;
        data["estimatedLoads"] = this.estimatedLoads;
        data["estimatedWeight"] = this.estimatedWeight;
        data["estimatedVolume"] = this.estimatedVolume;
        data["sourceSiteUniqueId"] = this.sourceSiteUniqueId;
        data["sourceType"] = this.sourceType;
        data["sourceTypeOther"] = this.sourceTypeOther;
        data["sourceSiteHistory"] = this.sourceSiteHistory;
        data["sourceSiteHistoryOther"] = this.sourceSiteHistoryOther;
        data["sourceSitePresentUse"] = this.sourceSitePresentUse;
        data["sourceSiteAddress"] = this.sourceSiteAddress;
        data["sourceSiteUserUniqueId"] = this.sourceSiteUserUniqueId;
        data["sourceSiteQPUniqueId"] = this.sourceSiteQPUniqueId;
        data["soilDescriptionType"] = this.soilDescriptionType;
        data["soilAnalysisNotDone"] = this.soilAnalysisNotDone;
        data["analysisParameterOther"] = this.analysisParameterOther;
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IBatchViewModel {
    identification?: string | undefined;
    sourceSiteUser?: UserViewModel | undefined;
    sourceSiteQP?: QualifiedPersonViewModel | undefined;
    sourceSite?: SourceSiteViewModel | undefined;
    fillSiteUser?: UserViewModel | undefined;
    submittedByUser?: UserViewModel | undefined;
    fillSite?: FillSiteViewModel | undefined;
    fillSiteQP?: QualifiedPersonViewModel | undefined;
    fillSiteTPQP?: QualifiedPersonViewModel | undefined;
    fillSiteQPUserUniqueId?: string | undefined;
    sourceSiteQPUserUniqueId?: string | undefined;
    fillSiteTPQPUserUniqueId?: string | undefined;
    fillSiteQPUser?: UserViewModel | undefined;
    fillSiteTPQPUser?: UserViewModel | undefined;
    isESVRReleased?: boolean | undefined;
    unitPrice?: number;
    invoiceType?: InvoiceType;
    approvedLoads?: number;
    approvedWeight?: number;
    rejectionComments?: string | undefined;
    maxEsvrIndex?: number | undefined;
    companyUniqueId?: string;
    companyName?: string | undefined;
    pendingApprovalBatchExtraUniqueId?: string | undefined;
    pendingESVRReleaseBatchExtraUniqueId?: string | undefined;
    soilQualityTypes?: BatchSoilQualityTypeViewModel[] | undefined;
    analysisParameters?: BatchAnalysisParameterViewModel[] | undefined;
    isqpAdminForSourceSite?: boolean;
    isqpAdminForFillSite?: boolean;
    uniqueId?: string;
    name?: string | undefined;
    status?: BatchStatus;
    estimatedStartDate?: Date | undefined;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    sourceSiteUniqueId?: string | undefined;
    sourceType?: SourceType | undefined;
    sourceTypeOther?: string | undefined;
    sourceSiteHistory?: SourceSiteType | undefined;
    sourceSiteHistoryOther?: string | undefined;
    sourceSitePresentUse?: string | undefined;
    sourceSiteAddress?: string | undefined;
    sourceSiteUserUniqueId?: string | undefined;
    sourceSiteQPUniqueId?: string | undefined;
    soilDescriptionType?: SoilDescriptionType | undefined;
    soilAnalysisNotDone?: boolean | undefined;
    analysisParameterOther?: string | undefined;
    fillSiteUniqueId?: string | undefined;
    comments?: string | undefined;
}

export class BatchWeightReconciliationViewModel implements IBatchWeightReconciliationViewModel {
    totalWeight?: number;
    extra?: number;
    transferred?: number;
    remaining?: number;

    constructor(data?: IBatchWeightReconciliationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWeight = _data["totalWeight"];
            this.extra = _data["extra"];
            this.transferred = _data["transferred"];
            this.remaining = _data["remaining"];
        }
    }

    static fromJS(data: any): BatchWeightReconciliationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BatchWeightReconciliationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWeight"] = this.totalWeight;
        data["extra"] = this.extra;
        data["transferred"] = this.transferred;
        data["remaining"] = this.remaining;
        return data;
    }
}

export interface IBatchWeightReconciliationViewModel {
    totalWeight?: number;
    extra?: number;
    transferred?: number;
    remaining?: number;
}

export class CleanFillGroupPolicyViewModel implements ICleanFillGroupPolicyViewModel {
    uniqueId?: string;
    cleanFillGroupUniqueId?: string;
    cleanFillPolicyUniqueId?: string;
    cleanFillPolicy?: CleanFillPolicyViewModel | undefined;

    constructor(data?: ICleanFillGroupPolicyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.cleanFillGroupUniqueId = _data["cleanFillGroupUniqueId"];
            this.cleanFillPolicyUniqueId = _data["cleanFillPolicyUniqueId"];
            this.cleanFillPolicy = _data["cleanFillPolicy"] ? CleanFillPolicyViewModel.fromJS(_data["cleanFillPolicy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CleanFillGroupPolicyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CleanFillGroupPolicyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["cleanFillGroupUniqueId"] = this.cleanFillGroupUniqueId;
        data["cleanFillPolicyUniqueId"] = this.cleanFillPolicyUniqueId;
        data["cleanFillPolicy"] = this.cleanFillPolicy ? this.cleanFillPolicy.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICleanFillGroupPolicyViewModel {
    uniqueId?: string;
    cleanFillGroupUniqueId?: string;
    cleanFillPolicyUniqueId?: string;
    cleanFillPolicy?: CleanFillPolicyViewModel | undefined;
}

export class CleanFillGroupViewModel implements ICleanFillGroupViewModel {
    uniqueId?: string;
    cleanFillGroupPolicies?: CleanFillGroupPolicyViewModel[] | undefined;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICleanFillGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            if (Array.isArray(_data["cleanFillGroupPolicies"])) {
                this.cleanFillGroupPolicies = [] as any;
                for (let item of _data["cleanFillGroupPolicies"])
                    this.cleanFillGroupPolicies!.push(CleanFillGroupPolicyViewModel.fromJS(item));
            }
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CleanFillGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CleanFillGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        if (Array.isArray(this.cleanFillGroupPolicies)) {
            data["cleanFillGroupPolicies"] = [];
            for (let item of this.cleanFillGroupPolicies)
                data["cleanFillGroupPolicies"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ICleanFillGroupViewModel {
    uniqueId?: string;
    cleanFillGroupPolicies?: CleanFillGroupPolicyViewModel[] | undefined;
    code?: string | undefined;
    name?: string | undefined;
}

export enum CleanFillPolicyCategory {
    Batch = "Batch",
    ESVR = "ESVR",
    Invoice = "Invoice",
    PO = "PO",
    Profile = "Profile",
    Report = "Report",
    SourceSite = "SourceSite",
    User = "User",
    FillSite = "FillSite",
    Inspection = "Inspection",
    Dashboard = "Dashboard",
    LegalEntity = "LegalEntity",
    QPInvitation = "QPInvitation",
    Hauler = "Hauler",
}

export class CleanFillPolicyViewModel implements ICleanFillPolicyViewModel {
    uniqueId?: string;
    name?: string | undefined;
    category?: CleanFillPolicyCategory;

    constructor(data?: ICleanFillPolicyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): CleanFillPolicyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CleanFillPolicyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["category"] = this.category;
        return data;
    }
}

export interface ICleanFillPolicyViewModel {
    uniqueId?: string;
    name?: string | undefined;
    category?: CleanFillPolicyCategory;
}

export class CleanFillUserGroupViewModel implements ICleanFillUserGroupViewModel {
    uniqueId?: string;
    cleanFillGroupUniqueId?: string;
    cleanFillUserUniqueId?: string;
    legalEntityUniqueId?: string;
    cleanFillGroup?: CleanFillGroupViewModel | undefined;
    legalEntity?: LegalEntityViewModel | undefined;

    constructor(data?: ICleanFillUserGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.cleanFillGroupUniqueId = _data["cleanFillGroupUniqueId"];
            this.cleanFillUserUniqueId = _data["cleanFillUserUniqueId"];
            this.legalEntityUniqueId = _data["legalEntityUniqueId"];
            this.cleanFillGroup = _data["cleanFillGroup"] ? CleanFillGroupViewModel.fromJS(_data["cleanFillGroup"]) : <any>undefined;
            this.legalEntity = _data["legalEntity"] ? LegalEntityViewModel.fromJS(_data["legalEntity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CleanFillUserGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CleanFillUserGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["cleanFillGroupUniqueId"] = this.cleanFillGroupUniqueId;
        data["cleanFillUserUniqueId"] = this.cleanFillUserUniqueId;
        data["legalEntityUniqueId"] = this.legalEntityUniqueId;
        data["cleanFillGroup"] = this.cleanFillGroup ? this.cleanFillGroup.toJSON() : <any>undefined;
        data["legalEntity"] = this.legalEntity ? this.legalEntity.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICleanFillUserGroupViewModel {
    uniqueId?: string;
    cleanFillGroupUniqueId?: string;
    cleanFillUserUniqueId?: string;
    legalEntityUniqueId?: string;
    cleanFillGroup?: CleanFillGroupViewModel | undefined;
    legalEntity?: LegalEntityViewModel | undefined;
}

export class CleanFillUserPolicyViewModel implements ICleanFillUserPolicyViewModel {
    uniqueId?: string;
    cleanFillPolicyUniqueId?: string;
    cleanFillUserUniqueId?: string;
    legalEntityUniqueId?: string;
    cleanFillPolicy?: CleanFillPolicyViewModel | undefined;
    legalEntity?: LegalEntityViewModel | undefined;

    constructor(data?: ICleanFillUserPolicyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.cleanFillPolicyUniqueId = _data["cleanFillPolicyUniqueId"];
            this.cleanFillUserUniqueId = _data["cleanFillUserUniqueId"];
            this.legalEntityUniqueId = _data["legalEntityUniqueId"];
            this.cleanFillPolicy = _data["cleanFillPolicy"] ? CleanFillPolicyViewModel.fromJS(_data["cleanFillPolicy"]) : <any>undefined;
            this.legalEntity = _data["legalEntity"] ? LegalEntityViewModel.fromJS(_data["legalEntity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CleanFillUserPolicyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CleanFillUserPolicyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["cleanFillPolicyUniqueId"] = this.cleanFillPolicyUniqueId;
        data["cleanFillUserUniqueId"] = this.cleanFillUserUniqueId;
        data["legalEntityUniqueId"] = this.legalEntityUniqueId;
        data["cleanFillPolicy"] = this.cleanFillPolicy ? this.cleanFillPolicy.toJSON() : <any>undefined;
        data["legalEntity"] = this.legalEntity ? this.legalEntity.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICleanFillUserPolicyViewModel {
    uniqueId?: string;
    cleanFillPolicyUniqueId?: string;
    cleanFillUserUniqueId?: string;
    legalEntityUniqueId?: string;
    cleanFillPolicy?: CleanFillPolicyViewModel | undefined;
    legalEntity?: LegalEntityViewModel | undefined;
}

export enum CleanFillUserStatus {
    Active = "Active",
    PendingVerification = "PendingVerification",
    Deactivated = "Deactivated",
    PendingSetUp = "PendingSetUp",
}

export enum CleanFillUserTotalType {
    Active = "Active",
    Pending = "Pending",
    Deactivated = "Deactivated",
    AllStatus = "AllStatus",
}

export class CleanFillUserTotalTypeITotal implements ICleanFillUserTotalTypeITotal {
    type?: CleanFillUserTotalType;
    value?: number | undefined;

    constructor(data?: ICleanFillUserTotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CleanFillUserTotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new CleanFillUserTotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ICleanFillUserTotalTypeITotal {
    type?: CleanFillUserTotalType;
    value?: number | undefined;
}

export enum CompanyQPTotalType {
    PendingRequest = "PendingRequest",
    Active = "Active",
    Rejected = "Rejected",
    AllStatus = "AllStatus",
}

export class CompanyQPTotalTypeITotal implements ICompanyQPTotalTypeITotal {
    type?: CompanyQPTotalType;
    value?: number | undefined;

    constructor(data?: ICompanyQPTotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CompanyQPTotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyQPTotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ICompanyQPTotalTypeITotal {
    type?: CompanyQPTotalType;
    value?: number | undefined;
}

export class CompanyQPViewModel implements ICompanyQPViewModel {
    uniqueId?: string;
    modifiedDate?: Date;
    companyUniqueId?: string;
    qpName?: string | undefined;
    qpEmail?: string | undefined;
    qpUniqueId?: string;
    sourceSiteNames?: string | undefined;
    fillSiteNames?: string | undefined;
    assignedFillSites?: number | undefined;
    assignedSourceSites?: number | undefined;
    assignedSites?: number | undefined;
    status?: CompanyQPTotalType;
    permission?: string | undefined;
    isAdmin?: boolean;
    ssCount?: number | undefined;
    fsCount?: number | undefined;
    companyType?: CompanyType;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;

    constructor(data?: ICompanyQPViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.companyUniqueId = _data["companyUniqueId"];
            this.qpName = _data["qpName"];
            this.qpEmail = _data["qpEmail"];
            this.qpUniqueId = _data["qpUniqueId"];
            this.sourceSiteNames = _data["sourceSiteNames"];
            this.fillSiteNames = _data["fillSiteNames"];
            this.assignedFillSites = _data["assignedFillSites"];
            this.assignedSourceSites = _data["assignedSourceSites"];
            this.assignedSites = _data["assignedSites"];
            this.status = _data["status"];
            this.permission = _data["permission"];
            this.isAdmin = _data["isAdmin"];
            this.ssCount = _data["ssCount"];
            this.fsCount = _data["fsCount"];
            this.companyType = _data["companyType"];
            this.companyName = _data["companyName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): CompanyQPViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyQPViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["companyUniqueId"] = this.companyUniqueId;
        data["qpName"] = this.qpName;
        data["qpEmail"] = this.qpEmail;
        data["qpUniqueId"] = this.qpUniqueId;
        data["sourceSiteNames"] = this.sourceSiteNames;
        data["fillSiteNames"] = this.fillSiteNames;
        data["assignedFillSites"] = this.assignedFillSites;
        data["assignedSourceSites"] = this.assignedSourceSites;
        data["assignedSites"] = this.assignedSites;
        data["status"] = this.status;
        data["permission"] = this.permission;
        data["isAdmin"] = this.isAdmin;
        data["ssCount"] = this.ssCount;
        data["fsCount"] = this.fsCount;
        data["companyType"] = this.companyType;
        data["companyName"] = this.companyName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        return data;
    }
}

export interface ICompanyQPViewModel {
    uniqueId?: string;
    modifiedDate?: Date;
    companyUniqueId?: string;
    qpName?: string | undefined;
    qpEmail?: string | undefined;
    qpUniqueId?: string;
    sourceSiteNames?: string | undefined;
    fillSiteNames?: string | undefined;
    assignedFillSites?: number | undefined;
    assignedSourceSites?: number | undefined;
    assignedSites?: number | undefined;
    status?: CompanyQPTotalType;
    permission?: string | undefined;
    isAdmin?: boolean;
    ssCount?: number | undefined;
    fsCount?: number | undefined;
    companyType?: CompanyType;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
}

export class CompanyQPViewModelCompanyQPTotalTypePagedResultResponse implements ICompanyQPViewModelCompanyQPTotalTypePagedResultResponse {
    totals?: CompanyQPTotalTypeITotal[] | undefined;
    records?: CompanyQPViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: ICompanyQPViewModelCompanyQPTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(CompanyQPTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(CompanyQPViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): CompanyQPViewModelCompanyQPTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyQPViewModelCompanyQPTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface ICompanyQPViewModelCompanyQPTotalTypePagedResultResponse {
    totals?: CompanyQPTotalTypeITotal[] | undefined;
    records?: CompanyQPViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class CompanySearchViewModel implements ICompanySearchViewModel {
    id?: number;
    name?: string | undefined;
    uniqueId?: string;
    phoneNumber?: string | undefined;

    constructor(data?: ICompanySearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.uniqueId = _data["uniqueId"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): CompanySearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanySearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["uniqueId"] = this.uniqueId;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ICompanySearchViewModel {
    id?: number;
    name?: string | undefined;
    uniqueId?: string;
    phoneNumber?: string | undefined;
}

export enum CompanyType {
    Source = "Source",
    Receiving = "Receiving",
    SourceReceiving = "SourceReceiving",
}

export class CompanyViewModel implements ICompanyViewModel {
    sourceSites?: SourceSiteViewModel[] | undefined;
    fillSites?: FillSiteViewModel[] | undefined;
    legalEntityType?: LegalEntityType;
    isAdminForClient?: boolean;
    uniqueId?: string;
    billingAsCompanyContact?: boolean | undefined;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    billingContact?: EditContactViewModel | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;

    constructor(data?: ICompanyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sourceSites"])) {
                this.sourceSites = [] as any;
                for (let item of _data["sourceSites"])
                    this.sourceSites!.push(SourceSiteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["fillSites"])) {
                this.fillSites = [] as any;
                for (let item of _data["fillSites"])
                    this.fillSites!.push(FillSiteViewModel.fromJS(item));
            }
            this.legalEntityType = _data["legalEntityType"];
            this.isAdminForClient = _data["isAdminForClient"];
            this.uniqueId = _data["uniqueId"];
            this.billingAsCompanyContact = _data["billingAsCompanyContact"];
            this.address = _data["address"] ? EditAddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? EditContactViewModel.fromJS(_data["contact"]) : <any>undefined;
            this.billingContact = _data["billingContact"] ? EditContactViewModel.fromJS(_data["billingContact"]) : <any>undefined;
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CompanyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceSites)) {
            data["sourceSites"] = [];
            for (let item of this.sourceSites)
                data["sourceSites"].push(item.toJSON());
        }
        if (Array.isArray(this.fillSites)) {
            data["fillSites"] = [];
            for (let item of this.fillSites)
                data["fillSites"].push(item.toJSON());
        }
        data["legalEntityType"] = this.legalEntityType;
        data["isAdminForClient"] = this.isAdminForClient;
        data["uniqueId"] = this.uniqueId;
        data["billingAsCompanyContact"] = this.billingAsCompanyContact;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["billingContact"] = this.billingContact ? this.billingContact.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface ICompanyViewModel {
    sourceSites?: SourceSiteViewModel[] | undefined;
    fillSites?: FillSiteViewModel[] | undefined;
    legalEntityType?: LegalEntityType;
    isAdminForClient?: boolean;
    uniqueId?: string;
    billingAsCompanyContact?: boolean | undefined;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    billingContact?: EditContactViewModel | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;
}

export class ContactViewModel implements IContactViewModel {
    uniqueId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;

    constructor(data?: IContactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): ContactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IContactViewModel {
    uniqueId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
}

export class ContactViewModelBase implements IContactViewModelBase {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;

    constructor(data?: IContactViewModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): ContactViewModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new ContactViewModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IContactViewModelBase {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
}

export class CountryViewModel implements ICountryViewModel {
    provinces?: ProvinceViewModel[] | undefined;
    uniqueId?: string;
    name?: string | undefined;
    threeLetterCode?: string | undefined;
    twoLetterCode?: string | undefined;

    constructor(data?: ICountryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["provinces"])) {
                this.provinces = [] as any;
                for (let item of _data["provinces"])
                    this.provinces!.push(ProvinceViewModel.fromJS(item));
            }
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.threeLetterCode = _data["threeLetterCode"];
            this.twoLetterCode = _data["twoLetterCode"];
        }
    }

    static fromJS(data: any): CountryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.provinces)) {
            data["provinces"] = [];
            for (let item of this.provinces)
                data["provinces"].push(item.toJSON());
        }
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["threeLetterCode"] = this.threeLetterCode;
        data["twoLetterCode"] = this.twoLetterCode;
        return data;
    }
}

export interface ICountryViewModel {
    provinces?: ProvinceViewModel[] | undefined;
    uniqueId?: string;
    name?: string | undefined;
    threeLetterCode?: string | undefined;
    twoLetterCode?: string | undefined;
}

export class CreateBatchCommand implements ICreateBatchCommand {
    companyUniqueId?: string;
    name?: string | undefined;
    status?: BatchStatus;
    estimatedStartDate?: Date | undefined;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    sourceSiteUniqueId?: string | undefined;
    sourceType?: SourceType | undefined;
    sourceTypeOther?: string | undefined;
    sourceSiteHistory?: SourceSiteType | undefined;
    sourceSiteHistoryOther?: string | undefined;
    sourceSitePresentUse?: string | undefined;
    sourceSiteAddress?: string | undefined;
    sourceSiteUserUniqueId?: string | undefined;
    sourceSiteQPUniqueId?: string | undefined;
    soilDescriptionType?: SoilDescriptionType | undefined;
    soilQualityTypes?: SoilQualityType[] | undefined;
    soilAnalysisNotDone?: boolean | undefined;
    analysisParameters?: BatchAnalysisParameterViewModelBase[] | undefined;
    analysisParameterOther?: string | undefined;
    fillSiteUniqueId?: string | undefined;
    comments?: string | undefined;

    constructor(data?: ICreateBatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyUniqueId = _data["companyUniqueId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.estimatedStartDate = _data["estimatedStartDate"] ? new Date(_data["estimatedStartDate"].toString()) : <any>undefined;
            this.estimatedLoads = _data["estimatedLoads"];
            this.estimatedWeight = _data["estimatedWeight"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.sourceSiteUniqueId = _data["sourceSiteUniqueId"];
            this.sourceType = _data["sourceType"];
            this.sourceTypeOther = _data["sourceTypeOther"];
            this.sourceSiteHistory = _data["sourceSiteHistory"];
            this.sourceSiteHistoryOther = _data["sourceSiteHistoryOther"];
            this.sourceSitePresentUse = _data["sourceSitePresentUse"];
            this.sourceSiteAddress = _data["sourceSiteAddress"];
            this.sourceSiteUserUniqueId = _data["sourceSiteUserUniqueId"];
            this.sourceSiteQPUniqueId = _data["sourceSiteQPUniqueId"];
            this.soilDescriptionType = _data["soilDescriptionType"];
            if (Array.isArray(_data["soilQualityTypes"])) {
                this.soilQualityTypes = [] as any;
                for (let item of _data["soilQualityTypes"])
                    this.soilQualityTypes!.push(item);
            }
            this.soilAnalysisNotDone = _data["soilAnalysisNotDone"];
            if (Array.isArray(_data["analysisParameters"])) {
                this.analysisParameters = [] as any;
                for (let item of _data["analysisParameters"])
                    this.analysisParameters!.push(BatchAnalysisParameterViewModelBase.fromJS(item));
            }
            this.analysisParameterOther = _data["analysisParameterOther"];
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateBatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyUniqueId"] = this.companyUniqueId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["estimatedStartDate"] = this.estimatedStartDate ? this.estimatedStartDate.toISOString() : <any>undefined;
        data["estimatedLoads"] = this.estimatedLoads;
        data["estimatedWeight"] = this.estimatedWeight;
        data["estimatedVolume"] = this.estimatedVolume;
        data["sourceSiteUniqueId"] = this.sourceSiteUniqueId;
        data["sourceType"] = this.sourceType;
        data["sourceTypeOther"] = this.sourceTypeOther;
        data["sourceSiteHistory"] = this.sourceSiteHistory;
        data["sourceSiteHistoryOther"] = this.sourceSiteHistoryOther;
        data["sourceSitePresentUse"] = this.sourceSitePresentUse;
        data["sourceSiteAddress"] = this.sourceSiteAddress;
        data["sourceSiteUserUniqueId"] = this.sourceSiteUserUniqueId;
        data["sourceSiteQPUniqueId"] = this.sourceSiteQPUniqueId;
        data["soilDescriptionType"] = this.soilDescriptionType;
        if (Array.isArray(this.soilQualityTypes)) {
            data["soilQualityTypes"] = [];
            for (let item of this.soilQualityTypes)
                data["soilQualityTypes"].push(item);
        }
        data["soilAnalysisNotDone"] = this.soilAnalysisNotDone;
        if (Array.isArray(this.analysisParameters)) {
            data["analysisParameters"] = [];
            for (let item of this.analysisParameters)
                data["analysisParameters"].push(item.toJSON());
        }
        data["analysisParameterOther"] = this.analysisParameterOther;
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateBatchCommand {
    companyUniqueId?: string;
    name?: string | undefined;
    status?: BatchStatus;
    estimatedStartDate?: Date | undefined;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    sourceSiteUniqueId?: string | undefined;
    sourceType?: SourceType | undefined;
    sourceTypeOther?: string | undefined;
    sourceSiteHistory?: SourceSiteType | undefined;
    sourceSiteHistoryOther?: string | undefined;
    sourceSitePresentUse?: string | undefined;
    sourceSiteAddress?: string | undefined;
    sourceSiteUserUniqueId?: string | undefined;
    sourceSiteQPUniqueId?: string | undefined;
    soilDescriptionType?: SoilDescriptionType | undefined;
    soilQualityTypes?: SoilQualityType[] | undefined;
    soilAnalysisNotDone?: boolean | undefined;
    analysisParameters?: BatchAnalysisParameterViewModelBase[] | undefined;
    analysisParameterOther?: string | undefined;
    fillSiteUniqueId?: string | undefined;
    comments?: string | undefined;
}

export class CreateBatchExtraCommand implements ICreateBatchExtraCommand {
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;

    constructor(data?: ICreateBatchExtraCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentBatchUniqueId = _data["parentBatchUniqueId"];
            this.status = _data["status"];
            this.estimatedLoads = _data["estimatedLoads"];
            this.estimatedWeight = _data["estimatedWeight"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateBatchExtraCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBatchExtraCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentBatchUniqueId"] = this.parentBatchUniqueId;
        data["status"] = this.status;
        data["estimatedLoads"] = this.estimatedLoads;
        data["estimatedWeight"] = this.estimatedWeight;
        data["estimatedVolume"] = this.estimatedVolume;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateBatchExtraCommand {
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;
}

export class CreateBatchExtraFSCommand implements ICreateBatchExtraFSCommand {
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;

    constructor(data?: ICreateBatchExtraFSCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentBatchUniqueId = _data["parentBatchUniqueId"];
            this.status = _data["status"];
            this.estimatedLoads = _data["estimatedLoads"];
            this.estimatedWeight = _data["estimatedWeight"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateBatchExtraFSCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBatchExtraFSCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentBatchUniqueId"] = this.parentBatchUniqueId;
        data["status"] = this.status;
        data["estimatedLoads"] = this.estimatedLoads;
        data["estimatedWeight"] = this.estimatedWeight;
        data["estimatedVolume"] = this.estimatedVolume;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateBatchExtraFSCommand {
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;
}

export class CreateCompanyCommand implements ICreateCompanyCommand {
    sourceSites?: CreateSourceSiteViewModel[] | undefined;
    fillSites?: CreateFillSiteViewModel[] | undefined;
    billingAsCompanyContact?: boolean | undefined;
    billingContact?: ContactViewModelBase | undefined;
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;

    constructor(data?: ICreateCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sourceSites"])) {
                this.sourceSites = [] as any;
                for (let item of _data["sourceSites"])
                    this.sourceSites!.push(CreateSourceSiteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["fillSites"])) {
                this.fillSites = [] as any;
                for (let item of _data["fillSites"])
                    this.fillSites!.push(CreateFillSiteViewModel.fromJS(item));
            }
            this.billingAsCompanyContact = _data["billingAsCompanyContact"];
            this.billingContact = _data["billingContact"] ? ContactViewModelBase.fromJS(_data["billingContact"]) : <any>undefined;
            this.address = _data["address"] ? AddressViewModelBase.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? ContactViewModelBase.fromJS(_data["contact"]) : <any>undefined;
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceSites)) {
            data["sourceSites"] = [];
            for (let item of this.sourceSites)
                data["sourceSites"].push(item.toJSON());
        }
        if (Array.isArray(this.fillSites)) {
            data["fillSites"] = [];
            for (let item of this.fillSites)
                data["fillSites"].push(item.toJSON());
        }
        data["billingAsCompanyContact"] = this.billingAsCompanyContact;
        data["billingContact"] = this.billingContact ? this.billingContact.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateCompanyCommand {
    sourceSites?: CreateSourceSiteViewModel[] | undefined;
    fillSites?: CreateFillSiteViewModel[] | undefined;
    billingAsCompanyContact?: boolean | undefined;
    billingContact?: ContactViewModelBase | undefined;
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;
}

export class CreateFillSiteCommand implements ICreateFillSiteCommand {
    companyUniqueId?: string;
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    soilQualityTypes?: SoilQualityType[] | undefined;
    name?: string | undefined;
    siteClassificationType?: SiteClassificationType;
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    municipalityName?: string | undefined;
    status?: SiteStatus;
    registrationNumber?: string | undefined;

    constructor(data?: ICreateFillSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyUniqueId = _data["companyUniqueId"];
            this.address = _data["address"] ? AddressViewModelBase.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? ContactViewModelBase.fromJS(_data["contact"]) : <any>undefined;
            if (Array.isArray(_data["soilQualityTypes"])) {
                this.soilQualityTypes = [] as any;
                for (let item of _data["soilQualityTypes"])
                    this.soilQualityTypes!.push(item);
            }
            this.name = _data["name"];
            this.siteClassificationType = _data["siteClassificationType"];
            this.isTPQPApprovalRequired = _data["isTPQPApprovalRequired"];
            this.visibilityToClients = _data["visibilityToClients"];
            this.unitPricePerLoad = _data["unitPricePerLoad"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
            this.registrationNumber = _data["registrationNumber"];
        }
    }

    static fromJS(data: any): CreateFillSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFillSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyUniqueId"] = this.companyUniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        if (Array.isArray(this.soilQualityTypes)) {
            data["soilQualityTypes"] = [];
            for (let item of this.soilQualityTypes)
                data["soilQualityTypes"].push(item);
        }
        data["name"] = this.name;
        data["siteClassificationType"] = this.siteClassificationType;
        data["isTPQPApprovalRequired"] = this.isTPQPApprovalRequired;
        data["visibilityToClients"] = this.visibilityToClients;
        data["unitPricePerLoad"] = this.unitPricePerLoad;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        data["registrationNumber"] = this.registrationNumber;
        return data;
    }
}

export interface ICreateFillSiteCommand {
    companyUniqueId?: string;
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    soilQualityTypes?: SoilQualityType[] | undefined;
    name?: string | undefined;
    siteClassificationType?: SiteClassificationType;
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    municipalityName?: string | undefined;
    status?: SiteStatus;
    registrationNumber?: string | undefined;
}

export class CreateFillSiteViewModel implements ICreateFillSiteViewModel {
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    soilQualityTypes?: SoilQualityType[] | undefined;
    name?: string | undefined;
    siteClassificationType?: SiteClassificationType;
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    municipalityName?: string | undefined;
    status?: SiteStatus;
    registrationNumber?: string | undefined;

    constructor(data?: ICreateFillSiteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? AddressViewModelBase.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? ContactViewModelBase.fromJS(_data["contact"]) : <any>undefined;
            if (Array.isArray(_data["soilQualityTypes"])) {
                this.soilQualityTypes = [] as any;
                for (let item of _data["soilQualityTypes"])
                    this.soilQualityTypes!.push(item);
            }
            this.name = _data["name"];
            this.siteClassificationType = _data["siteClassificationType"];
            this.isTPQPApprovalRequired = _data["isTPQPApprovalRequired"];
            this.visibilityToClients = _data["visibilityToClients"];
            this.unitPricePerLoad = _data["unitPricePerLoad"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
            this.registrationNumber = _data["registrationNumber"];
        }
    }

    static fromJS(data: any): CreateFillSiteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFillSiteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        if (Array.isArray(this.soilQualityTypes)) {
            data["soilQualityTypes"] = [];
            for (let item of this.soilQualityTypes)
                data["soilQualityTypes"].push(item);
        }
        data["name"] = this.name;
        data["siteClassificationType"] = this.siteClassificationType;
        data["isTPQPApprovalRequired"] = this.isTPQPApprovalRequired;
        data["visibilityToClients"] = this.visibilityToClients;
        data["unitPricePerLoad"] = this.unitPricePerLoad;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        data["registrationNumber"] = this.registrationNumber;
        return data;
    }
}

export interface ICreateFillSiteViewModel {
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    soilQualityTypes?: SoilQualityType[] | undefined;
    name?: string | undefined;
    siteClassificationType?: SiteClassificationType;
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    municipalityName?: string | undefined;
    status?: SiteStatus;
    registrationNumber?: string | undefined;
}

export class CreateHaulerCommand implements ICreateHaulerCommand {
    companyUniqueId?: string;
    name?: string | undefined;
    phones?: Phone[] | undefined;
    emails?: string[] | undefined;
    address?: AddressViewModelBase | undefined;

    constructor(data?: ICreateHaulerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyUniqueId = _data["companyUniqueId"];
            this.name = _data["name"];
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(Phone.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.address = _data["address"] ? AddressViewModelBase.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateHaulerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHaulerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyUniqueId"] = this.companyUniqueId;
        data["name"] = this.name;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateHaulerCommand {
    companyUniqueId?: string;
    name?: string | undefined;
    phones?: Phone[] | undefined;
    emails?: string[] | undefined;
    address?: AddressViewModelBase | undefined;
}

export class CreateInvoiceCommand implements ICreateInvoiceCommand {
    batchUniqueId?: string;
    invoiceNumber?: string | undefined;
    weight?: number | undefined;
    unitPrice?: number | undefined;
    status?: InvoiceStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    notes?: string | undefined;
    invoiceType?: InvoiceType | undefined;

    constructor(data?: ICreateInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchUniqueId = _data["batchUniqueId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.weight = _data["weight"];
            this.unitPrice = _data["unitPrice"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.invoicedDate = _data["invoicedDate"] ? new Date(_data["invoicedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.invoiceType = _data["invoiceType"];
        }
    }

    static fromJS(data: any): CreateInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchUniqueId"] = this.batchUniqueId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["weight"] = this.weight;
        data["unitPrice"] = this.unitPrice;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["invoicedDate"] = this.invoicedDate ? this.invoicedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["invoiceType"] = this.invoiceType;
        return data;
    }
}

export interface ICreateInvoiceCommand {
    batchUniqueId?: string;
    invoiceNumber?: string | undefined;
    weight?: number | undefined;
    unitPrice?: number | undefined;
    status?: InvoiceStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    notes?: string | undefined;
    invoiceType?: InvoiceType | undefined;
}

export class CreateQualifiedPersonCommand implements ICreateQualifiedPersonCommand {
    isIndividual?: boolean;
    pgoNumber?: string | undefined;
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;

    constructor(data?: ICreateQualifiedPersonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isIndividual = _data["isIndividual"];
            this.pgoNumber = _data["pgoNumber"];
            this.address = _data["address"] ? AddressViewModelBase.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? ContactViewModelBase.fromJS(_data["contact"]) : <any>undefined;
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateQualifiedPersonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualifiedPersonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isIndividual"] = this.isIndividual;
        data["pgoNumber"] = this.pgoNumber;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateQualifiedPersonCommand {
    isIndividual?: boolean;
    pgoNumber?: string | undefined;
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;
}

export class CreateSourceSiteCommand implements ICreateSourceSiteCommand {
    companyUniqueId?: string;
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    name?: string | undefined;
    municipalityName?: string | undefined;
    status?: SiteStatus;

    constructor(data?: ICreateSourceSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyUniqueId = _data["companyUniqueId"];
            this.address = _data["address"] ? AddressViewModelBase.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? ContactViewModelBase.fromJS(_data["contact"]) : <any>undefined;
            this.name = _data["name"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateSourceSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSourceSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyUniqueId"] = this.companyUniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateSourceSiteCommand {
    companyUniqueId?: string;
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    name?: string | undefined;
    municipalityName?: string | undefined;
    status?: SiteStatus;
}

export class CreateSourceSiteViewModel implements ICreateSourceSiteViewModel {
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    name?: string | undefined;
    municipalityName?: string | undefined;
    status?: SiteStatus;

    constructor(data?: ICreateSourceSiteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? AddressViewModelBase.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? ContactViewModelBase.fromJS(_data["contact"]) : <any>undefined;
            this.name = _data["name"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateSourceSiteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSourceSiteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateSourceSiteViewModel {
    address?: AddressViewModelBase | undefined;
    contact?: ContactViewModelBase | undefined;
    name?: string | undefined;
    municipalityName?: string | undefined;
    status?: SiteStatus;
}

export class CreateTrainingMaterialCommand implements ICreateTrainingMaterialCommand {
    name?: string | undefined;
    description?: string | undefined;
    filePathURL?: string | undefined;

    constructor(data?: ICreateTrainingMaterialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.filePathURL = _data["filePathURL"];
        }
    }

    static fromJS(data: any): CreateTrainingMaterialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTrainingMaterialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["filePathURL"] = this.filePathURL;
        return data;
    }
}

export interface ICreateTrainingMaterialCommand {
    name?: string | undefined;
    description?: string | undefined;
    filePathURL?: string | undefined;
}

export class CreateTruckCommand implements ICreateTruckCommand {
    haulerUniqueId?: string;
    truckNumber?: string | undefined;
    driverName?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType | undefined;
    barcode?: string | undefined;

    constructor(data?: ICreateTruckCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haulerUniqueId = _data["haulerUniqueId"];
            this.truckNumber = _data["truckNumber"];
            this.driverName = _data["driverName"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.vehicleWeight = _data["vehicleWeight"];
            this.vehicleType = _data["vehicleType"];
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): CreateTruckCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTruckCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haulerUniqueId"] = this.haulerUniqueId;
        data["truckNumber"] = this.truckNumber;
        data["driverName"] = this.driverName;
        data["vehiclePlate"] = this.vehiclePlate;
        data["vehicleWeight"] = this.vehicleWeight;
        data["vehicleType"] = this.vehicleType;
        data["barcode"] = this.barcode;
        return data;
    }
}

export interface ICreateTruckCommand {
    haulerUniqueId?: string;
    truckNumber?: string | undefined;
    driverName?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType | undefined;
    barcode?: string | undefined;
}

export class CreateTruckListCommand implements ICreateTruckListCommand {
    haulerUniqueId?: string;
    trucks?: CreateTruckCommand[] | undefined;

    constructor(data?: ICreateTruckListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haulerUniqueId = _data["haulerUniqueId"];
            if (Array.isArray(_data["trucks"])) {
                this.trucks = [] as any;
                for (let item of _data["trucks"])
                    this.trucks!.push(CreateTruckCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTruckListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTruckListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haulerUniqueId"] = this.haulerUniqueId;
        if (Array.isArray(this.trucks)) {
            data["trucks"] = [];
            for (let item of this.trucks)
                data["trucks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateTruckListCommand {
    haulerUniqueId?: string;
    trucks?: CreateTruckCommand[] | undefined;
}

export class CurrentUserViewModel implements ICurrentUserViewModel {
    uniqueId?: string;
    legalEntityUniqueId?: string | undefined;
    legalEntityName?: string | undefined;
    status?: CleanFillUserStatus;
    firstName?: string | undefined;
    lastName?: string | undefined;
    initials?: string | undefined;
    isTermAccepted?: boolean;
    isApproved?: boolean;
    inviteUniqueId?: string | undefined;
    readonly legalEntityType?: LegalEntityType | undefined;
    legalEntityStatus?: LegalEntityStatus | undefined;
    policies?: string[] | undefined;
    roles?: string[] | undefined;

    constructor(data?: ICurrentUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.legalEntityUniqueId = _data["legalEntityUniqueId"];
            this.legalEntityName = _data["legalEntityName"];
            this.status = _data["status"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.initials = _data["initials"];
            this.isTermAccepted = _data["isTermAccepted"];
            this.isApproved = _data["isApproved"];
            this.inviteUniqueId = _data["inviteUniqueId"];
            (<any>this).legalEntityType = _data["legalEntityType"];
            this.legalEntityStatus = _data["legalEntityStatus"];
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CurrentUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["legalEntityUniqueId"] = this.legalEntityUniqueId;
        data["legalEntityName"] = this.legalEntityName;
        data["status"] = this.status;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["initials"] = this.initials;
        data["isTermAccepted"] = this.isTermAccepted;
        data["isApproved"] = this.isApproved;
        data["inviteUniqueId"] = this.inviteUniqueId;
        data["legalEntityType"] = this.legalEntityType;
        data["legalEntityStatus"] = this.legalEntityStatus;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICurrentUserViewModel {
    uniqueId?: string;
    legalEntityUniqueId?: string | undefined;
    legalEntityName?: string | undefined;
    status?: CleanFillUserStatus;
    firstName?: string | undefined;
    lastName?: string | undefined;
    initials?: string | undefined;
    isTermAccepted?: boolean;
    isApproved?: boolean;
    inviteUniqueId?: string | undefined;
    legalEntityType?: LegalEntityType | undefined;
    legalEntityStatus?: LegalEntityStatus | undefined;
    policies?: string[] | undefined;
    roles?: string[] | undefined;
}

export class DeleteTruckListCommand implements IDeleteTruckListCommand {
    uniqueIds?: string[] | undefined;

    constructor(data?: IDeleteTruckListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniqueIds"])) {
                this.uniqueIds = [] as any;
                for (let item of _data["uniqueIds"])
                    this.uniqueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteTruckListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTruckListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniqueIds)) {
            data["uniqueIds"] = [];
            for (let item of this.uniqueIds)
                data["uniqueIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteTruckListCommand {
    uniqueIds?: string[] | undefined;
}

export class DispatchESVRInfoUpdate implements IDispatchESVRInfoUpdate {
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number;
    vehicleType?: VehicleType;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    excavationLocation?: string | undefined;
    placementLocation?: string | undefined;
    customerBOL?: string | undefined;

    constructor(data?: IDispatchESVRInfoUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hauler = _data["hauler"];
            this.driverName = _data["driverName"];
            this.truckNumber = _data["truckNumber"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.vehicleWeight = _data["vehicleWeight"];
            this.vehicleType = _data["vehicleType"];
            this.loadWeight = _data["loadWeight"];
            this.tareWeight = _data["tareWeight"];
            this.grossWeight = _data["grossWeight"];
            this.excavationLocation = _data["excavationLocation"];
            this.placementLocation = _data["placementLocation"];
            this.customerBOL = _data["customerBOL"];
        }
    }

    static fromJS(data: any): DispatchESVRInfoUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new DispatchESVRInfoUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hauler"] = this.hauler;
        data["driverName"] = this.driverName;
        data["truckNumber"] = this.truckNumber;
        data["vehiclePlate"] = this.vehiclePlate;
        data["vehicleWeight"] = this.vehicleWeight;
        data["vehicleType"] = this.vehicleType;
        data["loadWeight"] = this.loadWeight;
        data["tareWeight"] = this.tareWeight;
        data["grossWeight"] = this.grossWeight;
        data["excavationLocation"] = this.excavationLocation;
        data["placementLocation"] = this.placementLocation;
        data["customerBOL"] = this.customerBOL;
        return data;
    }
}

export interface IDispatchESVRInfoUpdate {
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number;
    vehicleType?: VehicleType;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    excavationLocation?: string | undefined;
    placementLocation?: string | undefined;
    customerBOL?: string | undefined;
}

export class DisputeESVRCommand implements IDisputeESVRCommand {
    comments?: string | undefined;

    constructor(data?: IDisputeESVRCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): DisputeESVRCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DisputeESVRCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        return data;
    }
}

export interface IDisputeESVRCommand {
    comments?: string | undefined;
}

export class EditAddressViewModel implements IEditAddressViewModel {
    uniqueId?: string;
    city?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    postalCode?: string | undefined;
    provinceUniqueId?: string | undefined;

    constructor(data?: IEditAddressViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.city = _data["city"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.postalCode = _data["postalCode"];
            this.provinceUniqueId = _data["provinceUniqueId"];
        }
    }

    static fromJS(data: any): EditAddressViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditAddressViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["city"] = this.city;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["postalCode"] = this.postalCode;
        data["provinceUniqueId"] = this.provinceUniqueId;
        return data;
    }
}

export interface IEditAddressViewModel {
    uniqueId?: string;
    city?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    postalCode?: string | undefined;
    provinceUniqueId?: string | undefined;
}

export class EditBatchAnalysisParameterViewModel implements IEditBatchAnalysisParameterViewModel {
    uniqueId?: string;
    analysisParameter?: AnalysisParameter;
    count?: number | undefined;
    exceedance?: number | undefined;
    isTCPL?: boolean | undefined;

    constructor(data?: IEditBatchAnalysisParameterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.analysisParameter = _data["analysisParameter"];
            this.count = _data["count"];
            this.exceedance = _data["exceedance"];
            this.isTCPL = _data["isTCPL"];
        }
    }

    static fromJS(data: any): EditBatchAnalysisParameterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditBatchAnalysisParameterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["analysisParameter"] = this.analysisParameter;
        data["count"] = this.count;
        data["exceedance"] = this.exceedance;
        data["isTCPL"] = this.isTCPL;
        return data;
    }
}

export interface IEditBatchAnalysisParameterViewModel {
    uniqueId?: string;
    analysisParameter?: AnalysisParameter;
    count?: number | undefined;
    exceedance?: number | undefined;
    isTCPL?: boolean | undefined;
}

export class EditBatchCommand implements IEditBatchCommand {
    uniqueId?: string;
    soilQualityTypes?: EditBatchSoilQualityTypeViewModel[] | undefined;
    analysisParameters?: EditBatchAnalysisParameterViewModel[] | undefined;
    name?: string | undefined;
    status?: BatchStatus;
    estimatedStartDate?: Date | undefined;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    sourceSiteUniqueId?: string | undefined;
    sourceType?: SourceType | undefined;
    sourceTypeOther?: string | undefined;
    sourceSiteHistory?: SourceSiteType | undefined;
    sourceSiteHistoryOther?: string | undefined;
    sourceSitePresentUse?: string | undefined;
    sourceSiteAddress?: string | undefined;
    sourceSiteUserUniqueId?: string | undefined;
    sourceSiteQPUniqueId?: string | undefined;
    soilDescriptionType?: SoilDescriptionType | undefined;
    soilAnalysisNotDone?: boolean | undefined;
    analysisParameterOther?: string | undefined;
    fillSiteUniqueId?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IEditBatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            if (Array.isArray(_data["soilQualityTypes"])) {
                this.soilQualityTypes = [] as any;
                for (let item of _data["soilQualityTypes"])
                    this.soilQualityTypes!.push(EditBatchSoilQualityTypeViewModel.fromJS(item));
            }
            if (Array.isArray(_data["analysisParameters"])) {
                this.analysisParameters = [] as any;
                for (let item of _data["analysisParameters"])
                    this.analysisParameters!.push(EditBatchAnalysisParameterViewModel.fromJS(item));
            }
            this.name = _data["name"];
            this.status = _data["status"];
            this.estimatedStartDate = _data["estimatedStartDate"] ? new Date(_data["estimatedStartDate"].toString()) : <any>undefined;
            this.estimatedLoads = _data["estimatedLoads"];
            this.estimatedWeight = _data["estimatedWeight"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.sourceSiteUniqueId = _data["sourceSiteUniqueId"];
            this.sourceType = _data["sourceType"];
            this.sourceTypeOther = _data["sourceTypeOther"];
            this.sourceSiteHistory = _data["sourceSiteHistory"];
            this.sourceSiteHistoryOther = _data["sourceSiteHistoryOther"];
            this.sourceSitePresentUse = _data["sourceSitePresentUse"];
            this.sourceSiteAddress = _data["sourceSiteAddress"];
            this.sourceSiteUserUniqueId = _data["sourceSiteUserUniqueId"];
            this.sourceSiteQPUniqueId = _data["sourceSiteQPUniqueId"];
            this.soilDescriptionType = _data["soilDescriptionType"];
            this.soilAnalysisNotDone = _data["soilAnalysisNotDone"];
            this.analysisParameterOther = _data["analysisParameterOther"];
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): EditBatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditBatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        if (Array.isArray(this.soilQualityTypes)) {
            data["soilQualityTypes"] = [];
            for (let item of this.soilQualityTypes)
                data["soilQualityTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.analysisParameters)) {
            data["analysisParameters"] = [];
            for (let item of this.analysisParameters)
                data["analysisParameters"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["status"] = this.status;
        data["estimatedStartDate"] = this.estimatedStartDate ? this.estimatedStartDate.toISOString() : <any>undefined;
        data["estimatedLoads"] = this.estimatedLoads;
        data["estimatedWeight"] = this.estimatedWeight;
        data["estimatedVolume"] = this.estimatedVolume;
        data["sourceSiteUniqueId"] = this.sourceSiteUniqueId;
        data["sourceType"] = this.sourceType;
        data["sourceTypeOther"] = this.sourceTypeOther;
        data["sourceSiteHistory"] = this.sourceSiteHistory;
        data["sourceSiteHistoryOther"] = this.sourceSiteHistoryOther;
        data["sourceSitePresentUse"] = this.sourceSitePresentUse;
        data["sourceSiteAddress"] = this.sourceSiteAddress;
        data["sourceSiteUserUniqueId"] = this.sourceSiteUserUniqueId;
        data["sourceSiteQPUniqueId"] = this.sourceSiteQPUniqueId;
        data["soilDescriptionType"] = this.soilDescriptionType;
        data["soilAnalysisNotDone"] = this.soilAnalysisNotDone;
        data["analysisParameterOther"] = this.analysisParameterOther;
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IEditBatchCommand {
    uniqueId?: string;
    soilQualityTypes?: EditBatchSoilQualityTypeViewModel[] | undefined;
    analysisParameters?: EditBatchAnalysisParameterViewModel[] | undefined;
    name?: string | undefined;
    status?: BatchStatus;
    estimatedStartDate?: Date | undefined;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    sourceSiteUniqueId?: string | undefined;
    sourceType?: SourceType | undefined;
    sourceTypeOther?: string | undefined;
    sourceSiteHistory?: SourceSiteType | undefined;
    sourceSiteHistoryOther?: string | undefined;
    sourceSitePresentUse?: string | undefined;
    sourceSiteAddress?: string | undefined;
    sourceSiteUserUniqueId?: string | undefined;
    sourceSiteQPUniqueId?: string | undefined;
    soilDescriptionType?: SoilDescriptionType | undefined;
    soilAnalysisNotDone?: boolean | undefined;
    analysisParameterOther?: string | undefined;
    fillSiteUniqueId?: string | undefined;
    comments?: string | undefined;
}

export class EditBatchExtraCommand implements IEditBatchExtraCommand {
    uniqueId?: string;
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;

    constructor(data?: IEditBatchExtraCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.parentBatchUniqueId = _data["parentBatchUniqueId"];
            this.status = _data["status"];
            this.estimatedLoads = _data["estimatedLoads"];
            this.estimatedWeight = _data["estimatedWeight"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): EditBatchExtraCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditBatchExtraCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["parentBatchUniqueId"] = this.parentBatchUniqueId;
        data["status"] = this.status;
        data["estimatedLoads"] = this.estimatedLoads;
        data["estimatedWeight"] = this.estimatedWeight;
        data["estimatedVolume"] = this.estimatedVolume;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IEditBatchExtraCommand {
    uniqueId?: string;
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;
}

export class EditBatchExtraFSCommand implements IEditBatchExtraFSCommand {
    uniqueId?: string;
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;

    constructor(data?: IEditBatchExtraFSCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.parentBatchUniqueId = _data["parentBatchUniqueId"];
            this.status = _data["status"];
            this.estimatedLoads = _data["estimatedLoads"];
            this.estimatedWeight = _data["estimatedWeight"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): EditBatchExtraFSCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditBatchExtraFSCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["parentBatchUniqueId"] = this.parentBatchUniqueId;
        data["status"] = this.status;
        data["estimatedLoads"] = this.estimatedLoads;
        data["estimatedWeight"] = this.estimatedWeight;
        data["estimatedVolume"] = this.estimatedVolume;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IEditBatchExtraFSCommand {
    uniqueId?: string;
    parentBatchUniqueId?: string;
    status?: BatchStatus;
    estimatedLoads?: number | undefined;
    estimatedWeight?: number | undefined;
    estimatedVolume?: number | undefined;
    comments?: string | undefined;
}

export class EditBatchSoilQualityTypeViewModel implements IEditBatchSoilQualityTypeViewModel {
    uniqueId?: string;
    soilQualityType?: SoilQualityType;

    constructor(data?: IEditBatchSoilQualityTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.soilQualityType = _data["soilQualityType"];
        }
    }

    static fromJS(data: any): EditBatchSoilQualityTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditBatchSoilQualityTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["soilQualityType"] = this.soilQualityType;
        return data;
    }
}

export interface IEditBatchSoilQualityTypeViewModel {
    uniqueId?: string;
    soilQualityType?: SoilQualityType;
}

export class EditCleanFillUserGroupViewModel implements IEditCleanFillUserGroupViewModel {
    uniqueId?: string | undefined;
    cleanFillGroupUniqueId?: string;

    constructor(data?: IEditCleanFillUserGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.cleanFillGroupUniqueId = _data["cleanFillGroupUniqueId"];
        }
    }

    static fromJS(data: any): EditCleanFillUserGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditCleanFillUserGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["cleanFillGroupUniqueId"] = this.cleanFillGroupUniqueId;
        return data;
    }
}

export interface IEditCleanFillUserGroupViewModel {
    uniqueId?: string | undefined;
    cleanFillGroupUniqueId?: string;
}

export class EditCleanFillUserPolicyViewModel implements IEditCleanFillUserPolicyViewModel {
    uniqueId?: string | undefined;
    cleanFillPolicyUniqueId?: string;

    constructor(data?: IEditCleanFillUserPolicyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.cleanFillPolicyUniqueId = _data["cleanFillPolicyUniqueId"];
        }
    }

    static fromJS(data: any): EditCleanFillUserPolicyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditCleanFillUserPolicyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["cleanFillPolicyUniqueId"] = this.cleanFillPolicyUniqueId;
        return data;
    }
}

export interface IEditCleanFillUserPolicyViewModel {
    uniqueId?: string | undefined;
    cleanFillPolicyUniqueId?: string;
}

export class EditCompanyCommand implements IEditCompanyCommand {
    uniqueId?: string;
    billingAsCompanyContact?: boolean | undefined;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    billingContact?: EditContactViewModel | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;

    constructor(data?: IEditCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.billingAsCompanyContact = _data["billingAsCompanyContact"];
            this.address = _data["address"] ? EditAddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? EditContactViewModel.fromJS(_data["contact"]) : <any>undefined;
            this.billingContact = _data["billingContact"] ? EditContactViewModel.fromJS(_data["billingContact"]) : <any>undefined;
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EditCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["billingAsCompanyContact"] = this.billingAsCompanyContact;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["billingContact"] = this.billingContact ? this.billingContact.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface IEditCompanyCommand {
    uniqueId?: string;
    billingAsCompanyContact?: boolean | undefined;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    billingContact?: EditContactViewModel | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;
}

export class EditContactViewModel implements IEditContactViewModel {
    uniqueId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;

    constructor(data?: IEditContactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): EditContactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditContactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IEditContactViewModel {
    uniqueId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
}

export class EditESVRCommand implements IEditESVRCommand {
    uniqueId?: string;
    sourceSiteRepresentativeId?: number | undefined;
    sourceSiteRepresentativeUniqueId?: string | undefined;
    fillSiteRepresentativeId?: number | undefined;
    fillSiteRepresentativeUniqueId?: string | undefined;
    comments?: string | undefined;
    placementLocation?: string | undefined;
    excavationLocation?: string | undefined;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    outbound?: Date | undefined;
    transferDate?: Date | undefined;
    vehicleType?: VehicleType | undefined;
    customerBOL?: string | undefined;

    constructor(data?: IEditESVRCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.sourceSiteRepresentativeId = _data["sourceSiteRepresentativeId"];
            this.sourceSiteRepresentativeUniqueId = _data["sourceSiteRepresentativeUniqueId"];
            this.fillSiteRepresentativeId = _data["fillSiteRepresentativeId"];
            this.fillSiteRepresentativeUniqueId = _data["fillSiteRepresentativeUniqueId"];
            this.comments = _data["comments"];
            this.placementLocation = _data["placementLocation"];
            this.excavationLocation = _data["excavationLocation"];
            this.loadWeight = _data["loadWeight"];
            this.tareWeight = _data["tareWeight"];
            this.grossWeight = _data["grossWeight"];
            this.hauler = _data["hauler"];
            this.driverName = _data["driverName"];
            this.truckNumber = _data["truckNumber"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.outbound = _data["outbound"] ? new Date(_data["outbound"].toString()) : <any>undefined;
            this.transferDate = _data["transferDate"] ? new Date(_data["transferDate"].toString()) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.customerBOL = _data["customerBOL"];
        }
    }

    static fromJS(data: any): EditESVRCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditESVRCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["sourceSiteRepresentativeId"] = this.sourceSiteRepresentativeId;
        data["sourceSiteRepresentativeUniqueId"] = this.sourceSiteRepresentativeUniqueId;
        data["fillSiteRepresentativeId"] = this.fillSiteRepresentativeId;
        data["fillSiteRepresentativeUniqueId"] = this.fillSiteRepresentativeUniqueId;
        data["comments"] = this.comments;
        data["placementLocation"] = this.placementLocation;
        data["excavationLocation"] = this.excavationLocation;
        data["loadWeight"] = this.loadWeight;
        data["tareWeight"] = this.tareWeight;
        data["grossWeight"] = this.grossWeight;
        data["hauler"] = this.hauler;
        data["driverName"] = this.driverName;
        data["truckNumber"] = this.truckNumber;
        data["vehiclePlate"] = this.vehiclePlate;
        data["outbound"] = this.outbound ? this.outbound.toISOString() : <any>undefined;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["customerBOL"] = this.customerBOL;
        return data;
    }
}

export interface IEditESVRCommand {
    uniqueId?: string;
    sourceSiteRepresentativeId?: number | undefined;
    sourceSiteRepresentativeUniqueId?: string | undefined;
    fillSiteRepresentativeId?: number | undefined;
    fillSiteRepresentativeUniqueId?: string | undefined;
    comments?: string | undefined;
    placementLocation?: string | undefined;
    excavationLocation?: string | undefined;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    outbound?: Date | undefined;
    transferDate?: Date | undefined;
    vehicleType?: VehicleType | undefined;
    customerBOL?: string | undefined;
}

export class EditFillSiteCommand implements IEditFillSiteCommand {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    soilQualityTypes?: EditFillSiteSoilQualityTypeViewModel[] | undefined;
    name?: string | undefined;
    siteClassificationType?: SiteClassificationType;
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    municipalityName?: string | undefined;
    status?: SiteStatus;
    registrationNumber?: string | undefined;

    constructor(data?: IEditFillSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.address = _data["address"] ? EditAddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? EditContactViewModel.fromJS(_data["contact"]) : <any>undefined;
            if (Array.isArray(_data["soilQualityTypes"])) {
                this.soilQualityTypes = [] as any;
                for (let item of _data["soilQualityTypes"])
                    this.soilQualityTypes!.push(EditFillSiteSoilQualityTypeViewModel.fromJS(item));
            }
            this.name = _data["name"];
            this.siteClassificationType = _data["siteClassificationType"];
            this.isTPQPApprovalRequired = _data["isTPQPApprovalRequired"];
            this.visibilityToClients = _data["visibilityToClients"];
            this.unitPricePerLoad = _data["unitPricePerLoad"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
            this.registrationNumber = _data["registrationNumber"];
        }
    }

    static fromJS(data: any): EditFillSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditFillSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        if (Array.isArray(this.soilQualityTypes)) {
            data["soilQualityTypes"] = [];
            for (let item of this.soilQualityTypes)
                data["soilQualityTypes"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["siteClassificationType"] = this.siteClassificationType;
        data["isTPQPApprovalRequired"] = this.isTPQPApprovalRequired;
        data["visibilityToClients"] = this.visibilityToClients;
        data["unitPricePerLoad"] = this.unitPricePerLoad;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        data["registrationNumber"] = this.registrationNumber;
        return data;
    }
}

export interface IEditFillSiteCommand {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    soilQualityTypes?: EditFillSiteSoilQualityTypeViewModel[] | undefined;
    name?: string | undefined;
    siteClassificationType?: SiteClassificationType;
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    municipalityName?: string | undefined;
    status?: SiteStatus;
    registrationNumber?: string | undefined;
}

export class EditFillSiteSoilQualityTypeViewModel implements IEditFillSiteSoilQualityTypeViewModel {
    uniqueId?: string;
    soilQualityType?: SoilQualityType;

    constructor(data?: IEditFillSiteSoilQualityTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.soilQualityType = _data["soilQualityType"];
        }
    }

    static fromJS(data: any): EditFillSiteSoilQualityTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditFillSiteSoilQualityTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["soilQualityType"] = this.soilQualityType;
        return data;
    }
}

export interface IEditFillSiteSoilQualityTypeViewModel {
    uniqueId?: string;
    soilQualityType?: SoilQualityType;
}

export class EditHaulerCommand implements IEditHaulerCommand {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    name?: string | undefined;
    phones?: Phone[] | undefined;
    emails?: string[] | undefined;

    constructor(data?: IEditHaulerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.address = _data["address"] ? EditAddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(Phone.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): EditHaulerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditHaulerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IEditHaulerCommand {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    name?: string | undefined;
    phones?: Phone[] | undefined;
    emails?: string[] | undefined;
}

export class EditInvoiceCommand implements IEditInvoiceCommand {
    uniqueId?: string;
    batchUniqueId?: string;
    invoiceNumber?: string | undefined;
    weight?: number | undefined;
    unitPrice?: number | undefined;
    status?: InvoiceStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    notes?: string | undefined;
    invoiceType?: InvoiceType | undefined;

    constructor(data?: IEditInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.batchUniqueId = _data["batchUniqueId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.weight = _data["weight"];
            this.unitPrice = _data["unitPrice"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.invoicedDate = _data["invoicedDate"] ? new Date(_data["invoicedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.invoiceType = _data["invoiceType"];
        }
    }

    static fromJS(data: any): EditInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["batchUniqueId"] = this.batchUniqueId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["weight"] = this.weight;
        data["unitPrice"] = this.unitPrice;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["invoicedDate"] = this.invoicedDate ? this.invoicedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["invoiceType"] = this.invoiceType;
        return data;
    }
}

export interface IEditInvoiceCommand {
    uniqueId?: string;
    batchUniqueId?: string;
    invoiceNumber?: string | undefined;
    weight?: number | undefined;
    unitPrice?: number | undefined;
    status?: InvoiceStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    notes?: string | undefined;
    invoiceType?: InvoiceType | undefined;
}

export class EditQualifiedPersonCommand implements IEditQualifiedPersonCommand {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    isIndividual?: boolean;
    pgoNumber?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;

    constructor(data?: IEditQualifiedPersonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.address = _data["address"] ? EditAddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? EditContactViewModel.fromJS(_data["contact"]) : <any>undefined;
            this.isIndividual = _data["isIndividual"];
            this.pgoNumber = _data["pgoNumber"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EditQualifiedPersonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditQualifiedPersonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["isIndividual"] = this.isIndividual;
        data["pgoNumber"] = this.pgoNumber;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface IEditQualifiedPersonCommand {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    isIndividual?: boolean;
    pgoNumber?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;
}

export class EditQualifiedPersonInviteCommand implements IEditQualifiedPersonInviteCommand {
    uniqueId?: string;
    status?: EmailInviteStatus;

    constructor(data?: IEditQualifiedPersonInviteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EditQualifiedPersonInviteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditQualifiedPersonInviteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["status"] = this.status;
        return data;
    }
}

export interface IEditQualifiedPersonInviteCommand {
    uniqueId?: string;
    status?: EmailInviteStatus;
}

export class EditSourceSiteCommand implements IEditSourceSiteCommand {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    name?: string | undefined;
    municipalityName?: string | undefined;
    status?: SiteStatus;

    constructor(data?: IEditSourceSiteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.address = _data["address"] ? EditAddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? EditContactViewModel.fromJS(_data["contact"]) : <any>undefined;
            this.name = _data["name"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EditSourceSiteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditSourceSiteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface IEditSourceSiteCommand {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    name?: string | undefined;
    municipalityName?: string | undefined;
    status?: SiteStatus;
}

export class EditTrainingMaterialCommand implements IEditTrainingMaterialCommand {
    uniqueId?: string;
    name?: string | undefined;
    description?: string | undefined;
    filePathURL?: string | undefined;

    constructor(data?: IEditTrainingMaterialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.filePathURL = _data["filePathURL"];
        }
    }

    static fromJS(data: any): EditTrainingMaterialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditTrainingMaterialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["filePathURL"] = this.filePathURL;
        return data;
    }
}

export interface IEditTrainingMaterialCommand {
    uniqueId?: string;
    name?: string | undefined;
    description?: string | undefined;
    filePathURL?: string | undefined;
}

export class EditTruckCommand implements IEditTruckCommand {
    uniqueId?: string;
    haulerUniqueId?: string;
    truckNumber?: string | undefined;
    driverName?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType | undefined;
    barcode?: string | undefined;

    constructor(data?: IEditTruckCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.haulerUniqueId = _data["haulerUniqueId"];
            this.truckNumber = _data["truckNumber"];
            this.driverName = _data["driverName"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.vehicleWeight = _data["vehicleWeight"];
            this.vehicleType = _data["vehicleType"];
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): EditTruckCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditTruckCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["haulerUniqueId"] = this.haulerUniqueId;
        data["truckNumber"] = this.truckNumber;
        data["driverName"] = this.driverName;
        data["vehiclePlate"] = this.vehiclePlate;
        data["vehicleWeight"] = this.vehicleWeight;
        data["vehicleType"] = this.vehicleType;
        data["barcode"] = this.barcode;
        return data;
    }
}

export interface IEditTruckCommand {
    uniqueId?: string;
    haulerUniqueId?: string;
    truckNumber?: string | undefined;
    driverName?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType | undefined;
    barcode?: string | undefined;
}

export class EditUserInviteCommand implements IEditUserInviteCommand {
    uniqueId?: string;
    status?: EmailInviteStatus;

    constructor(data?: IEditUserInviteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EditUserInviteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserInviteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["status"] = this.status;
        return data;
    }
}

export interface IEditUserInviteCommand {
    uniqueId?: string;
    status?: EmailInviteStatus;
}

export class EditUserPoliciesAndRolesCommand implements IEditUserPoliciesAndRolesCommand {
    userUniqueId?: string;
    cleanFillUserGroups?: EditCleanFillUserGroupViewModel[] | undefined;
    cleanFillUserPolicies?: EditCleanFillUserPolicyViewModel[] | undefined;

    constructor(data?: IEditUserPoliciesAndRolesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userUniqueId = _data["userUniqueId"];
            if (Array.isArray(_data["cleanFillUserGroups"])) {
                this.cleanFillUserGroups = [] as any;
                for (let item of _data["cleanFillUserGroups"])
                    this.cleanFillUserGroups!.push(EditCleanFillUserGroupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["cleanFillUserPolicies"])) {
                this.cleanFillUserPolicies = [] as any;
                for (let item of _data["cleanFillUserPolicies"])
                    this.cleanFillUserPolicies!.push(EditCleanFillUserPolicyViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditUserPoliciesAndRolesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserPoliciesAndRolesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userUniqueId"] = this.userUniqueId;
        if (Array.isArray(this.cleanFillUserGroups)) {
            data["cleanFillUserGroups"] = [];
            for (let item of this.cleanFillUserGroups)
                data["cleanFillUserGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.cleanFillUserPolicies)) {
            data["cleanFillUserPolicies"] = [];
            for (let item of this.cleanFillUserPolicies)
                data["cleanFillUserPolicies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditUserPoliciesAndRolesCommand {
    userUniqueId?: string;
    cleanFillUserGroups?: EditCleanFillUserGroupViewModel[] | undefined;
    cleanFillUserPolicies?: EditCleanFillUserPolicyViewModel[] | undefined;
}

export class EditUserProfileCommand implements IEditUserProfileCommand {
    uniqueId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
    userGroup?: UserInvitationGroup;

    constructor(data?: IEditUserProfileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.jobTitle = _data["jobTitle"];
            this.userGroup = _data["userGroup"];
        }
    }

    static fromJS(data: any): EditUserProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditUserProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["jobTitle"] = this.jobTitle;
        data["userGroup"] = this.userGroup;
        return data;
    }
}

export interface IEditUserProfileCommand {
    uniqueId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
    userGroup?: UserInvitationGroup;
}

export enum EmailInviteStatus {
    Sent = "Sent",
    Accepted = "Accepted",
    Rejected = "Rejected",
}

export class ESVRFillSiteInfoEditCommand implements IESVRFillSiteInfoEditCommand {
    uniqueId?: string;
    comments?: string | undefined;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    placementLocation?: string | undefined;

    constructor(data?: IESVRFillSiteInfoEditCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.comments = _data["comments"];
            this.loadWeight = _data["loadWeight"];
            this.tareWeight = _data["tareWeight"];
            this.grossWeight = _data["grossWeight"];
            this.placementLocation = _data["placementLocation"];
        }
    }

    static fromJS(data: any): ESVRFillSiteInfoEditCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRFillSiteInfoEditCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["comments"] = this.comments;
        data["loadWeight"] = this.loadWeight;
        data["tareWeight"] = this.tareWeight;
        data["grossWeight"] = this.grossWeight;
        data["placementLocation"] = this.placementLocation;
        return data;
    }
}

export interface IESVRFillSiteInfoEditCommand {
    uniqueId?: string;
    comments?: string | undefined;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    placementLocation?: string | undefined;
}

export class ESVRFillSiteSaveCommand implements IESVRFillSiteSaveCommand {
    uniqueId?: string;
    loadWeight?: number;
    placementLocation?: string | undefined;

    constructor(data?: IESVRFillSiteSaveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.loadWeight = _data["loadWeight"];
            this.placementLocation = _data["placementLocation"];
        }
    }

    static fromJS(data: any): ESVRFillSiteSaveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRFillSiteSaveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["loadWeight"] = this.loadWeight;
        data["placementLocation"] = this.placementLocation;
        return data;
    }
}

export interface IESVRFillSiteSaveCommand {
    uniqueId?: string;
    loadWeight?: number;
    placementLocation?: string | undefined;
}

export class ESVRInitialDataWithAmount implements IESVRInitialDataWithAmount {
    amount?: number;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    outbound?: Date | undefined;
    transferDate?: Date | undefined;
    vehicleType?: VehicleType | undefined;
    customerBOL?: string | undefined;

    constructor(data?: IESVRInitialDataWithAmount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.loadWeight = _data["loadWeight"];
            this.tareWeight = _data["tareWeight"];
            this.grossWeight = _data["grossWeight"];
            this.hauler = _data["hauler"];
            this.driverName = _data["driverName"];
            this.truckNumber = _data["truckNumber"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.outbound = _data["outbound"] ? new Date(_data["outbound"].toString()) : <any>undefined;
            this.transferDate = _data["transferDate"] ? new Date(_data["transferDate"].toString()) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.customerBOL = _data["customerBOL"];
        }
    }

    static fromJS(data: any): ESVRInitialDataWithAmount {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRInitialDataWithAmount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["loadWeight"] = this.loadWeight;
        data["tareWeight"] = this.tareWeight;
        data["grossWeight"] = this.grossWeight;
        data["hauler"] = this.hauler;
        data["driverName"] = this.driverName;
        data["truckNumber"] = this.truckNumber;
        data["vehiclePlate"] = this.vehiclePlate;
        data["outbound"] = this.outbound ? this.outbound.toISOString() : <any>undefined;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["customerBOL"] = this.customerBOL;
        return data;
    }
}

export interface IESVRInitialDataWithAmount {
    amount?: number;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    outbound?: Date | undefined;
    transferDate?: Date | undefined;
    vehicleType?: VehicleType | undefined;
    customerBOL?: string | undefined;
}

export class ESVRsDownloadQuery implements IESVRsDownloadQuery {
    batchUniqueId?: string | undefined;
    batchUniqueIds?: string[] | undefined;
    esvrIndexStart?: number | undefined;
    esvrIndexEnd?: number | undefined;
    esvrUniqueIds?: string[] | undefined;

    constructor(data?: IESVRsDownloadQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchUniqueId = _data["batchUniqueId"];
            if (Array.isArray(_data["batchUniqueIds"])) {
                this.batchUniqueIds = [] as any;
                for (let item of _data["batchUniqueIds"])
                    this.batchUniqueIds!.push(item);
            }
            this.esvrIndexStart = _data["esvrIndexStart"];
            this.esvrIndexEnd = _data["esvrIndexEnd"];
            if (Array.isArray(_data["esvrUniqueIds"])) {
                this.esvrUniqueIds = [] as any;
                for (let item of _data["esvrUniqueIds"])
                    this.esvrUniqueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ESVRsDownloadQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRsDownloadQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchUniqueId"] = this.batchUniqueId;
        if (Array.isArray(this.batchUniqueIds)) {
            data["batchUniqueIds"] = [];
            for (let item of this.batchUniqueIds)
                data["batchUniqueIds"].push(item);
        }
        data["esvrIndexStart"] = this.esvrIndexStart;
        data["esvrIndexEnd"] = this.esvrIndexEnd;
        if (Array.isArray(this.esvrUniqueIds)) {
            data["esvrUniqueIds"] = [];
            for (let item of this.esvrUniqueIds)
                data["esvrUniqueIds"].push(item);
        }
        return data;
    }
}

export interface IESVRsDownloadQuery {
    batchUniqueId?: string | undefined;
    batchUniqueIds?: string[] | undefined;
    esvrIndexStart?: number | undefined;
    esvrIndexEnd?: number | undefined;
    esvrUniqueIds?: string[] | undefined;
}

export class ESVRSearchViewModel implements IESVRSearchViewModel {
    uniqueId?: string;
    batchUniqueId?: string;
    esvrIndex?: number;
    isDeleted?: boolean;
    esvrNumber?: string | undefined;
    status?: ESVRStatus;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    hauler?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleType?: VehicleType | undefined;
    outbound?: Date | undefined;
    transferDate?: Date | undefined;
    modifiedDate?: Date;
    isForwaded?: boolean;
    fillSiteUniqueId?: string;
    fillSiteName?: string | undefined;
    fillSiteCompanyUniqueId?: string;
    fillSiteCompanyName?: string | undefined;
    sourceSiteUniqueId?: string;
    sourceSiteName?: string | undefined;
    sourceSiteCompanyUniqueId?: string;
    sourceSiteCompanyName?: string | undefined;
    batchName?: string | undefined;
    batchStatus?: BatchStatus;
    driverName?: string | undefined;
    placementLocation?: string | undefined;
    excavationLocation?: string | undefined;
    customerBOL?: string | undefined;

    constructor(data?: IESVRSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.batchUniqueId = _data["batchUniqueId"];
            this.esvrIndex = _data["esvrIndex"];
            this.isDeleted = _data["isDeleted"];
            this.esvrNumber = _data["esvrNumber"];
            this.status = _data["status"];
            this.loadWeight = _data["loadWeight"];
            this.tareWeight = _data["tareWeight"];
            this.grossWeight = _data["grossWeight"];
            this.hauler = _data["hauler"];
            this.truckNumber = _data["truckNumber"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.vehicleType = _data["vehicleType"];
            this.outbound = _data["outbound"] ? new Date(_data["outbound"].toString()) : <any>undefined;
            this.transferDate = _data["transferDate"] ? new Date(_data["transferDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.isForwaded = _data["isForwaded"];
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
            this.fillSiteName = _data["fillSiteName"];
            this.fillSiteCompanyUniqueId = _data["fillSiteCompanyUniqueId"];
            this.fillSiteCompanyName = _data["fillSiteCompanyName"];
            this.sourceSiteUniqueId = _data["sourceSiteUniqueId"];
            this.sourceSiteName = _data["sourceSiteName"];
            this.sourceSiteCompanyUniqueId = _data["sourceSiteCompanyUniqueId"];
            this.sourceSiteCompanyName = _data["sourceSiteCompanyName"];
            this.batchName = _data["batchName"];
            this.batchStatus = _data["batchStatus"];
            this.driverName = _data["driverName"];
            this.placementLocation = _data["placementLocation"];
            this.excavationLocation = _data["excavationLocation"];
            this.customerBOL = _data["customerBOL"];
        }
    }

    static fromJS(data: any): ESVRSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["batchUniqueId"] = this.batchUniqueId;
        data["esvrIndex"] = this.esvrIndex;
        data["isDeleted"] = this.isDeleted;
        data["esvrNumber"] = this.esvrNumber;
        data["status"] = this.status;
        data["loadWeight"] = this.loadWeight;
        data["tareWeight"] = this.tareWeight;
        data["grossWeight"] = this.grossWeight;
        data["hauler"] = this.hauler;
        data["truckNumber"] = this.truckNumber;
        data["vehiclePlate"] = this.vehiclePlate;
        data["vehicleType"] = this.vehicleType;
        data["outbound"] = this.outbound ? this.outbound.toISOString() : <any>undefined;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["isForwaded"] = this.isForwaded;
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        data["fillSiteName"] = this.fillSiteName;
        data["fillSiteCompanyUniqueId"] = this.fillSiteCompanyUniqueId;
        data["fillSiteCompanyName"] = this.fillSiteCompanyName;
        data["sourceSiteUniqueId"] = this.sourceSiteUniqueId;
        data["sourceSiteName"] = this.sourceSiteName;
        data["sourceSiteCompanyUniqueId"] = this.sourceSiteCompanyUniqueId;
        data["sourceSiteCompanyName"] = this.sourceSiteCompanyName;
        data["batchName"] = this.batchName;
        data["batchStatus"] = this.batchStatus;
        data["driverName"] = this.driverName;
        data["placementLocation"] = this.placementLocation;
        data["excavationLocation"] = this.excavationLocation;
        data["customerBOL"] = this.customerBOL;
        return data;
    }
}

export interface IESVRSearchViewModel {
    uniqueId?: string;
    batchUniqueId?: string;
    esvrIndex?: number;
    isDeleted?: boolean;
    esvrNumber?: string | undefined;
    status?: ESVRStatus;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    hauler?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleType?: VehicleType | undefined;
    outbound?: Date | undefined;
    transferDate?: Date | undefined;
    modifiedDate?: Date;
    isForwaded?: boolean;
    fillSiteUniqueId?: string;
    fillSiteName?: string | undefined;
    fillSiteCompanyUniqueId?: string;
    fillSiteCompanyName?: string | undefined;
    sourceSiteUniqueId?: string;
    sourceSiteName?: string | undefined;
    sourceSiteCompanyUniqueId?: string;
    sourceSiteCompanyName?: string | undefined;
    batchName?: string | undefined;
    batchStatus?: BatchStatus;
    driverName?: string | undefined;
    placementLocation?: string | undefined;
    excavationLocation?: string | undefined;
    customerBOL?: string | undefined;
}

export class ESVRSearchViewModelESVRTotalTypePagedResultResponse implements IESVRSearchViewModelESVRTotalTypePagedResultResponse {
    totals?: ESVRTotalTypeITotal[] | undefined;
    records?: ESVRSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IESVRSearchViewModelESVRTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(ESVRTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(ESVRSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): ESVRSearchViewModelESVRTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRSearchViewModelESVRTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IESVRSearchViewModelESVRTotalTypePagedResultResponse {
    totals?: ESVRTotalTypeITotal[] | undefined;
    records?: ESVRSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class ESVRSourceSiteInfoEditCommand implements IESVRSourceSiteInfoEditCommand {
    uniqueId?: string;
    excavationLocation?: string | undefined;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    tareWeight?: number | undefined;
    grossWeight?: number;
    vehicleType?: VehicleType;

    constructor(data?: IESVRSourceSiteInfoEditCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.excavationLocation = _data["excavationLocation"];
            this.hauler = _data["hauler"];
            this.driverName = _data["driverName"];
            this.truckNumber = _data["truckNumber"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.vehicleWeight = _data["vehicleWeight"];
            this.tareWeight = _data["tareWeight"];
            this.grossWeight = _data["grossWeight"];
            this.vehicleType = _data["vehicleType"];
        }
    }

    static fromJS(data: any): ESVRSourceSiteInfoEditCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRSourceSiteInfoEditCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["excavationLocation"] = this.excavationLocation;
        data["hauler"] = this.hauler;
        data["driverName"] = this.driverName;
        data["truckNumber"] = this.truckNumber;
        data["vehiclePlate"] = this.vehiclePlate;
        data["vehicleWeight"] = this.vehicleWeight;
        data["tareWeight"] = this.tareWeight;
        data["grossWeight"] = this.grossWeight;
        data["vehicleType"] = this.vehicleType;
        return data;
    }
}

export interface IESVRSourceSiteInfoEditCommand {
    uniqueId?: string;
    excavationLocation?: string | undefined;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    tareWeight?: number | undefined;
    grossWeight?: number;
    vehicleType?: VehicleType;
}

export class ESVRSourceSiteSaveCommand implements IESVRSourceSiteSaveCommand {
    uniqueId?: string;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number;
    excavationLocation?: string | undefined;

    constructor(data?: IESVRSourceSiteSaveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.hauler = _data["hauler"];
            this.driverName = _data["driverName"];
            this.truckNumber = _data["truckNumber"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.vehicleWeight = _data["vehicleWeight"];
            this.vehicleType = _data["vehicleType"];
            this.loadWeight = _data["loadWeight"];
            this.tareWeight = _data["tareWeight"];
            this.grossWeight = _data["grossWeight"];
            this.excavationLocation = _data["excavationLocation"];
        }
    }

    static fromJS(data: any): ESVRSourceSiteSaveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRSourceSiteSaveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["hauler"] = this.hauler;
        data["driverName"] = this.driverName;
        data["truckNumber"] = this.truckNumber;
        data["vehiclePlate"] = this.vehiclePlate;
        data["vehicleWeight"] = this.vehicleWeight;
        data["vehicleType"] = this.vehicleType;
        data["loadWeight"] = this.loadWeight;
        data["tareWeight"] = this.tareWeight;
        data["grossWeight"] = this.grossWeight;
        data["excavationLocation"] = this.excavationLocation;
        return data;
    }
}

export interface IESVRSourceSiteSaveCommand {
    uniqueId?: string;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number;
    excavationLocation?: string | undefined;
}

export class ESVRsReqDownloadQuery implements IESVRsReqDownloadQuery {
    batchUniqueId?: string | undefined;
    batchUniqueIds?: string[] | undefined;
    esvrIndexStart?: number | undefined;
    esvrIndexEnd?: number | undefined;
    esvrUniqueIds?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IESVRsReqDownloadQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchUniqueId = _data["batchUniqueId"];
            if (Array.isArray(_data["batchUniqueIds"])) {
                this.batchUniqueIds = [] as any;
                for (let item of _data["batchUniqueIds"])
                    this.batchUniqueIds!.push(item);
            }
            this.esvrIndexStart = _data["esvrIndexStart"];
            this.esvrIndexEnd = _data["esvrIndexEnd"];
            if (Array.isArray(_data["esvrUniqueIds"])) {
                this.esvrUniqueIds = [] as any;
                for (let item of _data["esvrUniqueIds"])
                    this.esvrUniqueIds!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ESVRsReqDownloadQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRsReqDownloadQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchUniqueId"] = this.batchUniqueId;
        if (Array.isArray(this.batchUniqueIds)) {
            data["batchUniqueIds"] = [];
            for (let item of this.batchUniqueIds)
                data["batchUniqueIds"].push(item);
        }
        data["esvrIndexStart"] = this.esvrIndexStart;
        data["esvrIndexEnd"] = this.esvrIndexEnd;
        if (Array.isArray(this.esvrUniqueIds)) {
            data["esvrUniqueIds"] = [];
            for (let item of this.esvrUniqueIds)
                data["esvrUniqueIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IESVRsReqDownloadQuery {
    batchUniqueId?: string | undefined;
    batchUniqueIds?: string[] | undefined;
    esvrIndexStart?: number | undefined;
    esvrIndexEnd?: number | undefined;
    esvrUniqueIds?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export enum ESVRStatus {
    Prepared = "Prepared",
    Dispatched = "Dispatched",
    PendingApproval = "PendingApproval",
    Received = "Received",
    Rejected = "Rejected",
}

export class ESVRStatusCountViewModel implements IESVRStatusCountViewModel {
    date?: Date;
    status?: ESVRStatus;
    count?: number | undefined;

    constructor(data?: IESVRStatusCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ESVRStatusCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRStatusCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IESVRStatusCountViewModel {
    date?: Date;
    status?: ESVRStatus;
    count?: number | undefined;
}

export enum ESVRTotalType {
    Prepared = "Prepared",
    Dispatched = "Dispatched",
    PendingApproval = "PendingApproval",
    Received = "Received",
    Rejected = "Rejected",
    AllStatus = "AllStatus",
}

export class ESVRTotalTypeITotal implements IESVRTotalTypeITotal {
    type?: ESVRTotalType;
    value?: number | undefined;

    constructor(data?: IESVRTotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ESVRTotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRTotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IESVRTotalTypeITotal {
    type?: ESVRTotalType;
    value?: number | undefined;
}

export class ESVRViewModel implements IESVRViewModel {
    uniqueId?: string;
    batchUniqueId?: string;
    batchIdentification?: string | undefined;
    batchName?: string | undefined;
    companyUniqueId?: string;
    status?: ESVRStatus;
    esvrNumber?: string | undefined;
    esvrIndex?: number;
    isForwaded?: boolean;
    comments?: string | undefined;
    placementLocation?: string | undefined;
    excavationLocation?: string | undefined;
    sourceSite?: SourceSiteViewModel | undefined;
    fillSite?: FillSiteViewModel | undefined;
    sourceSiteRepresentative?: UserGeneralInfoViewModel | undefined;
    fillSiteRepresentative?: UserGeneralInfoViewModel | undefined;
    userHasAccessToESVRFillSite?: boolean;
    userHasAccessToESVRSourceSite?: boolean;
    auditTrails?: AuditTrailViewModel[] | undefined;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    outbound?: Date | undefined;
    transferDate?: Date | undefined;
    vehicleType?: VehicleType | undefined;
    customerBOL?: string | undefined;

    constructor(data?: IESVRViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.batchUniqueId = _data["batchUniqueId"];
            this.batchIdentification = _data["batchIdentification"];
            this.batchName = _data["batchName"];
            this.companyUniqueId = _data["companyUniqueId"];
            this.status = _data["status"];
            this.esvrNumber = _data["esvrNumber"];
            this.esvrIndex = _data["esvrIndex"];
            this.isForwaded = _data["isForwaded"];
            this.comments = _data["comments"];
            this.placementLocation = _data["placementLocation"];
            this.excavationLocation = _data["excavationLocation"];
            this.sourceSite = _data["sourceSite"] ? SourceSiteViewModel.fromJS(_data["sourceSite"]) : <any>undefined;
            this.fillSite = _data["fillSite"] ? FillSiteViewModel.fromJS(_data["fillSite"]) : <any>undefined;
            this.sourceSiteRepresentative = _data["sourceSiteRepresentative"] ? UserGeneralInfoViewModel.fromJS(_data["sourceSiteRepresentative"]) : <any>undefined;
            this.fillSiteRepresentative = _data["fillSiteRepresentative"] ? UserGeneralInfoViewModel.fromJS(_data["fillSiteRepresentative"]) : <any>undefined;
            this.userHasAccessToESVRFillSite = _data["userHasAccessToESVRFillSite"];
            this.userHasAccessToESVRSourceSite = _data["userHasAccessToESVRSourceSite"];
            if (Array.isArray(_data["auditTrails"])) {
                this.auditTrails = [] as any;
                for (let item of _data["auditTrails"])
                    this.auditTrails!.push(AuditTrailViewModel.fromJS(item));
            }
            this.loadWeight = _data["loadWeight"];
            this.tareWeight = _data["tareWeight"];
            this.grossWeight = _data["grossWeight"];
            this.hauler = _data["hauler"];
            this.driverName = _data["driverName"];
            this.truckNumber = _data["truckNumber"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.outbound = _data["outbound"] ? new Date(_data["outbound"].toString()) : <any>undefined;
            this.transferDate = _data["transferDate"] ? new Date(_data["transferDate"].toString()) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.customerBOL = _data["customerBOL"];
        }
    }

    static fromJS(data: any): ESVRViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESVRViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["batchUniqueId"] = this.batchUniqueId;
        data["batchIdentification"] = this.batchIdentification;
        data["batchName"] = this.batchName;
        data["companyUniqueId"] = this.companyUniqueId;
        data["status"] = this.status;
        data["esvrNumber"] = this.esvrNumber;
        data["esvrIndex"] = this.esvrIndex;
        data["isForwaded"] = this.isForwaded;
        data["comments"] = this.comments;
        data["placementLocation"] = this.placementLocation;
        data["excavationLocation"] = this.excavationLocation;
        data["sourceSite"] = this.sourceSite ? this.sourceSite.toJSON() : <any>undefined;
        data["fillSite"] = this.fillSite ? this.fillSite.toJSON() : <any>undefined;
        data["sourceSiteRepresentative"] = this.sourceSiteRepresentative ? this.sourceSiteRepresentative.toJSON() : <any>undefined;
        data["fillSiteRepresentative"] = this.fillSiteRepresentative ? this.fillSiteRepresentative.toJSON() : <any>undefined;
        data["userHasAccessToESVRFillSite"] = this.userHasAccessToESVRFillSite;
        data["userHasAccessToESVRSourceSite"] = this.userHasAccessToESVRSourceSite;
        if (Array.isArray(this.auditTrails)) {
            data["auditTrails"] = [];
            for (let item of this.auditTrails)
                data["auditTrails"].push(item.toJSON());
        }
        data["loadWeight"] = this.loadWeight;
        data["tareWeight"] = this.tareWeight;
        data["grossWeight"] = this.grossWeight;
        data["hauler"] = this.hauler;
        data["driverName"] = this.driverName;
        data["truckNumber"] = this.truckNumber;
        data["vehiclePlate"] = this.vehiclePlate;
        data["outbound"] = this.outbound ? this.outbound.toISOString() : <any>undefined;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["customerBOL"] = this.customerBOL;
        return data;
    }
}

export interface IESVRViewModel {
    uniqueId?: string;
    batchUniqueId?: string;
    batchIdentification?: string | undefined;
    batchName?: string | undefined;
    companyUniqueId?: string;
    status?: ESVRStatus;
    esvrNumber?: string | undefined;
    esvrIndex?: number;
    isForwaded?: boolean;
    comments?: string | undefined;
    placementLocation?: string | undefined;
    excavationLocation?: string | undefined;
    sourceSite?: SourceSiteViewModel | undefined;
    fillSite?: FillSiteViewModel | undefined;
    sourceSiteRepresentative?: UserGeneralInfoViewModel | undefined;
    fillSiteRepresentative?: UserGeneralInfoViewModel | undefined;
    userHasAccessToESVRFillSite?: boolean;
    userHasAccessToESVRSourceSite?: boolean;
    auditTrails?: AuditTrailViewModel[] | undefined;
    loadWeight?: number;
    tareWeight?: number | undefined;
    grossWeight?: number | undefined;
    hauler?: string | undefined;
    driverName?: string | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    outbound?: Date | undefined;
    transferDate?: Date | undefined;
    vehicleType?: VehicleType | undefined;
    customerBOL?: string | undefined;
}

export class FillSiteAttachmentViewModel implements IFillSiteAttachmentViewModel {
    uniqueId?: string;
    isLink?: boolean;
    fileName?: string | undefined;
    fileSize?: number;
    link?: string | undefined;

    constructor(data?: IFillSiteAttachmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.isLink = _data["isLink"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): FillSiteAttachmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteAttachmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["isLink"] = this.isLink;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["link"] = this.link;
        return data;
    }
}

export interface IFillSiteAttachmentViewModel {
    uniqueId?: string;
    isLink?: boolean;
    fileName?: string | undefined;
    fileSize?: number;
    link?: string | undefined;
}

export class FillSiteDashboardViewModel implements IFillSiteDashboardViewModel {
    uniqueId?: string;
    name?: string | undefined;
    batchCount?: number | undefined;
    transferredLoads?: number | undefined;
    transferredWeight?: number | undefined;

    constructor(data?: IFillSiteDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.batchCount = _data["batchCount"];
            this.transferredLoads = _data["transferredLoads"];
            this.transferredWeight = _data["transferredWeight"];
        }
    }

    static fromJS(data: any): FillSiteDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["batchCount"] = this.batchCount;
        data["transferredLoads"] = this.transferredLoads;
        data["transferredWeight"] = this.transferredWeight;
        return data;
    }
}

export interface IFillSiteDashboardViewModel {
    uniqueId?: string;
    name?: string | undefined;
    batchCount?: number | undefined;
    transferredLoads?: number | undefined;
    transferredWeight?: number | undefined;
}

export class FillSiteESVRSearchQuery implements IFillSiteESVRSearchQuery {
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: SortBy[] | undefined;
    filterBy?: FilterBy[] | undefined;

    constructor(data?: IFillSiteESVRSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortBy.fromJS(item));
            }
            if (Array.isArray(_data["filterBy"])) {
                this.filterBy = [] as any;
                for (let item of _data["filterBy"])
                    this.filterBy!.push(FilterBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FillSiteESVRSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteESVRSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        if (Array.isArray(this.filterBy)) {
            data["filterBy"] = [];
            for (let item of this.filterBy)
                data["filterBy"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFillSiteESVRSearchQuery {
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: SortBy[] | undefined;
    filterBy?: FilterBy[] | undefined;
}

export class FillSiteQPSearchViewModel implements IFillSiteQPSearchViewModel {
    fillSiteUniqueId?: string;
    fillSiteName?: string | undefined;
    fillSiteStatus?: SiteStatus;
    batchCount?: number | undefined;
    qpBatchCount?: number | undefined;
    uniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    qpUniqueId?: string;
    qpName?: string | undefined;
    contactEmail?: string | undefined;
    companyName?: string | undefined;

    constructor(data?: IFillSiteQPSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
            this.fillSiteName = _data["fillSiteName"];
            this.fillSiteStatus = _data["fillSiteStatus"];
            this.batchCount = _data["batchCount"];
            this.qpBatchCount = _data["qpBatchCount"];
            this.uniqueId = _data["uniqueId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.qpUniqueId = _data["qpUniqueId"];
            this.qpName = _data["qpName"];
            this.contactEmail = _data["contactEmail"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): FillSiteQPSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteQPSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        data["fillSiteName"] = this.fillSiteName;
        data["fillSiteStatus"] = this.fillSiteStatus;
        data["batchCount"] = this.batchCount;
        data["qpBatchCount"] = this.qpBatchCount;
        data["uniqueId"] = this.uniqueId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["qpUniqueId"] = this.qpUniqueId;
        data["qpName"] = this.qpName;
        data["contactEmail"] = this.contactEmail;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IFillSiteQPSearchViewModel {
    fillSiteUniqueId?: string;
    fillSiteName?: string | undefined;
    fillSiteStatus?: SiteStatus;
    batchCount?: number | undefined;
    qpBatchCount?: number | undefined;
    uniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    qpUniqueId?: string;
    qpName?: string | undefined;
    contactEmail?: string | undefined;
    companyName?: string | undefined;
}

export class FillSiteQPSearchViewModelTotalTypePagedResultResponse implements IFillSiteQPSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: FillSiteQPSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IFillSiteQPSearchViewModelTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(TotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(FillSiteQPSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): FillSiteQPSearchViewModelTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteQPSearchViewModelTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IFillSiteQPSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: FillSiteQPSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class FillSiteSearchQuery implements IFillSiteSearchQuery {
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: SortBy[] | undefined;
    filterBy?: FilterBy[] | undefined;

    constructor(data?: IFillSiteSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortBy.fromJS(item));
            }
            if (Array.isArray(_data["filterBy"])) {
                this.filterBy = [] as any;
                for (let item of _data["filterBy"])
                    this.filterBy!.push(FilterBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FillSiteSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        if (Array.isArray(this.filterBy)) {
            data["filterBy"] = [];
            for (let item of this.filterBy)
                data["filterBy"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFillSiteSearchQuery {
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: SortBy[] | undefined;
    filterBy?: FilterBy[] | undefined;
}

export class FillSiteSearchViewModel implements IFillSiteSearchViewModel {
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    soilQualityTypes?: SoilQualityType[] | undefined;
    cleanFillUserUniqueIds?: string[] | undefined;
    uniqueId?: string;
    name?: string | undefined;
    status?: SiteStatus;
    createdDate?: Date;
    modifiedDate?: Date;
    batchCount?: number | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    companyContactName?: string | undefined;
    companyContactEmail?: string | undefined;
    companyPhoneNumber?: string | undefined;
    companyExtension?: string | undefined;
    line1?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    admins?: string[] | undefined;
    qpLegalEntities?: string[] | undefined;

    constructor(data?: IFillSiteSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTPQPApprovalRequired = _data["isTPQPApprovalRequired"];
            this.visibilityToClients = _data["visibilityToClients"];
            this.unitPricePerLoad = _data["unitPricePerLoad"];
            if (Array.isArray(_data["soilQualityTypes"])) {
                this.soilQualityTypes = [] as any;
                for (let item of _data["soilQualityTypes"])
                    this.soilQualityTypes!.push(item);
            }
            if (Array.isArray(_data["cleanFillUserUniqueIds"])) {
                this.cleanFillUserUniqueIds = [] as any;
                for (let item of _data["cleanFillUserUniqueIds"])
                    this.cleanFillUserUniqueIds!.push(item);
            }
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.batchCount = _data["batchCount"];
            this.companyName = _data["companyName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.companyContactName = _data["companyContactName"];
            this.companyContactEmail = _data["companyContactEmail"];
            this.companyPhoneNumber = _data["companyPhoneNumber"];
            this.companyExtension = _data["companyExtension"];
            this.line1 = _data["line1"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceCode = _data["provinceCode"];
            if (Array.isArray(_data["admins"])) {
                this.admins = [] as any;
                for (let item of _data["admins"])
                    this.admins!.push(item);
            }
            if (Array.isArray(_data["qpLegalEntities"])) {
                this.qpLegalEntities = [] as any;
                for (let item of _data["qpLegalEntities"])
                    this.qpLegalEntities!.push(item);
            }
        }
    }

    static fromJS(data: any): FillSiteSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTPQPApprovalRequired"] = this.isTPQPApprovalRequired;
        data["visibilityToClients"] = this.visibilityToClients;
        data["unitPricePerLoad"] = this.unitPricePerLoad;
        if (Array.isArray(this.soilQualityTypes)) {
            data["soilQualityTypes"] = [];
            for (let item of this.soilQualityTypes)
                data["soilQualityTypes"].push(item);
        }
        if (Array.isArray(this.cleanFillUserUniqueIds)) {
            data["cleanFillUserUniqueIds"] = [];
            for (let item of this.cleanFillUserUniqueIds)
                data["cleanFillUserUniqueIds"].push(item);
        }
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["batchCount"] = this.batchCount;
        data["companyName"] = this.companyName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["companyContactName"] = this.companyContactName;
        data["companyContactEmail"] = this.companyContactEmail;
        data["companyPhoneNumber"] = this.companyPhoneNumber;
        data["companyExtension"] = this.companyExtension;
        data["line1"] = this.line1;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceCode"] = this.provinceCode;
        if (Array.isArray(this.admins)) {
            data["admins"] = [];
            for (let item of this.admins)
                data["admins"].push(item);
        }
        if (Array.isArray(this.qpLegalEntities)) {
            data["qpLegalEntities"] = [];
            for (let item of this.qpLegalEntities)
                data["qpLegalEntities"].push(item);
        }
        return data;
    }
}

export interface IFillSiteSearchViewModel {
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    soilQualityTypes?: SoilQualityType[] | undefined;
    cleanFillUserUniqueIds?: string[] | undefined;
    uniqueId?: string;
    name?: string | undefined;
    status?: SiteStatus;
    createdDate?: Date;
    modifiedDate?: Date;
    batchCount?: number | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    companyContactName?: string | undefined;
    companyContactEmail?: string | undefined;
    companyPhoneNumber?: string | undefined;
    companyExtension?: string | undefined;
    line1?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    admins?: string[] | undefined;
    qpLegalEntities?: string[] | undefined;
}

export class FillSiteSearchViewModelSiteTotalTypePagedResultResponse implements IFillSiteSearchViewModelSiteTotalTypePagedResultResponse {
    totals?: SiteTotalTypeITotal[] | undefined;
    records?: FillSiteSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IFillSiteSearchViewModelSiteTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(SiteTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(FillSiteSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): FillSiteSearchViewModelSiteTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteSearchViewModelSiteTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IFillSiteSearchViewModelSiteTotalTypePagedResultResponse {
    totals?: SiteTotalTypeITotal[] | undefined;
    records?: FillSiteSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class FillSiteSoilQualityTypeViewModel implements IFillSiteSoilQualityTypeViewModel {
    uniqueId?: string;
    soilQualityType?: SoilQualityType;

    constructor(data?: IFillSiteSoilQualityTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.soilQualityType = _data["soilQualityType"];
        }
    }

    static fromJS(data: any): FillSiteSoilQualityTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteSoilQualityTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["soilQualityType"] = this.soilQualityType;
        return data;
    }
}

export interface IFillSiteSoilQualityTypeViewModel {
    uniqueId?: string;
    soilQualityType?: SoilQualityType;
}

export class FillSiteSourceSiteSearchViewModel implements IFillSiteSourceSiteSearchViewModel {
    uniqueId?: string;
    fillSiteUniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    isDeleted?: boolean;
    sourceSiteUniqueId?: string;
    sourceSiteName?: string | undefined;
    sourceSiteContactEmail?: string | undefined;
    sourceSiteContactPhoneNumber?: string | undefined;
    batchCount?: number | undefined;
    sourceSiteCompanyName?: string | undefined;

    constructor(data?: IFillSiteSourceSiteSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.sourceSiteUniqueId = _data["sourceSiteUniqueId"];
            this.sourceSiteName = _data["sourceSiteName"];
            this.sourceSiteContactEmail = _data["sourceSiteContactEmail"];
            this.sourceSiteContactPhoneNumber = _data["sourceSiteContactPhoneNumber"];
            this.batchCount = _data["batchCount"];
            this.sourceSiteCompanyName = _data["sourceSiteCompanyName"];
        }
    }

    static fromJS(data: any): FillSiteSourceSiteSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteSourceSiteSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["sourceSiteUniqueId"] = this.sourceSiteUniqueId;
        data["sourceSiteName"] = this.sourceSiteName;
        data["sourceSiteContactEmail"] = this.sourceSiteContactEmail;
        data["sourceSiteContactPhoneNumber"] = this.sourceSiteContactPhoneNumber;
        data["batchCount"] = this.batchCount;
        data["sourceSiteCompanyName"] = this.sourceSiteCompanyName;
        return data;
    }
}

export interface IFillSiteSourceSiteSearchViewModel {
    uniqueId?: string;
    fillSiteUniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    isDeleted?: boolean;
    sourceSiteUniqueId?: string;
    sourceSiteName?: string | undefined;
    sourceSiteContactEmail?: string | undefined;
    sourceSiteContactPhoneNumber?: string | undefined;
    batchCount?: number | undefined;
    sourceSiteCompanyName?: string | undefined;
}

export class FillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse implements IFillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse {
    totals?: FillSiteSourceSiteTotalTypeITotal[] | undefined;
    records?: FillSiteSourceSiteSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IFillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(FillSiteSourceSiteTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(FillSiteSourceSiteSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): FillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IFillSiteSourceSiteSearchViewModelFillSiteSourceSiteTotalTypePagedResultResponse {
    totals?: FillSiteSourceSiteTotalTypeITotal[] | undefined;
    records?: FillSiteSourceSiteSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export enum FillSiteSourceSiteTotalType {
    Active = "Active",
    Closed = "Closed",
    All = "All",
}

export class FillSiteSourceSiteTotalTypeITotal implements IFillSiteSourceSiteTotalTypeITotal {
    type?: FillSiteSourceSiteTotalType;
    value?: number | undefined;

    constructor(data?: IFillSiteSourceSiteTotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FillSiteSourceSiteTotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteSourceSiteTotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IFillSiteSourceSiteTotalTypeITotal {
    type?: FillSiteSourceSiteTotalType;
    value?: number | undefined;
}

export class FillSiteUserSearchViewModel implements IFillSiteUserSearchViewModel {
    uniqueId?: string;
    fillSiteUniqueId?: string;
    userUniqueId?: string;
    userName?: string | undefined;
    userStatus?: CleanFillUserStatus;
    userEmail?: string | undefined;
    userPhoneNumber?: string | undefined;
    siteUserRoleName?: string | undefined;
    fillSiteName?: string | undefined;
    fillSiteContactEmail?: string | undefined;
    fillSiteStatus?: SiteStatus;
    batchCount?: number | undefined;
    userBatchCount?: number | undefined;

    constructor(data?: IFillSiteUserSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.fillSiteUniqueId = _data["fillSiteUniqueId"];
            this.userUniqueId = _data["userUniqueId"];
            this.userName = _data["userName"];
            this.userStatus = _data["userStatus"];
            this.userEmail = _data["userEmail"];
            this.userPhoneNumber = _data["userPhoneNumber"];
            this.siteUserRoleName = _data["siteUserRoleName"];
            this.fillSiteName = _data["fillSiteName"];
            this.fillSiteContactEmail = _data["fillSiteContactEmail"];
            this.fillSiteStatus = _data["fillSiteStatus"];
            this.batchCount = _data["batchCount"];
            this.userBatchCount = _data["userBatchCount"];
        }
    }

    static fromJS(data: any): FillSiteUserSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteUserSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["fillSiteUniqueId"] = this.fillSiteUniqueId;
        data["userUniqueId"] = this.userUniqueId;
        data["userName"] = this.userName;
        data["userStatus"] = this.userStatus;
        data["userEmail"] = this.userEmail;
        data["userPhoneNumber"] = this.userPhoneNumber;
        data["siteUserRoleName"] = this.siteUserRoleName;
        data["fillSiteName"] = this.fillSiteName;
        data["fillSiteContactEmail"] = this.fillSiteContactEmail;
        data["fillSiteStatus"] = this.fillSiteStatus;
        data["batchCount"] = this.batchCount;
        data["userBatchCount"] = this.userBatchCount;
        return data;
    }
}

export interface IFillSiteUserSearchViewModel {
    uniqueId?: string;
    fillSiteUniqueId?: string;
    userUniqueId?: string;
    userName?: string | undefined;
    userStatus?: CleanFillUserStatus;
    userEmail?: string | undefined;
    userPhoneNumber?: string | undefined;
    siteUserRoleName?: string | undefined;
    fillSiteName?: string | undefined;
    fillSiteContactEmail?: string | undefined;
    fillSiteStatus?: SiteStatus;
    batchCount?: number | undefined;
    userBatchCount?: number | undefined;
}

export class FillSiteUserSearchViewModelTotalTypePagedResultResponse implements IFillSiteUserSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: FillSiteUserSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IFillSiteUserSearchViewModelTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(TotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(FillSiteUserSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): FillSiteUserSearchViewModelTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteUserSearchViewModelTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IFillSiteUserSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: FillSiteUserSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class FillSiteViewModel implements IFillSiteViewModel {
    uniqueId?: string;
    addressUniqueId?: string;
    address?: AddressViewModel | undefined;
    contact?: ContactViewModel | undefined;
    company?: LegalEntityViewModel | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    soilQualityTypes?: FillSiteSoilQualityTypeViewModel[] | undefined;
    createdBy?: string | undefined;
    createdByLegalEntity?: string | undefined;
    batchCount?: BatchTotalTypeITotal[] | undefined;
    name?: string | undefined;
    siteClassificationType?: SiteClassificationType;
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    municipalityName?: string | undefined;
    status?: SiteStatus;
    registrationNumber?: string | undefined;

    constructor(data?: IFillSiteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.addressUniqueId = _data["addressUniqueId"];
            this.address = _data["address"] ? AddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? ContactViewModel.fromJS(_data["contact"]) : <any>undefined;
            this.company = _data["company"] ? LegalEntityViewModel.fromJS(_data["company"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["soilQualityTypes"])) {
                this.soilQualityTypes = [] as any;
                for (let item of _data["soilQualityTypes"])
                    this.soilQualityTypes!.push(FillSiteSoilQualityTypeViewModel.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.createdByLegalEntity = _data["createdByLegalEntity"];
            if (Array.isArray(_data["batchCount"])) {
                this.batchCount = [] as any;
                for (let item of _data["batchCount"])
                    this.batchCount!.push(BatchTotalTypeITotal.fromJS(item));
            }
            this.name = _data["name"];
            this.siteClassificationType = _data["siteClassificationType"];
            this.isTPQPApprovalRequired = _data["isTPQPApprovalRequired"];
            this.visibilityToClients = _data["visibilityToClients"];
            this.unitPricePerLoad = _data["unitPricePerLoad"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
            this.registrationNumber = _data["registrationNumber"];
        }
    }

    static fromJS(data: any): FillSiteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FillSiteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["addressUniqueId"] = this.addressUniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.soilQualityTypes)) {
            data["soilQualityTypes"] = [];
            for (let item of this.soilQualityTypes)
                data["soilQualityTypes"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["createdByLegalEntity"] = this.createdByLegalEntity;
        if (Array.isArray(this.batchCount)) {
            data["batchCount"] = [];
            for (let item of this.batchCount)
                data["batchCount"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["siteClassificationType"] = this.siteClassificationType;
        data["isTPQPApprovalRequired"] = this.isTPQPApprovalRequired;
        data["visibilityToClients"] = this.visibilityToClients;
        data["unitPricePerLoad"] = this.unitPricePerLoad;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        data["registrationNumber"] = this.registrationNumber;
        return data;
    }
}

export interface IFillSiteViewModel {
    uniqueId?: string;
    addressUniqueId?: string;
    address?: AddressViewModel | undefined;
    contact?: ContactViewModel | undefined;
    company?: LegalEntityViewModel | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    soilQualityTypes?: FillSiteSoilQualityTypeViewModel[] | undefined;
    createdBy?: string | undefined;
    createdByLegalEntity?: string | undefined;
    batchCount?: BatchTotalTypeITotal[] | undefined;
    name?: string | undefined;
    siteClassificationType?: SiteClassificationType;
    isTPQPApprovalRequired?: boolean;
    visibilityToClients?: VisibilityToClients;
    unitPricePerLoad?: number;
    municipalityName?: string | undefined;
    status?: SiteStatus;
    registrationNumber?: string | undefined;
}

export class FilterBy implements IFilterBy {
    property?: string | undefined;
    equal?: string | undefined;
    greaterThan?: string | undefined;
    lessThan?: string | undefined;
    notEqual?: string | undefined;
    in?: string | undefined;
    contains?: string | undefined;

    constructor(data?: IFilterBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.equal = _data["equal"];
            this.greaterThan = _data["greaterThan"];
            this.lessThan = _data["lessThan"];
            this.notEqual = _data["notEqual"];
            this.in = _data["in"];
            this.contains = _data["contains"];
        }
    }

    static fromJS(data: any): FilterBy {
        data = typeof data === 'object' ? data : {};
        let result = new FilterBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["equal"] = this.equal;
        data["greaterThan"] = this.greaterThan;
        data["lessThan"] = this.lessThan;
        data["notEqual"] = this.notEqual;
        data["in"] = this.in;
        data["contains"] = this.contains;
        return data;
    }
}

export interface IFilterBy {
    property?: string | undefined;
    equal?: string | undefined;
    greaterThan?: string | undefined;
    lessThan?: string | undefined;
    notEqual?: string | undefined;
    in?: string | undefined;
    contains?: string | undefined;
}

export class ForwardESVRsCommand implements IForwardESVRsCommand {
    batchUniqueId?: string;
    esvrGroups?: ESVRInitialDataWithAmount[] | undefined;

    constructor(data?: IForwardESVRsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchUniqueId = _data["batchUniqueId"];
            if (Array.isArray(_data["esvrGroups"])) {
                this.esvrGroups = [] as any;
                for (let item of _data["esvrGroups"])
                    this.esvrGroups!.push(ESVRInitialDataWithAmount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ForwardESVRsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ForwardESVRsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchUniqueId"] = this.batchUniqueId;
        if (Array.isArray(this.esvrGroups)) {
            data["esvrGroups"] = [];
            for (let item of this.esvrGroups)
                data["esvrGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IForwardESVRsCommand {
    batchUniqueId?: string;
    esvrGroups?: ESVRInitialDataWithAmount[] | undefined;
}

export class HaulerSearchViewModel implements IHaulerSearchViewModel {
    uniqueId?: string;
    name?: string | undefined;
    line1?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    numberOfTruck?: number | undefined;

    constructor(data?: IHaulerSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.line1 = _data["line1"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceCode = _data["provinceCode"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.numberOfTruck = _data["numberOfTruck"];
        }
    }

    static fromJS(data: any): HaulerSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HaulerSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["line1"] = this.line1;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceCode"] = this.provinceCode;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["numberOfTruck"] = this.numberOfTruck;
        return data;
    }
}

export interface IHaulerSearchViewModel {
    uniqueId?: string;
    name?: string | undefined;
    line1?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    numberOfTruck?: number | undefined;
}

export class HaulerSearchViewModelTotalTypePagedResultResponse implements IHaulerSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: HaulerSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IHaulerSearchViewModelTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(TotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(HaulerSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): HaulerSearchViewModelTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HaulerSearchViewModelTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IHaulerSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: HaulerSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class HaulerViewModel implements IHaulerViewModel {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    name?: string | undefined;
    phones?: Phone[] | undefined;
    emails?: string[] | undefined;

    constructor(data?: IHaulerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.address = _data["address"] ? EditAddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.name = _data["name"];
            if (Array.isArray(_data["phones"])) {
                this.phones = [] as any;
                for (let item of _data["phones"])
                    this.phones!.push(Phone.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): HaulerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HaulerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["name"] = this.name;
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IHaulerViewModel {
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    name?: string | undefined;
    phones?: Phone[] | undefined;
    emails?: string[] | undefined;
}

export class InspectionQuestionViewModel implements IInspectionQuestionViewModel {
    text?: string | undefined;

    constructor(data?: IInspectionQuestionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): InspectionQuestionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InspectionQuestionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface IInspectionQuestionViewModel {
    text?: string | undefined;
}

export class InviteLegalEntityCommand implements IInviteLegalEntityCommand {
    email?: string | undefined;
    name?: string | undefined;

    constructor(data?: IInviteLegalEntityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InviteLegalEntityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InviteLegalEntityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["name"] = this.name;
        return data;
    }
}

export interface IInviteLegalEntityCommand {
    email?: string | undefined;
    name?: string | undefined;
}

export class InviteQualifiedPersonCommand implements IInviteQualifiedPersonCommand {
    companyUniqueId?: string;
    qualifiedPersonUniqueId?: string;
    isAdminInvite?: boolean;

    constructor(data?: IInviteQualifiedPersonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyUniqueId = _data["companyUniqueId"];
            this.qualifiedPersonUniqueId = _data["qualifiedPersonUniqueId"];
            this.isAdminInvite = _data["isAdminInvite"];
        }
    }

    static fromJS(data: any): InviteQualifiedPersonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InviteQualifiedPersonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyUniqueId"] = this.companyUniqueId;
        data["qualifiedPersonUniqueId"] = this.qualifiedPersonUniqueId;
        data["isAdminInvite"] = this.isAdminInvite;
        return data;
    }
}

export interface IInviteQualifiedPersonCommand {
    companyUniqueId?: string;
    qualifiedPersonUniqueId?: string;
    isAdminInvite?: boolean;
}

export class InviteQualifiedPersonListCommand implements IInviteQualifiedPersonListCommand {
    companyUniqueId?: string;
    inviteQPs?: InviteQualifiedPersonCommand[] | undefined;
    grantAdmin?: boolean;

    constructor(data?: IInviteQualifiedPersonListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyUniqueId = _data["companyUniqueId"];
            if (Array.isArray(_data["inviteQPs"])) {
                this.inviteQPs = [] as any;
                for (let item of _data["inviteQPs"])
                    this.inviteQPs!.push(InviteQualifiedPersonCommand.fromJS(item));
            }
            this.grantAdmin = _data["grantAdmin"];
        }
    }

    static fromJS(data: any): InviteQualifiedPersonListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InviteQualifiedPersonListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyUniqueId"] = this.companyUniqueId;
        if (Array.isArray(this.inviteQPs)) {
            data["inviteQPs"] = [];
            for (let item of this.inviteQPs)
                data["inviteQPs"].push(item.toJSON());
        }
        data["grantAdmin"] = this.grantAdmin;
        return data;
    }
}

export interface IInviteQualifiedPersonListCommand {
    companyUniqueId?: string;
    inviteQPs?: InviteQualifiedPersonCommand[] | undefined;
    grantAdmin?: boolean;
}

export class InviteUserCommand implements IInviteUserCommand {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userInvitationGroup?: UserInvitationGroup;

    constructor(data?: IInviteUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userInvitationGroup = _data["userInvitationGroup"];
        }
    }

    static fromJS(data: any): InviteUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InviteUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userInvitationGroup"] = this.userInvitationGroup;
        return data;
    }
}

export interface IInviteUserCommand {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userInvitationGroup?: UserInvitationGroup;
}

export class InvoiceSearchViewModel implements IInvoiceSearchViewModel {
    uniqueId?: string;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdDate?: Date;
    modifiedDate?: Date;
    invoiceType?: InvoiceType | undefined;
    invoiceNumber?: string | undefined;
    loads?: number | undefined;
    weight?: number | undefined;
    unitPrice?: number | undefined;
    status?: InvoiceStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    batchName?: string | undefined;
    subTotal?: number;
    hst?: number;
    total?: number;

    constructor(data?: IInvoiceSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.invoiceType = _data["invoiceType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.loads = _data["loads"];
            this.weight = _data["weight"];
            this.unitPrice = _data["unitPrice"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.invoicedDate = _data["invoicedDate"] ? new Date(_data["invoicedDate"].toString()) : <any>undefined;
            this.batchName = _data["batchName"];
            this.subTotal = _data["subTotal"];
            this.hst = _data["hst"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): InvoiceSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["invoiceType"] = this.invoiceType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["loads"] = this.loads;
        data["weight"] = this.weight;
        data["unitPrice"] = this.unitPrice;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["invoicedDate"] = this.invoicedDate ? this.invoicedDate.toISOString() : <any>undefined;
        data["batchName"] = this.batchName;
        data["subTotal"] = this.subTotal;
        data["hst"] = this.hst;
        data["total"] = this.total;
        return data;
    }
}

export interface IInvoiceSearchViewModel {
    uniqueId?: string;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdDate?: Date;
    modifiedDate?: Date;
    invoiceType?: InvoiceType | undefined;
    invoiceNumber?: string | undefined;
    loads?: number | undefined;
    weight?: number | undefined;
    unitPrice?: number | undefined;
    status?: InvoiceStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    batchName?: string | undefined;
    subTotal?: number;
    hst?: number;
    total?: number;
}

export class InvoiceSearchViewModelInvoiceTotalTypePagedResultResponse implements IInvoiceSearchViewModelInvoiceTotalTypePagedResultResponse {
    totals?: InvoiceTotalTypeITotal[] | undefined;
    records?: InvoiceSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IInvoiceSearchViewModelInvoiceTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(InvoiceTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(InvoiceSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): InvoiceSearchViewModelInvoiceTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSearchViewModelInvoiceTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IInvoiceSearchViewModelInvoiceTotalTypePagedResultResponse {
    totals?: InvoiceTotalTypeITotal[] | undefined;
    records?: InvoiceSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export enum InvoiceStatus {
    Unpaid = "Unpaid",
    Paid = "Paid",
    Cancelled = "Cancelled",
    Archived = "Archived",
}

export enum InvoiceTotalType {
    Unpaid = "Unpaid",
    Paid = "Paid",
    Cancelled = "Cancelled",
    Archived = "Archived",
    AllStatus = "AllStatus",
}

export class InvoiceTotalTypeITotal implements IInvoiceTotalTypeITotal {
    type?: InvoiceTotalType;
    value?: number | undefined;

    constructor(data?: IInvoiceTotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InvoiceTotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceTotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IInvoiceTotalTypeITotal {
    type?: InvoiceTotalType;
    value?: number | undefined;
}

export enum InvoiceType {
    Monthly = "Monthly",
    Prepaid = "Prepaid",
}

export class InvoiceViewModel implements IInvoiceViewModel {
    loads?: number | undefined;
    batchName?: string | undefined;
    subTotal?: number;
    hst?: number;
    total?: number;
    uniqueId?: string;
    batchUniqueId?: string;
    invoiceNumber?: string | undefined;
    weight?: number | undefined;
    unitPrice?: number | undefined;
    status?: InvoiceStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    notes?: string | undefined;
    invoiceType?: InvoiceType | undefined;

    constructor(data?: IInvoiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loads = _data["loads"];
            this.batchName = _data["batchName"];
            this.subTotal = _data["subTotal"];
            this.hst = _data["hst"];
            this.total = _data["total"];
            this.uniqueId = _data["uniqueId"];
            this.batchUniqueId = _data["batchUniqueId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.weight = _data["weight"];
            this.unitPrice = _data["unitPrice"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.invoicedDate = _data["invoicedDate"] ? new Date(_data["invoicedDate"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.invoiceType = _data["invoiceType"];
        }
    }

    static fromJS(data: any): InvoiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loads"] = this.loads;
        data["batchName"] = this.batchName;
        data["subTotal"] = this.subTotal;
        data["hst"] = this.hst;
        data["total"] = this.total;
        data["uniqueId"] = this.uniqueId;
        data["batchUniqueId"] = this.batchUniqueId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["weight"] = this.weight;
        data["unitPrice"] = this.unitPrice;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["invoicedDate"] = this.invoicedDate ? this.invoicedDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["invoiceType"] = this.invoiceType;
        return data;
    }
}

export interface IInvoiceViewModel {
    loads?: number | undefined;
    batchName?: string | undefined;
    subTotal?: number;
    hst?: number;
    total?: number;
    uniqueId?: string;
    batchUniqueId?: string;
    invoiceNumber?: string | undefined;
    weight?: number | undefined;
    unitPrice?: number | undefined;
    status?: InvoiceStatus | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    invoicedDate?: Date | undefined;
    notes?: string | undefined;
    invoiceType?: InvoiceType | undefined;
}

export enum LegalEntityStatus {
    Draft = "Draft",
    Active = "Active",
}

export enum LegalEntityType {
    Company = "Company",
    Municipality = "Municipality",
    QualifiedPerson = "QualifiedPerson",
}

export class LegalEntityViewModel implements ILegalEntityViewModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;

    constructor(data?: ILegalEntityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LegalEntityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LegalEntityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface ILegalEntityViewModel {
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;
}

export enum NotificationStatus {
    New = "New",
    Read = "Read",
}

export enum NotificationTotalType {
    New = "New",
    Read = "Read",
    All = "All",
}

export class NotificationTotalTypeITotal implements INotificationTotalTypeITotal {
    type?: NotificationTotalType;
    value?: number | undefined;

    constructor(data?: INotificationTotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NotificationTotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface INotificationTotalTypeITotal {
    type?: NotificationTotalType;
    value?: number | undefined;
}

export enum NotificationType {
    Batches = "Batches",
    Sites = "Sites",
    Users = "Users",
}

export class NotificationViewModel implements INotificationViewModel {
    uniqueId?: string;
    header?: string | undefined;
    body?: string | undefined;
    createdDate?: Date | undefined;
    status?: NotificationStatus;
    type?: NotificationType | undefined;
    createdBy?: string | undefined;
    recepientId?: number | undefined;

    constructor(data?: INotificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.header = _data["header"];
            this.body = _data["body"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.createdBy = _data["createdBy"];
            this.recepientId = _data["recepientId"];
        }
    }

    static fromJS(data: any): NotificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["header"] = this.header;
        data["body"] = this.body;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["createdBy"] = this.createdBy;
        data["recepientId"] = this.recepientId;
        return data;
    }
}

export interface INotificationViewModel {
    uniqueId?: string;
    header?: string | undefined;
    body?: string | undefined;
    createdDate?: Date | undefined;
    status?: NotificationStatus;
    type?: NotificationType | undefined;
    createdBy?: string | undefined;
    recepientId?: number | undefined;
}

export class NotificationViewModelNotificationTotalTypePagedResultResponse implements INotificationViewModelNotificationTotalTypePagedResultResponse {
    totals?: NotificationTotalTypeITotal[] | undefined;
    records?: NotificationViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: INotificationViewModelNotificationTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(NotificationTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(NotificationViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): NotificationViewModelNotificationTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationViewModelNotificationTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface INotificationViewModelNotificationTotalTypePagedResultResponse {
    totals?: NotificationTotalTypeITotal[] | undefined;
    records?: NotificationViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class NotifyESVRsReleasedCommand implements INotifyESVRsReleasedCommand {
    batchUniqueId?: string | undefined;
    emailBody?: string | undefined;

    constructor(data?: INotifyESVRsReleasedCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchUniqueId = _data["batchUniqueId"];
            this.emailBody = _data["emailBody"];
        }
    }

    static fromJS(data: any): NotifyESVRsReleasedCommand {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyESVRsReleasedCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchUniqueId"] = this.batchUniqueId;
        data["emailBody"] = this.emailBody;
        return data;
    }
}

export interface INotifyESVRsReleasedCommand {
    batchUniqueId?: string | undefined;
    emailBody?: string | undefined;
}

export class Phone implements IPhone {
    phoneNumber?: string | undefined;
    extension?: string | undefined;

    constructor(data?: IPhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
        }
    }

    static fromJS(data: any): Phone {
        data = typeof data === 'object' ? data : {};
        let result = new Phone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        return data;
    }
}

export interface IPhone {
    phoneNumber?: string | undefined;
    extension?: string | undefined;
}

export class PrepareESVRCommand implements IPrepareESVRCommand {
    batchUniqueId?: string;
    esvrGroups?: ESVRInitialDataWithAmount[] | undefined;

    constructor(data?: IPrepareESVRCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchUniqueId = _data["batchUniqueId"];
            if (Array.isArray(_data["esvrGroups"])) {
                this.esvrGroups = [] as any;
                for (let item of _data["esvrGroups"])
                    this.esvrGroups!.push(ESVRInitialDataWithAmount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrepareESVRCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PrepareESVRCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchUniqueId"] = this.batchUniqueId;
        if (Array.isArray(this.esvrGroups)) {
            data["esvrGroups"] = [];
            for (let item of this.esvrGroups)
                data["esvrGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPrepareESVRCommand {
    batchUniqueId?: string;
    esvrGroups?: ESVRInitialDataWithAmount[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export class ProvinceViewModel implements IProvinceViewModel {
    uniqueId?: string;
    code?: string | undefined;
    countryUniqueId?: string;
    name?: string | undefined;
    country?: CountryViewModel | undefined;

    constructor(data?: IProvinceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.code = _data["code"];
            this.countryUniqueId = _data["countryUniqueId"];
            this.name = _data["name"];
            this.country = _data["country"] ? CountryViewModel.fromJS(_data["country"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProvinceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["code"] = this.code;
        data["countryUniqueId"] = this.countryUniqueId;
        data["name"] = this.name;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProvinceViewModel {
    uniqueId?: string;
    code?: string | undefined;
    countryUniqueId?: string;
    name?: string | undefined;
    country?: CountryViewModel | undefined;
}

export enum QPInviteTotalType {
    Pending = "Pending",
    Accepted = "Accepted",
    Rejected = "Rejected",
    AllStatus = "AllStatus",
}

export class QPInviteTotalTypeITotal implements IQPInviteTotalTypeITotal {
    type?: QPInviteTotalType;
    value?: number | undefined;

    constructor(data?: IQPInviteTotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): QPInviteTotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new QPInviteTotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface IQPInviteTotalTypeITotal {
    type?: QPInviteTotalType;
    value?: number | undefined;
}

export class QualifiedPersonDashboardViewModel implements IQualifiedPersonDashboardViewModel {
    id?: number;
    uniqueId?: string;
    name?: string | undefined;
    isIndividual?: boolean;
    batchCount?: number | undefined;

    constructor(data?: IQualifiedPersonDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.isIndividual = _data["isIndividual"];
            this.batchCount = _data["batchCount"];
        }
    }

    static fromJS(data: any): QualifiedPersonDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedPersonDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["isIndividual"] = this.isIndividual;
        data["batchCount"] = this.batchCount;
        return data;
    }
}

export interface IQualifiedPersonDashboardViewModel {
    id?: number;
    uniqueId?: string;
    name?: string | undefined;
    isIndividual?: boolean;
    batchCount?: number | undefined;
}

export class QualifiedPersonInviteSearchViewModel implements IQualifiedPersonInviteSearchViewModel {
    uniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    qpName?: string | undefined;
    email?: string | undefined;
    status?: QPInviteTotalType;
    companyName?: string | undefined;
    ssCount?: number | undefined;
    fsCount?: number | undefined;
    companyType?: string | undefined;
    qpInviteId?: string | undefined;
    qpAdminInviteId?: string | undefined;

    constructor(data?: IQualifiedPersonInviteSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.qpName = _data["qpName"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.companyName = _data["companyName"];
            this.ssCount = _data["ssCount"];
            this.fsCount = _data["fsCount"];
            this.companyType = _data["companyType"];
            this.qpInviteId = _data["qpInviteId"];
            this.qpAdminInviteId = _data["qpAdminInviteId"];
        }
    }

    static fromJS(data: any): QualifiedPersonInviteSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedPersonInviteSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["qpName"] = this.qpName;
        data["email"] = this.email;
        data["status"] = this.status;
        data["companyName"] = this.companyName;
        data["ssCount"] = this.ssCount;
        data["fsCount"] = this.fsCount;
        data["companyType"] = this.companyType;
        data["qpInviteId"] = this.qpInviteId;
        data["qpAdminInviteId"] = this.qpAdminInviteId;
        return data;
    }
}

export interface IQualifiedPersonInviteSearchViewModel {
    uniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    qpName?: string | undefined;
    email?: string | undefined;
    status?: QPInviteTotalType;
    companyName?: string | undefined;
    ssCount?: number | undefined;
    fsCount?: number | undefined;
    companyType?: string | undefined;
    qpInviteId?: string | undefined;
    qpAdminInviteId?: string | undefined;
}

export class QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse implements IQualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse {
    totals?: QPInviteTotalTypeITotal[] | undefined;
    records?: QualifiedPersonInviteSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IQualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(QPInviteTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(QualifiedPersonInviteSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IQualifiedPersonInviteSearchViewModelQPInviteTotalTypePagedResultResponse {
    totals?: QPInviteTotalTypeITotal[] | undefined;
    records?: QualifiedPersonInviteSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class QualifiedPersonInviteViewModel implements IQualifiedPersonInviteViewModel {
    company?: CompanyViewModel | undefined;
    uniqueId?: string;
    status?: EmailInviteStatus;
    isAdminInvite?: boolean;

    constructor(data?: IQualifiedPersonInviteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyViewModel.fromJS(_data["company"]) : <any>undefined;
            this.uniqueId = _data["uniqueId"];
            this.status = _data["status"];
            this.isAdminInvite = _data["isAdminInvite"];
        }
    }

    static fromJS(data: any): QualifiedPersonInviteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedPersonInviteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["uniqueId"] = this.uniqueId;
        data["status"] = this.status;
        data["isAdminInvite"] = this.isAdminInvite;
        return data;
    }
}

export interface IQualifiedPersonInviteViewModel {
    company?: CompanyViewModel | undefined;
    uniqueId?: string;
    status?: EmailInviteStatus;
    isAdminInvite?: boolean;
}

export class QualifiedPersonSearchViewModel implements IQualifiedPersonSearchViewModel {
    id?: number;
    name?: string | undefined;
    uniqueId?: string;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IQualifiedPersonSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.uniqueId = _data["uniqueId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): QualifiedPersonSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedPersonSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["uniqueId"] = this.uniqueId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IQualifiedPersonSearchViewModel {
    id?: number;
    name?: string | undefined;
    uniqueId?: string;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class QualifiedPersonSearchViewModelTotalTypePagedResultResponse implements IQualifiedPersonSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: QualifiedPersonSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IQualifiedPersonSearchViewModelTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(TotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(QualifiedPersonSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): QualifiedPersonSearchViewModelTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedPersonSearchViewModelTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IQualifiedPersonSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: QualifiedPersonSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class QualifiedPersonViewModel implements IQualifiedPersonViewModel {
    users?: UserSearchViewModel[] | undefined;
    legalEntityType?: LegalEntityType;
    isAdminForClient?: boolean;
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    isIndividual?: boolean;
    pgoNumber?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;

    constructor(data?: IQualifiedPersonViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserSearchViewModel.fromJS(item));
            }
            this.legalEntityType = _data["legalEntityType"];
            this.isAdminForClient = _data["isAdminForClient"];
            this.uniqueId = _data["uniqueId"];
            this.address = _data["address"] ? EditAddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? EditContactViewModel.fromJS(_data["contact"]) : <any>undefined;
            this.isIndividual = _data["isIndividual"];
            this.pgoNumber = _data["pgoNumber"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): QualifiedPersonViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedPersonViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["legalEntityType"] = this.legalEntityType;
        data["isAdminForClient"] = this.isAdminForClient;
        data["uniqueId"] = this.uniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["isIndividual"] = this.isIndividual;
        data["pgoNumber"] = this.pgoNumber;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface IQualifiedPersonViewModel {
    users?: UserSearchViewModel[] | undefined;
    legalEntityType?: LegalEntityType;
    isAdminForClient?: boolean;
    uniqueId?: string;
    address?: EditAddressViewModel | undefined;
    contact?: EditContactViewModel | undefined;
    isIndividual?: boolean;
    pgoNumber?: string | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    municipalityName?: string | undefined;
    status?: LegalEntityStatus;
}

export class RejectESVRCommand implements IRejectESVRCommand {
    comments?: string | undefined;

    constructor(data?: IRejectESVRCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): RejectESVRCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RejectESVRCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comments"] = this.comments;
        return data;
    }
}

export interface IRejectESVRCommand {
    comments?: string | undefined;
}

export enum SiteClassificationType {
    Class1SoilManagementSite = "Class1SoilManagementSite",
    Class2SoilManagementSite = "Class2SoilManagementSite",
    ReUseSite = "ReUseSite",
    LandFillingSiteOrDump = "LandFillingSiteOrDump",
}

export enum SiteStatus {
    New = "New",
    Draft = "Draft",
    Active = "Active",
    Archived = "Archived",
}

export enum SiteTotalType {
    New = "New",
    Draft = "Draft",
    Active = "Active",
    Archived = "Archived",
    AllStatus = "AllStatus",
}

export class SiteTotalTypeITotal implements ISiteTotalTypeITotal {
    type?: SiteTotalType;
    value?: number | undefined;

    constructor(data?: ISiteTotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SiteTotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new SiteTotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ISiteTotalTypeITotal {
    type?: SiteTotalType;
    value?: number | undefined;
}

export enum SoilDescriptionType {
    Clay = "Clay",
    Sand = "Sand",
    Topsoil = "Topsoil",
    Granular = "Granular",
    MixedSiltyClayWithTraceGravelSand = "MixedSiltyClayWithTraceGravelSand",
    TopsoilwithTraceGravelSand = "TopsoilwithTraceGravelSand",
    SandySilt = "SandySilt",
    Shale = "Shale",
    MixedClaySiltsShale = "MixedClaySiltsShale",
    BrickBlockRubble = "BrickBlockRubble",
    CleanFill = "CleanFill",
    AsphaltMix = "AsphaltMix",
}

export enum SoilQualityType {
    OReg153Table1 = "OReg153Table1",
    OReg153Table2 = "OReg153Table2",
    OReg153Table3 = "OReg153Table3",
    OReg153Table4 = "OReg153Table4",
    OReg153Table5 = "OReg153Table5",
    OReg153Table6 = "OReg153Table6",
    OReg153Table7 = "OReg153Table7",
    OReg153Table8 = "OReg153Table8",
    OReg153Table9 = "OReg153Table9",
    OReg406Table11 = "OReg406Table11",
    OReg406Table21 = "OReg406Table21",
    OReg406Table31 = "OReg406Table31",
    OReg406Table41 = "OReg406Table41",
    OReg406Table51 = "OReg406Table51",
    OReg406Table61 = "OReg406Table61",
    OReg406Table71 = "OReg406Table71",
    OReg406Table81 = "OReg406Table81",
    OReg406Table91 = "OReg406Table91",
    AllSoilTypes = "AllSoilTypes",
    NonHazardousSoil = "NonHazardousSoil",
}

export class SortBy implements ISortBy {
    property?: string | undefined;
    descendingOrder?: boolean | undefined;

    constructor(data?: ISortBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.descendingOrder = _data["descendingOrder"];
        }
    }

    static fromJS(data: any): SortBy {
        data = typeof data === 'object' ? data : {};
        let result = new SortBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["descendingOrder"] = this.descendingOrder;
        return data;
    }
}

export interface ISortBy {
    property?: string | undefined;
    descendingOrder?: boolean | undefined;
}

export class SourceSiteAttachmentViewModel implements ISourceSiteAttachmentViewModel {
    uniqueId?: string;
    isLink?: boolean;
    fileName?: string | undefined;
    fileSize?: number;
    link?: string | undefined;

    constructor(data?: ISourceSiteAttachmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.isLink = _data["isLink"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): SourceSiteAttachmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteAttachmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["isLink"] = this.isLink;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["link"] = this.link;
        return data;
    }
}

export interface ISourceSiteAttachmentViewModel {
    uniqueId?: string;
    isLink?: boolean;
    fileName?: string | undefined;
    fileSize?: number;
    link?: string | undefined;
}

export class SourceSiteDashboardViewModel implements ISourceSiteDashboardViewModel {
    uniqueId?: string;
    name?: string | undefined;
    batchCount?: number | undefined;
    transferredLoads?: number | undefined;
    transferredWeight?: number | undefined;

    constructor(data?: ISourceSiteDashboardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.batchCount = _data["batchCount"];
            this.transferredLoads = _data["transferredLoads"];
            this.transferredWeight = _data["transferredWeight"];
        }
    }

    static fromJS(data: any): SourceSiteDashboardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteDashboardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["batchCount"] = this.batchCount;
        data["transferredLoads"] = this.transferredLoads;
        data["transferredWeight"] = this.transferredWeight;
        return data;
    }
}

export interface ISourceSiteDashboardViewModel {
    uniqueId?: string;
    name?: string | undefined;
    batchCount?: number | undefined;
    transferredLoads?: number | undefined;
    transferredWeight?: number | undefined;
}

export class SourceSiteESVRSearchQuery implements ISourceSiteESVRSearchQuery {
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: SortBy[] | undefined;
    filterBy?: FilterBy[] | undefined;

    constructor(data?: ISourceSiteESVRSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortBy.fromJS(item));
            }
            if (Array.isArray(_data["filterBy"])) {
                this.filterBy = [] as any;
                for (let item of _data["filterBy"])
                    this.filterBy!.push(FilterBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SourceSiteESVRSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteESVRSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        if (Array.isArray(this.filterBy)) {
            data["filterBy"] = [];
            for (let item of this.filterBy)
                data["filterBy"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISourceSiteESVRSearchQuery {
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: SortBy[] | undefined;
    filterBy?: FilterBy[] | undefined;
}

export class SourceSiteQPSearchViewModel implements ISourceSiteQPSearchViewModel {
    sourceSiteUniqueId?: string;
    sourceSiteName?: string | undefined;
    sourceSiteStatus?: SiteStatus;
    batchCount?: number | undefined;
    qpBatchCount?: number | undefined;
    uniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    qpUniqueId?: string;
    qpName?: string | undefined;
    contactEmail?: string | undefined;
    companyName?: string | undefined;

    constructor(data?: ISourceSiteQPSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceSiteUniqueId = _data["sourceSiteUniqueId"];
            this.sourceSiteName = _data["sourceSiteName"];
            this.sourceSiteStatus = _data["sourceSiteStatus"];
            this.batchCount = _data["batchCount"];
            this.qpBatchCount = _data["qpBatchCount"];
            this.uniqueId = _data["uniqueId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.qpUniqueId = _data["qpUniqueId"];
            this.qpName = _data["qpName"];
            this.contactEmail = _data["contactEmail"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): SourceSiteQPSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteQPSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceSiteUniqueId"] = this.sourceSiteUniqueId;
        data["sourceSiteName"] = this.sourceSiteName;
        data["sourceSiteStatus"] = this.sourceSiteStatus;
        data["batchCount"] = this.batchCount;
        data["qpBatchCount"] = this.qpBatchCount;
        data["uniqueId"] = this.uniqueId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["qpUniqueId"] = this.qpUniqueId;
        data["qpName"] = this.qpName;
        data["contactEmail"] = this.contactEmail;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ISourceSiteQPSearchViewModel {
    sourceSiteUniqueId?: string;
    sourceSiteName?: string | undefined;
    sourceSiteStatus?: SiteStatus;
    batchCount?: number | undefined;
    qpBatchCount?: number | undefined;
    uniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    qpUniqueId?: string;
    qpName?: string | undefined;
    contactEmail?: string | undefined;
    companyName?: string | undefined;
}

export class SourceSiteQPSearchViewModelTotalTypePagedResultResponse implements ISourceSiteQPSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: SourceSiteQPSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: ISourceSiteQPSearchViewModelTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(TotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(SourceSiteQPSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): SourceSiteQPSearchViewModelTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteQPSearchViewModelTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface ISourceSiteQPSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: SourceSiteQPSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class SourceSiteSearchQuery implements ISourceSiteSearchQuery {
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: SortBy[] | undefined;
    filterBy?: FilterBy[] | undefined;

    constructor(data?: ISourceSiteSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["sortBy"])) {
                this.sortBy = [] as any;
                for (let item of _data["sortBy"])
                    this.sortBy!.push(SortBy.fromJS(item));
            }
            if (Array.isArray(_data["filterBy"])) {
                this.filterBy = [] as any;
                for (let item of _data["filterBy"])
                    this.filterBy!.push(FilterBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SourceSiteSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.sortBy)) {
            data["sortBy"] = [];
            for (let item of this.sortBy)
                data["sortBy"].push(item.toJSON());
        }
        if (Array.isArray(this.filterBy)) {
            data["filterBy"] = [];
            for (let item of this.filterBy)
                data["filterBy"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISourceSiteSearchQuery {
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: SortBy[] | undefined;
    filterBy?: FilterBy[] | undefined;
}

export class SourceSiteSearchViewModel implements ISourceSiteSearchViewModel {
    uniqueId?: string;
    name?: string | undefined;
    status?: SiteStatus;
    createdDate?: Date;
    modifiedDate?: Date;
    batchCount?: number | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    companyContactName?: string | undefined;
    companyContactEmail?: string | undefined;
    companyPhoneNumber?: string | undefined;
    companyExtension?: string | undefined;
    line1?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    admins?: string[] | undefined;
    qpLegalEntities?: string[] | undefined;

    constructor(data?: ISourceSiteSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.batchCount = _data["batchCount"];
            this.companyName = _data["companyName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.phoneNumber = _data["phoneNumber"];
            this.extension = _data["extension"];
            this.companyContactName = _data["companyContactName"];
            this.companyContactEmail = _data["companyContactEmail"];
            this.companyPhoneNumber = _data["companyPhoneNumber"];
            this.companyExtension = _data["companyExtension"];
            this.line1 = _data["line1"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.provinceCode = _data["provinceCode"];
            if (Array.isArray(_data["admins"])) {
                this.admins = [] as any;
                for (let item of _data["admins"])
                    this.admins!.push(item);
            }
            if (Array.isArray(_data["qpLegalEntities"])) {
                this.qpLegalEntities = [] as any;
                for (let item of _data["qpLegalEntities"])
                    this.qpLegalEntities!.push(item);
            }
        }
    }

    static fromJS(data: any): SourceSiteSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["batchCount"] = this.batchCount;
        data["companyName"] = this.companyName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["phoneNumber"] = this.phoneNumber;
        data["extension"] = this.extension;
        data["companyContactName"] = this.companyContactName;
        data["companyContactEmail"] = this.companyContactEmail;
        data["companyPhoneNumber"] = this.companyPhoneNumber;
        data["companyExtension"] = this.companyExtension;
        data["line1"] = this.line1;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["provinceCode"] = this.provinceCode;
        if (Array.isArray(this.admins)) {
            data["admins"] = [];
            for (let item of this.admins)
                data["admins"].push(item);
        }
        if (Array.isArray(this.qpLegalEntities)) {
            data["qpLegalEntities"] = [];
            for (let item of this.qpLegalEntities)
                data["qpLegalEntities"].push(item);
        }
        return data;
    }
}

export interface ISourceSiteSearchViewModel {
    uniqueId?: string;
    name?: string | undefined;
    status?: SiteStatus;
    createdDate?: Date;
    modifiedDate?: Date;
    batchCount?: number | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    phoneNumber?: string | undefined;
    extension?: string | undefined;
    companyContactName?: string | undefined;
    companyContactEmail?: string | undefined;
    companyPhoneNumber?: string | undefined;
    companyExtension?: string | undefined;
    line1?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    admins?: string[] | undefined;
    qpLegalEntities?: string[] | undefined;
}

export class SourceSiteSearchViewModelSiteTotalTypePagedResultResponse implements ISourceSiteSearchViewModelSiteTotalTypePagedResultResponse {
    totals?: SiteTotalTypeITotal[] | undefined;
    records?: SourceSiteSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: ISourceSiteSearchViewModelSiteTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(SiteTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(SourceSiteSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): SourceSiteSearchViewModelSiteTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteSearchViewModelSiteTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface ISourceSiteSearchViewModelSiteTotalTypePagedResultResponse {
    totals?: SiteTotalTypeITotal[] | undefined;
    records?: SourceSiteSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export enum SourceSiteType {
    IndustrialCommercial = "IndustrialCommercial",
    Residential = "Residential",
    Agricultural = "Agricultural",
    Parkland = "Parkland",
    Community = "Community",
    Other = "Other",
}

export class SourceSiteUserSearchViewModel implements ISourceSiteUserSearchViewModel {
    uniqueId?: string;
    sourceSiteUniqueId?: string;
    userUniqueId?: string;
    userName?: string | undefined;
    userStatus?: CleanFillUserStatus;
    userEmail?: string | undefined;
    userPhoneNumber?: string | undefined;
    siteUserRoleName?: string | undefined;
    sourceSiteName?: string | undefined;
    sourceSiteContactEmail?: string | undefined;
    sourceSiteStatus?: SiteStatus;
    batchCount?: number | undefined;
    userBatchCount?: number | undefined;

    constructor(data?: ISourceSiteUserSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.sourceSiteUniqueId = _data["sourceSiteUniqueId"];
            this.userUniqueId = _data["userUniqueId"];
            this.userName = _data["userName"];
            this.userStatus = _data["userStatus"];
            this.userEmail = _data["userEmail"];
            this.userPhoneNumber = _data["userPhoneNumber"];
            this.siteUserRoleName = _data["siteUserRoleName"];
            this.sourceSiteName = _data["sourceSiteName"];
            this.sourceSiteContactEmail = _data["sourceSiteContactEmail"];
            this.sourceSiteStatus = _data["sourceSiteStatus"];
            this.batchCount = _data["batchCount"];
            this.userBatchCount = _data["userBatchCount"];
        }
    }

    static fromJS(data: any): SourceSiteUserSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteUserSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["sourceSiteUniqueId"] = this.sourceSiteUniqueId;
        data["userUniqueId"] = this.userUniqueId;
        data["userName"] = this.userName;
        data["userStatus"] = this.userStatus;
        data["userEmail"] = this.userEmail;
        data["userPhoneNumber"] = this.userPhoneNumber;
        data["siteUserRoleName"] = this.siteUserRoleName;
        data["sourceSiteName"] = this.sourceSiteName;
        data["sourceSiteContactEmail"] = this.sourceSiteContactEmail;
        data["sourceSiteStatus"] = this.sourceSiteStatus;
        data["batchCount"] = this.batchCount;
        data["userBatchCount"] = this.userBatchCount;
        return data;
    }
}

export interface ISourceSiteUserSearchViewModel {
    uniqueId?: string;
    sourceSiteUniqueId?: string;
    userUniqueId?: string;
    userName?: string | undefined;
    userStatus?: CleanFillUserStatus;
    userEmail?: string | undefined;
    userPhoneNumber?: string | undefined;
    siteUserRoleName?: string | undefined;
    sourceSiteName?: string | undefined;
    sourceSiteContactEmail?: string | undefined;
    sourceSiteStatus?: SiteStatus;
    batchCount?: number | undefined;
    userBatchCount?: number | undefined;
}

export class SourceSiteUserSearchViewModelTotalTypePagedResultResponse implements ISourceSiteUserSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: SourceSiteUserSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: ISourceSiteUserSearchViewModelTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(TotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(SourceSiteUserSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): SourceSiteUserSearchViewModelTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteUserSearchViewModelTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface ISourceSiteUserSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: SourceSiteUserSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class SourceSiteViewModel implements ISourceSiteViewModel {
    uniqueId?: string;
    address?: AddressViewModel | undefined;
    contact?: ContactViewModel | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdByLegalEntity?: string | undefined;
    batchCount?: BatchTotalTypeITotal[] | undefined;
    name?: string | undefined;
    municipalityName?: string | undefined;
    status?: SiteStatus;

    constructor(data?: ISourceSiteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.address = _data["address"] ? AddressViewModel.fromJS(_data["address"]) : <any>undefined;
            this.contact = _data["contact"] ? ContactViewModel.fromJS(_data["contact"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdByLegalEntity = _data["createdByLegalEntity"];
            if (Array.isArray(_data["batchCount"])) {
                this.batchCount = [] as any;
                for (let item of _data["batchCount"])
                    this.batchCount!.push(BatchTotalTypeITotal.fromJS(item));
            }
            this.name = _data["name"];
            this.municipalityName = _data["municipalityName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SourceSiteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SourceSiteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdByLegalEntity"] = this.createdByLegalEntity;
        if (Array.isArray(this.batchCount)) {
            data["batchCount"] = [];
            for (let item of this.batchCount)
                data["batchCount"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["municipalityName"] = this.municipalityName;
        data["status"] = this.status;
        return data;
    }
}

export interface ISourceSiteViewModel {
    uniqueId?: string;
    address?: AddressViewModel | undefined;
    contact?: ContactViewModel | undefined;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    createdBy?: string | undefined;
    createdByLegalEntity?: string | undefined;
    batchCount?: BatchTotalTypeITotal[] | undefined;
    name?: string | undefined;
    municipalityName?: string | undefined;
    status?: SiteStatus;
}

export enum SourceType {
    Stockpile = "Stockpile",
    Excavation = "Excavation",
    DrillSpoils = "DrillSpoils",
    Other = "Other",
}

export class TermsAndConditionsViewModel implements ITermsAndConditionsViewModel {
    description?: string | undefined;

    constructor(data?: ITermsAndConditionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TermsAndConditionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface ITermsAndConditionsViewModel {
    description?: string | undefined;
}

export class TermsAndConditionsViewModelResultResponse implements ITermsAndConditionsViewModelResultResponse {
    result?: TermsAndConditionsViewModel | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: ITermsAndConditionsViewModelResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? TermsAndConditionsViewModel.fromJS(_data["result"]) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): TermsAndConditionsViewModelResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionsViewModelResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface ITermsAndConditionsViewModelResultResponse {
    result?: TermsAndConditionsViewModel | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export enum TotalType {
    Active = "Active",
    Inactive = "Inactive",
    Pending = "Pending",
    Deleted = "Deleted",
    Total = "Total",
}

export class TotalTypeITotal implements ITotalTypeITotal {
    type?: TotalType;
    value?: number | undefined;

    constructor(data?: ITotalTypeITotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TotalTypeITotal {
        data = typeof data === 'object' ? data : {};
        let result = new TotalTypeITotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}

export interface ITotalTypeITotal {
    type?: TotalType;
    value?: number | undefined;
}

export class TrainingMaterialViewModel implements ITrainingMaterialViewModel {
    uniqueId?: string;
    name?: string | undefined;
    description?: string | undefined;
    filePathURL?: string | undefined;

    constructor(data?: ITrainingMaterialViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.filePathURL = _data["filePathURL"];
        }
    }

    static fromJS(data: any): TrainingMaterialViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingMaterialViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["filePathURL"] = this.filePathURL;
        return data;
    }
}

export interface ITrainingMaterialViewModel {
    uniqueId?: string;
    name?: string | undefined;
    description?: string | undefined;
    filePathURL?: string | undefined;
}

export class TruckDownloadQuery implements ITruckDownloadQuery {
    uniqueIds?: string[] | undefined;

    constructor(data?: ITruckDownloadQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniqueIds"])) {
                this.uniqueIds = [] as any;
                for (let item of _data["uniqueIds"])
                    this.uniqueIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TruckDownloadQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TruckDownloadQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniqueIds)) {
            data["uniqueIds"] = [];
            for (let item of this.uniqueIds)
                data["uniqueIds"].push(item);
        }
        return data;
    }
}

export interface ITruckDownloadQuery {
    uniqueIds?: string[] | undefined;
}

export class TruckSearchViewModel implements ITruckSearchViewModel {
    uniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType;
    haulerName?: string | undefined;
    driverName?: string | undefined;
    barcode?: string | undefined;

    constructor(data?: ITruckSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.truckNumber = _data["truckNumber"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.vehicleWeight = _data["vehicleWeight"];
            this.vehicleType = _data["vehicleType"];
            this.haulerName = _data["haulerName"];
            this.driverName = _data["driverName"];
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): TruckSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TruckSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["truckNumber"] = this.truckNumber;
        data["vehiclePlate"] = this.vehiclePlate;
        data["vehicleWeight"] = this.vehicleWeight;
        data["vehicleType"] = this.vehicleType;
        data["haulerName"] = this.haulerName;
        data["driverName"] = this.driverName;
        data["barcode"] = this.barcode;
        return data;
    }
}

export interface ITruckSearchViewModel {
    uniqueId?: string;
    createdDate?: Date | undefined;
    modifiedDate?: Date | undefined;
    truckNumber?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType;
    haulerName?: string | undefined;
    driverName?: string | undefined;
    barcode?: string | undefined;
}

export class TruckSearchViewModelTotalTypePagedResultResponse implements ITruckSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: TruckSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: ITruckSearchViewModelTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(TotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(TruckSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): TruckSearchViewModelTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TruckSearchViewModelTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface ITruckSearchViewModelTotalTypePagedResultResponse {
    totals?: TotalTypeITotal[] | undefined;
    records?: TruckSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class TruckViewModel implements ITruckViewModel {
    notifiedESVRId?: number | undefined;
    uniqueId?: string;
    haulerUniqueId?: string;
    truckNumber?: string | undefined;
    driverName?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType | undefined;
    barcode?: string | undefined;

    constructor(data?: ITruckViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notifiedESVRId = _data["notifiedESVRId"];
            this.uniqueId = _data["uniqueId"];
            this.haulerUniqueId = _data["haulerUniqueId"];
            this.truckNumber = _data["truckNumber"];
            this.driverName = _data["driverName"];
            this.vehiclePlate = _data["vehiclePlate"];
            this.vehicleWeight = _data["vehicleWeight"];
            this.vehicleType = _data["vehicleType"];
            this.barcode = _data["barcode"];
        }
    }

    static fromJS(data: any): TruckViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TruckViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifiedESVRId"] = this.notifiedESVRId;
        data["uniqueId"] = this.uniqueId;
        data["haulerUniqueId"] = this.haulerUniqueId;
        data["truckNumber"] = this.truckNumber;
        data["driverName"] = this.driverName;
        data["vehiclePlate"] = this.vehiclePlate;
        data["vehicleWeight"] = this.vehicleWeight;
        data["vehicleType"] = this.vehicleType;
        data["barcode"] = this.barcode;
        return data;
    }
}

export interface ITruckViewModel {
    notifiedESVRId?: number | undefined;
    uniqueId?: string;
    haulerUniqueId?: string;
    truckNumber?: string | undefined;
    driverName?: string | undefined;
    vehiclePlate?: string | undefined;
    vehicleWeight?: number | undefined;
    vehicleType?: VehicleType | undefined;
    barcode?: string | undefined;
}

export class UpdateBatchStatusCommand implements IUpdateBatchStatusCommand {
    uniqueId?: string;
    status?: BatchStatus;

    constructor(data?: IUpdateBatchStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateBatchStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBatchStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateBatchStatusCommand {
    uniqueId?: string;
    status?: BatchStatus;
}

export class UpdateInvoiceStatusCommand implements IUpdateInvoiceStatusCommand {
    uniqueId?: string;
    status?: InvoiceStatus;

    constructor(data?: IUpdateInvoiceStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateInvoiceStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateInvoiceStatusCommand {
    uniqueId?: string;
    status?: InvoiceStatus;
}

export class UserGeneralInfoViewModel implements IUserGeneralInfoViewModel {
    uniqueId?: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    jobTitle?: string | undefined;
    initials?: string | undefined;
    lastName?: string | undefined;
    username?: string | undefined;
    phoneNumber?: string | undefined;
    status?: CleanFillUserStatus;
    readonly fullName?: string | undefined;

    constructor(data?: IUserGeneralInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.jobTitle = _data["jobTitle"];
            this.initials = _data["initials"];
            this.lastName = _data["lastName"];
            this.username = _data["username"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserGeneralInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserGeneralInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["jobTitle"] = this.jobTitle;
        data["initials"] = this.initials;
        data["lastName"] = this.lastName;
        data["username"] = this.username;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IUserGeneralInfoViewModel {
    uniqueId?: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    jobTitle?: string | undefined;
    initials?: string | undefined;
    lastName?: string | undefined;
    username?: string | undefined;
    phoneNumber?: string | undefined;
    status?: CleanFillUserStatus;
    fullName?: string | undefined;
}

export enum UserInvitationGroup {
    User = "User",
    Admin = "Admin",
}

export class UserInviteViewModel implements IUserInviteViewModel {
    uniqueId?: string;
    userUniqueId?: string;
    status?: EmailInviteStatus;

    constructor(data?: IUserInviteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.userUniqueId = _data["userUniqueId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserInviteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserInviteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["userUniqueId"] = this.userUniqueId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUserInviteViewModel {
    uniqueId?: string;
    userUniqueId?: string;
    status?: EmailInviteStatus;
}

export class UserSearchViewModel implements IUserSearchViewModel {
    uniqueId?: string;
    fullName?: string | undefined;
    isApproved?: boolean;
    roles?: string | undefined;
    jobTitle?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    batchesAssigned?: number;
    sitesAssigned?: string | undefined;
    createdDate?: Date;
    status?: CleanFillUserStatus;

    constructor(data?: IUserSearchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.fullName = _data["fullName"];
            this.isApproved = _data["isApproved"];
            this.roles = _data["roles"];
            this.jobTitle = _data["jobTitle"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.batchesAssigned = _data["batchesAssigned"];
            this.sitesAssigned = _data["sitesAssigned"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserSearchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["fullName"] = this.fullName;
        data["isApproved"] = this.isApproved;
        data["roles"] = this.roles;
        data["jobTitle"] = this.jobTitle;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["batchesAssigned"] = this.batchesAssigned;
        data["sitesAssigned"] = this.sitesAssigned;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IUserSearchViewModel {
    uniqueId?: string;
    fullName?: string | undefined;
    isApproved?: boolean;
    roles?: string | undefined;
    jobTitle?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    batchesAssigned?: number;
    sitesAssigned?: string | undefined;
    createdDate?: Date;
    status?: CleanFillUserStatus;
}

export class UserSearchViewModelCleanFillUserTotalTypePagedResultResponse implements IUserSearchViewModelCleanFillUserTotalTypePagedResultResponse {
    totals?: CleanFillUserTotalTypeITotal[] | undefined;
    records?: UserSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;

    constructor(data?: IUserSearchViewModelCleanFillUserTotalTypePagedResultResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["totals"])) {
                this.totals = [] as any;
                for (let item of _data["totals"])
                    this.totals!.push(CleanFillUserTotalTypeITotal.fromJS(item));
            }
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(UserSearchViewModel.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): UserSearchViewModelCleanFillUserTotalTypePagedResultResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserSearchViewModelCleanFillUserTotalTypePagedResultResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.totals)) {
            data["totals"] = [];
            for (let item of this.totals)
                data["totals"].push(item.toJSON());
        }
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IUserSearchViewModelCleanFillUserTotalTypePagedResultResponse {
    totals?: CleanFillUserTotalTypeITotal[] | undefined;
    records?: UserSearchViewModel[] | undefined;
    errorMessage?: string | undefined;
    isSuccess?: boolean;
}

export class UserViewModel implements IUserViewModel {
    uniqueId?: string;
    initials?: string | undefined;
    readonly fullName?: string | undefined;
    createdDate?: Date;
    userGroup?: UserInvitationGroup;
    cleanFillUserGroups?: CleanFillUserGroupViewModel[] | undefined;
    cleanFillUserPolicies?: CleanFillUserPolicyViewModel[] | undefined;
    legalEntityUniqueId?: string;
    isTermAccepted?: boolean;
    isApproved?: boolean;
    oId?: string | undefined;
    idp?: string | undefined;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    jobTitle?: string | undefined;
    lastName?: string | undefined;
    sid?: string | undefined;
    username?: string | undefined;
    phoneNumber?: string | undefined;
    status?: CleanFillUserStatus;

    constructor(data?: IUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.initials = _data["initials"];
            (<any>this).fullName = _data["fullName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.userGroup = _data["userGroup"];
            if (Array.isArray(_data["cleanFillUserGroups"])) {
                this.cleanFillUserGroups = [] as any;
                for (let item of _data["cleanFillUserGroups"])
                    this.cleanFillUserGroups!.push(CleanFillUserGroupViewModel.fromJS(item));
            }
            if (Array.isArray(_data["cleanFillUserPolicies"])) {
                this.cleanFillUserPolicies = [] as any;
                for (let item of _data["cleanFillUserPolicies"])
                    this.cleanFillUserPolicies!.push(CleanFillUserPolicyViewModel.fromJS(item));
            }
            this.legalEntityUniqueId = _data["legalEntityUniqueId"];
            this.isTermAccepted = _data["isTermAccepted"];
            this.isApproved = _data["isApproved"];
            this.oId = _data["oId"];
            this.idp = _data["idp"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.jobTitle = _data["jobTitle"];
            this.lastName = _data["lastName"];
            this.sid = _data["sid"];
            this.username = _data["username"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["initials"] = this.initials;
        data["fullName"] = this.fullName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["userGroup"] = this.userGroup;
        if (Array.isArray(this.cleanFillUserGroups)) {
            data["cleanFillUserGroups"] = [];
            for (let item of this.cleanFillUserGroups)
                data["cleanFillUserGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.cleanFillUserPolicies)) {
            data["cleanFillUserPolicies"] = [];
            for (let item of this.cleanFillUserPolicies)
                data["cleanFillUserPolicies"].push(item.toJSON());
        }
        data["legalEntityUniqueId"] = this.legalEntityUniqueId;
        data["isTermAccepted"] = this.isTermAccepted;
        data["isApproved"] = this.isApproved;
        data["oId"] = this.oId;
        data["idp"] = this.idp;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["jobTitle"] = this.jobTitle;
        data["lastName"] = this.lastName;
        data["sid"] = this.sid;
        data["username"] = this.username;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        return data;
    }
}

export interface IUserViewModel {
    uniqueId?: string;
    initials?: string | undefined;
    fullName?: string | undefined;
    createdDate?: Date;
    userGroup?: UserInvitationGroup;
    cleanFillUserGroups?: CleanFillUserGroupViewModel[] | undefined;
    cleanFillUserPolicies?: CleanFillUserPolicyViewModel[] | undefined;
    legalEntityUniqueId?: string;
    isTermAccepted?: boolean;
    isApproved?: boolean;
    oId?: string | undefined;
    idp?: string | undefined;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    jobTitle?: string | undefined;
    lastName?: string | undefined;
    sid?: string | undefined;
    username?: string | undefined;
    phoneNumber?: string | undefined;
    status?: CleanFillUserStatus;
}

export enum VehicleType {
    Triaxle = "Triaxle",
    TriaxleAndPup = "TriaxleAndPup",
    Trailer = "Trailer",
    TrailerLiveBottom = "TrailerLiveBottom",
}

export enum VisibilityToClients {
    Public = "Public",
    Private = "Private",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}